var _mask, _mask2, _mask3, _mask4, _mask5, _mask6, _mask7, _mask8, _mask9, _mask10, _mask11, _mask12, _mask13, _mask14, _mask15, _mask16, _mask17, _mask18, _mask19, _mask20, _mask21, _mask22, _mask23, _mask24, _mask25, _mask26, _mask27, _mask28, _mask29, _mask30, _mask31, _mask32, _mask33, _mask34, _mask35, _mask36, _mask37, _mask38, _mask39, _mask40, _mask41, _mask42, _mask43, _mask44, _mask45, _mask46, _mask47, _mask48, _mask49, _mask50, _mask51, _mask52, _mask53, _mask54, _mask55, _mask56, _mask57, _mask58, _mask59, _mask60, _mask61, _mask62, _mask63, _mask64, _mask65, _mask66, _mask67, _mask68, _mask69, _mask70, _mask71, _mask72, _mask73, _mask74, _mask75, _mask76, _mask77, _mask78, _mask79, _mask80, _mask81, _mask82, _mask83, _mask84, _mask85, _mask86, _mask87, _mask88, _mask89, _mask90, _mask91, _mask92, _mask93, _mask94, _mask95, _mask96, _mask97, _mask98, _mask99, _mask100, _mask101, _mask102, _mask103, _mask104, _mask105, _mask106, _mask107, _mask108, _mask109, _mask110, _mask111, _mask112, _mask113, _mask114, _mask115, _mask116, _mask117, _mask118, _mask119, _mask120, _mask121, _mask122, _mask123, _mask124, _mask125, _mask126, _mask127, _mask128, _mask129, _mask130, _mask131, _mask132, _mask133, _mask134, _mask135, _mask136, _mask137, _mask138, _mask139, _mask140, _mask141, _mask142, _mask143, _mask144, _mask145, _mask146, _mask147, _mask148, _mask149, _mask150, _mask151, _mask152, _mask153, _mask154, _mask155, _mask156, _mask157, _mask158, _mask159, _mask160, _mask161, _mask162, _mask163, _mask164, _mask165, _mask166, _mask167, _mask168, _mask169, _mask170, _mask171, _mask172, _mask173, _mask174, _mask175, _mask176, _mask177, _mask178, _mask179, _mask180, _mask181, _mask182, _mask183, _mask184, _mask185, _mask186, _mask187, _mask188, _mask189, _mask190, _mask191, _mask192, _mask193, _mask194, _mask195, _mask196, _mask197, _mask198, _mask199, _mask200, _mask201, _mask202, _mask203, _mask204, _mask205, _mask206, _mask207, _mask208, _mask209, _mask210, _mask211, _mask212, _mask213, _mask214, _mask215, _mask216, _mask217, _mask218, _mask219, _mask220, _mask221, _mask222, _mask223, _mask224, _mask225, _mask226, _mask227, _mask228, _mask229, _mask230, _mask231, _mask232, _mask233, _mask234, _mask235, _mask236, _mask237, _mask238, _mask239, _mask240, _mask241, _mask242, _mask243, _mask244, _mask245, _mask246, _mask247, _mask248, _mask249, _mask250, _mask251, _mask252, _mask253, _mask254, _mask255, _mask256, _mask257, _mask258, _mask259, _mask260, _mask261, _mask262, _mask263, _mask264, _mask265, _mask266, _mask267, _mask268, _mask269, _mask270, _mask271, _mask272, _mask273, _mask274, _mask275, _mask276, _mask277, _mask278, _mask279, _mask280, _mask281, _mask282, _mask283, _mask284, _mask285, _mask286, _mask287, _mask288, _mask289, _mask290, _mask291, _mask292, _mask293, _mask294, _mask295, _mask296, _mask297, _mask298, _mask299, _mask300, _mask301, _mask302, _mask303, _mask304, _mask305, _mask306, _mask307, _mask308, _mask309, _mask310, _mask311, _mask312, _mask313, _mask314, _mask315, _mask316, _mask317, _mask318, _mask319, _mask320, _mask321, _mask322, _mask323, _mask324, _mask325, _mask326, _mask327, _mask328, _mask329, _mask330, _mask331, _mask332, _mask333, _mask334, _mask335, _mask336, _mask337, _mask338, _mask339, _mask340, _mask341, _mask342, _mask343, _mask344, _mask345, _mask346, _mask347, _mask348, _mask349, _mask350, _mask351, _mask352, _mask353, _mask354, _mask355, _mask356, _mask357, _mask358, _mask359, _mask360, _mask361, _mask362, _mask363, _mask364, _mask365, _mask366, _mask367, _mask368, _mask369, _mask370, _mask371, _mask372, _mask373, _filter, _filter2, _filter3, _filter4, _filter5, _filter6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTbExcelUpload(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465, _ref466, _ref467, _ref468, _ref469, _ref470, _ref471, _ref472, _ref473, _ref474, _ref475, _ref476, _ref477, _ref478, _ref479, _ref480, _ref481, _ref482, _ref483, _ref484, _ref485, _ref486, _ref487, _ref488, _ref489, _ref490, _ref491, _ref492, _ref493, _ref494, _ref495, _ref496, _ref497, _ref498, _ref499, _ref500, _ref501, _ref502, _ref503, _ref504, _ref505, _ref506, _ref507, _ref508, _ref509, _ref510, _ref511, _ref512, _ref513, _ref514, _ref515, _ref516, _ref517, _ref518, _ref519, _ref520, _ref521, _ref522, _ref523, _ref524, _ref525, _ref526, _ref527, _ref528, _ref529, _ref530, _ref531, _ref532, _ref533, _ref534, _ref535, _ref536, _ref537, _ref538, _ref539, _ref540, _ref541, _ref542, _ref543, _ref544, _ref545, _ref546, _ref547, _ref548, _ref549, _ref550, _ref551, _ref552, _ref553, _ref554, _ref555, _ref556, _ref557, _ref558, _ref559, _ref560, _ref561, _ref562, _ref563, _ref564, _ref565, _ref566, _ref567, _ref568, _ref569, _ref570, _ref571, _ref572, _ref573, _ref574, _ref575, _ref576, _ref577, _ref578, _ref579, _ref580, _ref581, _ref582, _ref583, _ref584, _ref585, _ref586, _ref587, _ref588, _ref589, _ref590, _ref591, _ref592, _ref593, _ref594, _ref595, _ref596, _ref597, _ref598, _ref599, _ref600, _ref601, _ref602, _ref603, _ref604, _ref605, _ref606, _ref607, _ref608, _ref609, _ref610, _ref611, _ref612, _ref613, _ref614, _ref615, _ref616, _ref617, _ref618, _ref619, _ref620, _ref621, _ref622, _ref623, _ref624, _ref625, _ref626, _ref627, _ref628, _ref629, _ref630, _ref631, _ref632, _ref633, _ref634, _ref635, _ref636, _ref637, _ref638, _ref639, _ref640, _ref641, _ref642, _ref643, _ref644, _ref645, _ref646, _ref647, _ref648, _ref649, _ref650, _ref651, _ref652, _ref653, _ref654, _ref655, _ref656, _ref657, _ref658, _ref659, _ref660, _ref661, _ref662, _ref663, _ref664, _ref665, _ref666, _ref667, _ref668, _ref669, _ref670, _ref671, _ref672, _ref673, _ref674, _ref675, _ref676, _ref677, _ref678, _ref679, _ref680, _ref681, _ref682, _ref683, _ref684, _ref685, _ref686, _ref687, _ref688, _ref689, _ref690, _ref691, _ref692, _ref693, _ref694, _ref695, _ref696, _ref697, _ref698, _ref699, _ref700, _ref701, _ref702, _ref703, _ref704, _ref705, _ref706, _ref707, _ref708, _ref709, _ref710, _ref711, _ref712, _ref713, _ref714, _ref715, _ref716, _ref717, _ref718, _ref719, _ref720, _ref721, _ref722, _ref723, _ref724, _ref725, _ref726, _ref727, _ref728, _ref729, _ref730, _ref731, _ref732, _ref733, _ref734, _ref735, _ref736, _ref737, _ref738, _ref739, _ref740, _ref741, _ref742, _ref743, _ref744, _ref745, _ref746, _ref747, _ref748, _ref749, _ref750, _ref751, _ref752, _ref753, _ref754, _ref755, _ref756, _ref757, _ref758, _ref759, _ref760, _ref761, _ref762, _ref763, _ref764, _ref765, _ref766, _ref767, _ref768, _ref769, _ref770, _ref771, _ref772, _ref773, _ref774, _ref775;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 300,
    viewBox: "0 0 310 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 300,
    rx: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: 66.7257,
    width: 168.858,
    height: 170.32,
    rx: 5.86533,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17113_221003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 9.98428,
    transform: "translate(-24.001 66.7257)",
    fill: "#E4F2E6",
    style: (_ref2 = {
      fill: "#E4F2E6"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8941 0.9490 0.9020)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_17113_221003)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.001 76.71H350.41V86.1396H-24.001V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-24.001 76.71H350.41V86.1396H-24.001V76.71Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 76.71H12.4801V86.1396H-15.6807V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 76.71H12.4801V86.1396H-15.6807V76.71Z",
    fill: "#FAFAFA",
    style: (_ref3 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 86.1396H-15.4033V76.71H-15.6807H-15.958V86.1396H-15.6807Z",
    fill: "url(#paint0_linear_17113_221003)",
    style: {},
    mask: "url(#path-9-inside-2_17113_221003)"
  }), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 76.71H40.6413V86.1396H12.4805V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 76.71H40.6413V86.1396H12.4805V76.71Z",
    fill: "#FAFAFA",
    style: (_ref4 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 86.1396H12.7578V76.71H12.4805H12.2031V86.1396H12.4805Z",
    fill: "url(#paint1_linear_17113_221003)",
    style: {},
    mask: "url(#path-11-inside-3_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6823 82.71V79.992H26.6375C26.829 79.992 26.9869 80.0231 27.1112 80.0852C27.238 80.1447 27.3325 80.2276 27.3946 80.3337C27.4567 80.4372 27.4878 80.5537 27.4878 80.6832C27.4878 80.8229 27.4567 80.9394 27.3946 81.0326C27.3351 81.1258 27.2561 81.197 27.1578 81.2462C27.062 81.2953 26.9597 81.3251 26.851 81.3355L26.9054 81.2966C27.0219 81.2992 27.1293 81.3303 27.2277 81.3898C27.326 81.4494 27.4037 81.5296 27.4606 81.6305C27.5202 81.7315 27.5499 81.8441 27.5499 81.9684C27.5499 82.1055 27.5163 82.2311 27.449 82.345C27.3817 82.4563 27.282 82.5456 27.15 82.6129C27.0206 82.6776 26.8601 82.71 26.6685 82.71H25.6823ZM26.0085 82.4382H26.6336C26.8174 82.4382 26.9597 82.3955 27.0607 82.31C27.1642 82.222 27.216 82.1004 27.216 81.9451C27.216 81.7923 27.1629 81.6707 27.0568 81.5801C26.9533 81.4869 26.8096 81.4403 26.6258 81.4403H26.0085V82.4382ZM26.0085 81.1801H26.6142C26.7902 81.1801 26.9235 81.1387 27.0141 81.0559C27.1073 80.9731 27.1539 80.8605 27.1539 80.7181C27.1539 80.5809 27.1073 80.4709 27.0141 80.3881C26.9235 80.3052 26.7863 80.2638 26.6025 80.2638H26.0085V81.1801Z",
    fill: "#7F7F7D",
    style: (_ref5 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-4_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 76.71H68.8014V86.1396H40.6406V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 76.71H68.8014V86.1396H40.6406V76.71Z",
    fill: "#FAFAFA",
    style: (_ref6 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 86.1396H40.918V76.71H40.6406H40.3633V86.1396H40.6406Z",
    fill: "url(#paint2_linear_17113_221003)",
    style: {},
    mask: "url(#path-14-inside-4_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.801 82.7566C54.537 82.7566 54.3079 82.6983 54.1138 82.5818C53.9222 82.4628 53.7747 82.2984 53.6711 82.0887C53.5676 81.8765 53.5158 81.6305 53.5158 81.351C53.5158 81.0714 53.5676 80.8268 53.6711 80.6171C53.7747 80.4049 53.9222 80.2405 54.1138 80.124C54.3079 80.005 54.537 79.9454 54.801 79.9454C55.1116 79.9454 55.364 80.0192 55.5582 80.1667C55.7523 80.3143 55.8765 80.5227 55.9309 80.7919H55.5698C55.5284 80.6236 55.4443 80.489 55.3174 80.3881C55.1906 80.2845 55.0184 80.2327 54.801 80.2327C54.6069 80.2327 54.4386 80.278 54.2963 80.3686C54.1539 80.4567 54.0439 80.5848 53.9662 80.753C53.8886 80.9187 53.8497 81.118 53.8497 81.351C53.8497 81.584 53.8886 81.7846 53.9662 81.9528C54.0439 82.1185 54.1539 82.2466 54.2963 82.3372C54.4386 82.4252 54.6069 82.4692 54.801 82.4692C55.0184 82.4692 55.1906 82.42 55.3174 82.3217C55.4443 82.2207 55.5284 82.0874 55.5698 81.9218H55.9309C55.8765 82.1832 55.7523 82.3877 55.5582 82.5352C55.364 82.6828 55.1116 82.7566 54.801 82.7566Z",
    fill: "#7F7F7D",
    style: (_ref7 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-5_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 76.71H96.9626V86.1396H68.8018V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 76.71H96.9626V86.1396H68.8018V76.71Z",
    fill: "#FAFAFA",
    style: (_ref8 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 86.1396H69.0791V76.71H68.8018H68.5244V86.1396H68.8018Z",
    fill: "url(#paint3_linear_17113_221003)",
    style: {},
    mask: "url(#path-17-inside-5_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8368 82.71V79.992H82.6366C82.955 79.992 83.2164 80.0477 83.4209 80.159C83.628 80.2677 83.7807 80.4243 83.8791 80.6288C83.9801 80.8307 84.0305 81.074 84.0305 81.3588C84.0305 81.6383 83.9801 81.879 83.8791 82.081C83.7807 82.2829 83.628 82.4382 83.4209 82.5469C83.2164 82.6556 82.955 82.71 82.6366 82.71H81.8368ZM82.1629 82.4382H82.6288C82.8929 82.4382 83.1025 82.3955 83.2579 82.31C83.4132 82.222 83.5245 82.0978 83.5918 81.9373C83.6591 81.7742 83.6927 81.5814 83.6927 81.3588C83.6927 81.131 83.6591 80.9355 83.5918 80.7725C83.5245 80.6094 83.4132 80.4838 83.2579 80.3958C83.1025 80.3078 82.8929 80.2638 82.6288 80.2638H82.1629V82.4382Z",
    fill: "#7F7F7D",
    style: (_ref9 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-6_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 76.71H125.124V86.1396H96.9629V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 76.71H125.124V86.1396H96.9629V76.71Z",
    fill: "#FAFAFA",
    style: (_ref10 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 86.1396H97.2402V76.71H96.9629H96.6855V86.1396H96.9629Z",
    fill: "url(#paint4_linear_17113_221003)",
    style: {},
    mask: "url(#path-20-inside-6_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.237 82.71V79.992H111.918V80.2599H110.563V81.2073H111.802V81.4714H110.563V82.442H111.918V82.71H110.237Z",
    fill: "#7F7F7D",
    style: (_ref11 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-7_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 76.71H153.284V86.1396H125.123V76.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 76.71H153.284V86.1396H125.123V76.71Z",
    fill: "#FAFAFA",
    style: (_ref12 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 86.1396H125.4V76.71H125.123H124.846V86.1396H125.123Z",
    fill: "url(#paint5_linear_17113_221003)",
    style: {},
    mask: "url(#path-23-inside-7_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.456 82.71V79.992H140.11V80.2599H138.782V81.2151H139.912V81.4791H138.782V82.71H138.456Z",
    fill: "#7F7F7D",
    style: (_ref13 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref13, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref13, "fillOpacity", 1), _ref13)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-24.001 76.71V76.9873H350.41V76.71V76.4326H-24.001V76.71Z",
    fill: "#EAEEED",
    style: (_ref14 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref14, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref14, "fillOpacity", 1), _ref14),
    mask: "url(#path-7-inside-1_17113_221003)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 86.1395)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-8_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 86.1395H12.4801V93.7121H-15.6807V86.1395Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 86.1395H12.4801V93.7121H-15.6807V86.1395Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 86.1395V85.8622H-15.958V86.1395H-15.6807ZM-15.6807 86.1395V86.4169H12.4801V86.1395V85.8622H-15.6807V86.1395ZM-15.6807 93.7121H-15.4033V86.1395H-15.6807H-15.958V93.7121H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref15 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref15, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref15, "fillOpacity", 1), _ref15),
    mask: "url(#path-26-inside-8_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 89.9258H7.05205",
    stroke: "#99ABA7",
    style: (_ref16 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref16, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref16, "strokeOpacity", 1), _ref16),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-9_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 86.1395H40.6413V93.7121H12.4805V86.1395Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 86.1395H40.6413V93.7121H12.4805V86.1395Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 86.1395V85.8622H12.2031V86.1395H12.4805ZM12.4805 86.1395V86.4169H40.6413V86.1395V85.8622H12.4805V86.1395ZM12.4805 93.7121H12.7578V86.1395H12.4805H12.2031V93.7121H12.4805Z",
    fill: "#EAEEED",
    style: (_ref17 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref17, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref17, "fillOpacity", 1), _ref17),
    mask: "url(#path-29-inside-9_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 89.9258H35.2132",
    stroke: "#99ABA7",
    style: (_ref18 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref18, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref18, "strokeOpacity", 1), _ref18),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-10_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 86.1395H68.8014V93.7121H40.6406V86.1395Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 86.1395H68.8014V93.7121H40.6406V86.1395Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 86.1395V85.8622H40.3633V86.1395H40.6406ZM40.6406 86.1395V86.4169H68.8014V86.1395V85.8622H40.6406V86.1395ZM40.6406 93.7121H40.918V86.1395H40.6406H40.3633V93.7121H40.6406Z",
    fill: "#EAEEED",
    style: (_ref19 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref19, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref19, "fillOpacity", 1), _ref19),
    mask: "url(#path-32-inside-10_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 89.9258H63.3733",
    stroke: "#99ABA7",
    style: (_ref20 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref20, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref20, "strokeOpacity", 1), _ref20),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-11_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 86.1395H96.9625V93.7121H68.8018V86.1395Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 86.1395H96.9625V93.7121H68.8018V86.1395Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 86.1395V85.8622H68.5244V86.1395H68.8018ZM68.8018 86.1395V86.4169H96.9625V86.1395V85.8622H68.8018V86.1395ZM68.8018 93.7121H69.0791V86.1395H68.8018H68.5244V93.7121H68.8018Z",
    fill: "#EAEEED",
    style: (_ref21 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref21, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref21, "fillOpacity", 1), _ref21),
    mask: "url(#path-35-inside-11_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 89.9258H91.5345",
    stroke: "#99ABA7",
    style: (_ref22 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref22, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref22, "strokeOpacity", 1), _ref22),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-12_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 86.1395H125.124V93.7121H96.9629V86.1395Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 86.1395H125.124V93.7121H96.9629V86.1395Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 86.1395V85.8622H96.6855V86.1395H96.9629ZM96.9629 86.1395V86.4169H125.124V86.1395V85.8622H96.9629V86.1395ZM96.9629 93.7121H97.2402V86.1395H96.9629H96.6855V93.7121H96.9629Z",
    fill: "#EAEEED",
    style: (_ref23 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref23, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref23, "fillOpacity", 1), _ref23),
    mask: "url(#path-38-inside-12_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 89.9258H119.696",
    stroke: "#99ABA7",
    style: (_ref24 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref24, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref24, "strokeOpacity", 1), _ref24),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-13_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 86.1395H153.284V93.7121H125.123V86.1395Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 86.1395H153.284V93.7121H125.123V86.1395Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 86.1395V85.8622H124.846V86.1395H125.123ZM125.123 86.1395V86.4169H153.284V86.1395V85.8622H125.123V86.1395ZM125.123 93.7121H125.4V86.1395H125.123H124.846V93.7121H125.123Z",
    fill: "#EAEEED",
    style: (_ref25 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref25, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref25, "fillOpacity", 1), _ref25),
    mask: "url(#path-41-inside-13_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 89.9258H147.856",
    stroke: "#99ABA7",
    style: (_ref26 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref26, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref26, "strokeOpacity", 1), _ref26),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 93.7122)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-14_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 93.7122H12.4801V101.285H-15.6807V93.7122Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 93.7122H12.4801V101.285H-15.6807V93.7122Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 93.7122V93.4348H-15.958V93.7122H-15.6807ZM-15.6807 93.7122V93.9895H12.4801V93.7122V93.4348H-15.6807V93.7122ZM-15.6807 101.285H-15.4033V93.7122H-15.6807H-15.958V101.285H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref27 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref27, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref27, "fillOpacity", 1), _ref27),
    mask: "url(#path-44-inside-14_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 97.4984H7.05205",
    stroke: "#CCD5D3",
    style: (_ref28 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref28, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref28, "strokeOpacity", 1), _ref28),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-15_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 93.7122H40.6413V101.285H12.4805V93.7122Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 93.7122H40.6413V101.285H12.4805V93.7122Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 93.7122V93.4348H12.2031V93.7122H12.4805ZM12.4805 93.7122V93.9895H40.6413V93.7122V93.4348H12.4805V93.7122ZM12.4805 101.285H12.7578V93.7122H12.4805H12.2031V101.285H12.4805Z",
    fill: "#EAEEED",
    style: (_ref29 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref29, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref29, "fillOpacity", 1), _ref29),
    mask: "url(#path-47-inside-15_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 97.4984H35.2132",
    stroke: "#CCD5D3",
    style: (_ref30 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref30, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref30, "strokeOpacity", 1), _ref30),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-16_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 93.7122H68.8014V101.285H40.6406V93.7122Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 93.7122H68.8014V101.285H40.6406V93.7122Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 93.7122V93.4348H40.3633V93.7122H40.6406ZM40.6406 93.7122V93.9895H68.8014V93.7122V93.4348H40.6406V93.7122ZM40.6406 101.285H40.918V93.7122H40.6406H40.3633V101.285H40.6406Z",
    fill: "#EAEEED",
    style: (_ref31 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref31, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref31, "fillOpacity", 1), _ref31),
    mask: "url(#path-50-inside-16_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 97.4984H63.3733",
    stroke: "#CCD5D3",
    style: (_ref32 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref32, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref32, "strokeOpacity", 1), _ref32),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-17_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 93.7122H96.9625V101.285H68.8018V93.7122Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 93.7122H96.9625V101.285H68.8018V93.7122Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 93.7122V93.4348H68.5244V93.7122H68.8018ZM68.8018 93.7122V93.9895H96.9625V93.7122V93.4348H68.8018V93.7122ZM68.8018 101.285H69.0791V93.7122H68.8018H68.5244V101.285H68.8018Z",
    fill: "#EAEEED",
    style: (_ref33 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref33, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref33, "fillOpacity", 1), _ref33),
    mask: "url(#path-53-inside-17_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 97.4984H91.5345",
    stroke: "#CCD5D3",
    style: (_ref34 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref34, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref34, "strokeOpacity", 1), _ref34),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-56-inside-18_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 93.7122H125.124V101.285H96.9629V93.7122Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 93.7122H125.124V101.285H96.9629V93.7122Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 93.7122V93.4348H96.6855V93.7122H96.9629ZM96.9629 93.7122V93.9895H125.124V93.7122V93.4348H96.9629V93.7122ZM96.9629 101.285H97.2402V93.7122H96.9629H96.6855V101.285H96.9629Z",
    fill: "#EAEEED",
    style: (_ref35 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref35, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref35, "fillOpacity", 1), _ref35),
    mask: "url(#path-56-inside-18_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 97.4984H119.696",
    stroke: "#CCD5D3",
    style: (_ref36 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref36, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref36, "strokeOpacity", 1), _ref36),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-19_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 93.7122H153.284V101.285H125.123V93.7122Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 93.7122H153.284V101.285H125.123V93.7122Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 93.7122V93.4348H124.846V93.7122H125.123ZM125.123 93.7122V93.9895H153.284V93.7122V93.4348H125.123V93.7122ZM125.123 101.285H125.4V93.7122H125.123H124.846V101.285H125.123Z",
    fill: "#EAEEED",
    style: (_ref37 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref37, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref37, "fillOpacity", 1), _ref37),
    mask: "url(#path-59-inside-19_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 97.4984H147.856",
    stroke: "#CCD5D3",
    style: (_ref38 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref38, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref38, "strokeOpacity", 1), _ref38),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 101.285)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-20_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 101.285H12.4801V108.857H-15.6807V101.285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 101.285H12.4801V108.857H-15.6807V101.285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 101.285V101.007H-15.958V101.285H-15.6807ZM-15.6807 101.285V101.562H12.4801V101.285V101.007H-15.6807V101.285ZM-15.6807 108.857H-15.4033V101.285H-15.6807H-15.958V108.857H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref39 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref39, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref39, "fillOpacity", 1), _ref39),
    mask: "url(#path-62-inside-20_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 105.071H7.05205",
    stroke: "#CCD5D3",
    style: (_ref40 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref40, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref40, "strokeOpacity", 1), _ref40),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-65-inside-21_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 101.285H40.6413V108.857H12.4805V101.285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 101.285H40.6413V108.857H12.4805V101.285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 101.285V101.007H12.2031V101.285H12.4805ZM12.4805 101.285V101.562H40.6413V101.285V101.007H12.4805V101.285ZM12.4805 108.857H12.7578V101.285H12.4805H12.2031V108.857H12.4805Z",
    fill: "#EAEEED",
    style: (_ref41 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref41, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref41, "fillOpacity", 1), _ref41),
    mask: "url(#path-65-inside-21_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 105.071H35.2132",
    stroke: "#CCD5D3",
    style: (_ref42 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref42, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref42, "strokeOpacity", 1), _ref42),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-22_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 101.285H68.8014V108.857H40.6406V101.285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 101.285H68.8014V108.857H40.6406V101.285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 101.285V101.007H40.3633V101.285H40.6406ZM40.6406 101.285V101.562H68.8014V101.285V101.007H40.6406V101.285ZM40.6406 108.857H40.918V101.285H40.6406H40.3633V108.857H40.6406Z",
    fill: "#EAEEED",
    style: (_ref43 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref43, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref43, "fillOpacity", 1), _ref43),
    mask: "url(#path-68-inside-22_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 105.071H63.3733",
    stroke: "#CCD5D3",
    style: (_ref44 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref44, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref44, "strokeOpacity", 1), _ref44),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-23_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 101.285H96.9625V108.857H68.8018V101.285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 101.285H96.9625V108.857H68.8018V101.285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 101.285V101.007H68.5244V101.285H68.8018ZM68.8018 101.285V101.562H96.9625V101.285V101.007H68.8018V101.285ZM68.8018 108.857H69.0791V101.285H68.8018H68.5244V108.857H68.8018Z",
    fill: "#EAEEED",
    style: (_ref45 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref45, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref45, "fillOpacity", 1), _ref45),
    mask: "url(#path-71-inside-23_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 105.071H91.5345",
    stroke: "#CCD5D3",
    style: (_ref46 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref46, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref46, "strokeOpacity", 1), _ref46),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-74-inside-24_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 101.285H125.124V108.857H96.9629V101.285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 101.285H125.124V108.857H96.9629V101.285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 101.285V101.007H96.6855V101.285H96.9629ZM96.9629 101.285V101.562H125.124V101.285V101.007H96.9629V101.285ZM96.9629 108.857H97.2402V101.285H96.9629H96.6855V108.857H96.9629Z",
    fill: "#EAEEED",
    style: (_ref47 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref47, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref47, "fillOpacity", 1), _ref47),
    mask: "url(#path-74-inside-24_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 105.071H119.696",
    stroke: "#CCD5D3",
    style: (_ref48 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref48, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref48, "strokeOpacity", 1), _ref48),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-25_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 101.285H153.284V108.857H125.123V101.285Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 101.285H153.284V108.857H125.123V101.285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 101.285V101.007H124.846V101.285H125.123ZM125.123 101.285V101.562H153.284V101.285V101.007H125.123V101.285ZM125.123 108.857H125.4V101.285H125.123H124.846V108.857H125.123Z",
    fill: "#EAEEED",
    style: (_ref49 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref49, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref49, "fillOpacity", 1), _ref49),
    mask: "url(#path-77-inside-25_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 105.071H147.856",
    stroke: "#CCD5D3",
    style: (_ref50 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref50, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref50, "strokeOpacity", 1), _ref50),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 108.857)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-26_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 108.857H12.4801V116.43H-15.6807V108.857Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 108.857H12.4801V116.43H-15.6807V108.857Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 108.857V108.58H-15.958V108.857H-15.6807ZM-15.6807 108.857V109.135H12.4801V108.857V108.58H-15.6807V108.857ZM-15.6807 116.43H-15.4033V108.857H-15.6807H-15.958V116.43H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref51 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref51, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref51, "fillOpacity", 1), _ref51),
    mask: "url(#path-80-inside-26_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 112.644H7.05205",
    stroke: "#CCD5D3",
    style: (_ref52 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref52, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref52, "strokeOpacity", 1), _ref52),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-27_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 108.857H40.6413V116.43H12.4805V108.857Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 108.857H40.6413V116.43H12.4805V108.857Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 108.857V108.58H12.2031V108.857H12.4805ZM12.4805 108.857V109.135H40.6413V108.857V108.58H12.4805V108.857ZM12.4805 116.43H12.7578V108.857H12.4805H12.2031V116.43H12.4805Z",
    fill: "#EAEEED",
    style: (_ref53 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref53, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref53, "fillOpacity", 1), _ref53),
    mask: "url(#path-83-inside-27_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 112.644H35.2132",
    stroke: "#CCD5D3",
    style: (_ref54 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref54, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref54, "strokeOpacity", 1), _ref54),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    id: "path-86-inside-28_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 108.857H68.8014V116.43H40.6406V108.857Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 108.857H68.8014V116.43H40.6406V108.857Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 108.857V108.58H40.3633V108.857H40.6406ZM40.6406 108.857V109.135H68.8014V108.857V108.58H40.6406V108.857ZM40.6406 116.43H40.918V108.857H40.6406H40.3633V116.43H40.6406Z",
    fill: "#EAEEED",
    style: (_ref55 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref55, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref55, "fillOpacity", 1), _ref55),
    mask: "url(#path-86-inside-28_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 112.644H63.3733",
    stroke: "#CCD5D3",
    style: (_ref56 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref56, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref56, "strokeOpacity", 1), _ref56),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    id: "path-89-inside-29_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 108.857H96.9625V116.43H68.8018V108.857Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 108.857H96.9625V116.43H68.8018V108.857Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 108.857V108.58H68.5244V108.857H68.8018ZM68.8018 108.857V109.135H96.9625V108.857V108.58H68.8018V108.857ZM68.8018 116.43H69.0791V108.857H68.8018H68.5244V116.43H68.8018Z",
    fill: "#EAEEED",
    style: (_ref57 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref57, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref57, "fillOpacity", 1), _ref57),
    mask: "url(#path-89-inside-29_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 112.644H91.5345",
    stroke: "#CCD5D3",
    style: (_ref58 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref58, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref58, "strokeOpacity", 1), _ref58),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask30 || (_mask30 = /*#__PURE__*/React.createElement("mask", {
    id: "path-92-inside-30_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 108.857H125.124V116.43H96.9629V108.857Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 108.857H125.124V116.43H96.9629V108.857Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 108.857V108.58H96.6855V108.857H96.9629ZM96.9629 108.857V109.135H125.124V108.857V108.58H96.9629V108.857ZM96.9629 116.43H97.2402V108.857H96.9629H96.6855V116.43H96.9629Z",
    fill: "#EAEEED",
    style: (_ref59 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref59, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref59, "fillOpacity", 1), _ref59),
    mask: "url(#path-92-inside-30_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 112.644H119.696",
    stroke: "#CCD5D3",
    style: (_ref60 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref60, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref60, "strokeOpacity", 1), _ref60),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask31 || (_mask31 = /*#__PURE__*/React.createElement("mask", {
    id: "path-95-inside-31_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 108.857H153.284V116.43H125.123V108.857Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 108.857H153.284V116.43H125.123V108.857Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 108.857V108.58H124.846V108.857H125.123ZM125.123 108.857V109.135H153.284V108.857V108.58H125.123V108.857ZM125.123 116.43H125.4V108.857H125.123H124.846V116.43H125.123Z",
    fill: "#EAEEED",
    style: (_ref61 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref61, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref61, "fillOpacity", 1), _ref61),
    mask: "url(#path-95-inside-31_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 112.644H147.856",
    stroke: "#CCD5D3",
    style: (_ref62 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref62, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref62, "strokeOpacity", 1), _ref62),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 116.43)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask32 || (_mask32 = /*#__PURE__*/React.createElement("mask", {
    id: "path-98-inside-32_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 116.43H12.4801V124.003H-15.6807V116.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 116.43H12.4801V124.003H-15.6807V116.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 116.43V116.153H-15.958V116.43H-15.6807ZM-15.6807 116.43V116.707H12.4801V116.43V116.153H-15.6807V116.43ZM-15.6807 124.003H-15.4033V116.43H-15.6807H-15.958V124.003H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref63 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref63, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref63, "fillOpacity", 1), _ref63),
    mask: "url(#path-98-inside-32_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 120.216H7.05205",
    stroke: "#CCD5D3",
    style: (_ref64 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref64, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref64, "strokeOpacity", 1), _ref64),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask33 || (_mask33 = /*#__PURE__*/React.createElement("mask", {
    id: "path-101-inside-33_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 116.43H40.6413V124.003H12.4805V116.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 116.43H40.6413V124.003H12.4805V116.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 116.43V116.153H12.2031V116.43H12.4805ZM12.4805 116.43V116.707H40.6413V116.43V116.153H12.4805V116.43ZM12.4805 124.003H12.7578V116.43H12.4805H12.2031V124.003H12.4805Z",
    fill: "#EAEEED",
    style: (_ref65 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref65, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref65, "fillOpacity", 1), _ref65),
    mask: "url(#path-101-inside-33_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 120.216H35.2132",
    stroke: "#CCD5D3",
    style: (_ref66 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref66, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref66, "strokeOpacity", 1), _ref66),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask34 || (_mask34 = /*#__PURE__*/React.createElement("mask", {
    id: "path-104-inside-34_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 116.43H68.8014V124.003H40.6406V116.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 116.43H68.8014V124.003H40.6406V116.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 116.43V116.153H40.3633V116.43H40.6406ZM40.6406 116.43V116.707H68.8014V116.43V116.153H40.6406V116.43ZM40.6406 124.003H40.918V116.43H40.6406H40.3633V124.003H40.6406Z",
    fill: "#EAEEED",
    style: (_ref67 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref67, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref67, "fillOpacity", 1), _ref67),
    mask: "url(#path-104-inside-34_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 120.216H63.3733",
    stroke: "#CCD5D3",
    style: (_ref68 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref68, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref68, "strokeOpacity", 1), _ref68),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask35 || (_mask35 = /*#__PURE__*/React.createElement("mask", {
    id: "path-107-inside-35_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 116.43H96.9625V124.003H68.8018V116.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 116.43H96.9625V124.003H68.8018V116.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 116.43V116.153H68.5244V116.43H68.8018ZM68.8018 116.43V116.707H96.9625V116.43V116.153H68.8018V116.43ZM68.8018 124.003H69.0791V116.43H68.8018H68.5244V124.003H68.8018Z",
    fill: "#EAEEED",
    style: (_ref69 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref69, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref69, "fillOpacity", 1), _ref69),
    mask: "url(#path-107-inside-35_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 120.216H91.5345",
    stroke: "#CCD5D3",
    style: (_ref70 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref70, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref70, "strokeOpacity", 1), _ref70),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask36 || (_mask36 = /*#__PURE__*/React.createElement("mask", {
    id: "path-110-inside-36_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 116.43H125.124V124.003H96.9629V116.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 116.43H125.124V124.003H96.9629V116.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 116.43V116.153H96.6855V116.43H96.9629ZM96.9629 116.43V116.707H125.124V116.43V116.153H96.9629V116.43ZM96.9629 124.003H97.2402V116.43H96.9629H96.6855V124.003H96.9629Z",
    fill: "#EAEEED",
    style: (_ref71 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref71, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref71, "fillOpacity", 1), _ref71),
    mask: "url(#path-110-inside-36_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 120.216H119.696",
    stroke: "#CCD5D3",
    style: (_ref72 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref72, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref72, "strokeOpacity", 1), _ref72),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask37 || (_mask37 = /*#__PURE__*/React.createElement("mask", {
    id: "path-113-inside-37_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 116.43H153.284V124.003H125.123V116.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 116.43H153.284V124.003H125.123V116.43Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 116.43V116.153H124.846V116.43H125.123ZM125.123 116.43V116.707H153.284V116.43V116.153H125.123V116.43ZM125.123 124.003H125.4V116.43H125.123H124.846V124.003H125.123Z",
    fill: "#EAEEED",
    style: (_ref73 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref73, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref73, "fillOpacity", 1), _ref73),
    mask: "url(#path-113-inside-37_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 120.216H147.856",
    stroke: "#CCD5D3",
    style: (_ref74 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref74, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref74, "strokeOpacity", 1), _ref74),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 124.003)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask38 || (_mask38 = /*#__PURE__*/React.createElement("mask", {
    id: "path-116-inside-38_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 124.003H12.4801V131.575H-15.6807V124.003Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 124.003H12.4801V131.575H-15.6807V124.003Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 124.003V123.725H-15.958V124.003H-15.6807ZM-15.6807 124.003V124.28H12.4801V124.003V123.725H-15.6807V124.003ZM-15.6807 131.575H-15.4033V124.003H-15.6807H-15.958V131.575H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref75 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref75, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref75, "fillOpacity", 1), _ref75),
    mask: "url(#path-116-inside-38_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 127.789H7.05205",
    stroke: "#CCD5D3",
    style: (_ref76 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref76, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref76, "strokeOpacity", 1), _ref76),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask39 || (_mask39 = /*#__PURE__*/React.createElement("mask", {
    id: "path-119-inside-39_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 124.003H40.6413V131.575H12.4805V124.003Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 124.003H40.6413V131.575H12.4805V124.003Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 124.003V123.725H12.2031V124.003H12.4805ZM12.4805 124.003V124.28H40.6413V124.003V123.725H12.4805V124.003ZM12.4805 131.575H12.7578V124.003H12.4805H12.2031V131.575H12.4805Z",
    fill: "#EAEEED",
    style: (_ref77 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref77, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref77, "fillOpacity", 1), _ref77),
    mask: "url(#path-119-inside-39_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 127.789H35.2132",
    stroke: "#CCD5D3",
    style: (_ref78 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref78, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref78, "strokeOpacity", 1), _ref78),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask40 || (_mask40 = /*#__PURE__*/React.createElement("mask", {
    id: "path-122-inside-40_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 124.003H68.8014V131.575H40.6406V124.003Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 124.003H68.8014V131.575H40.6406V124.003Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 124.003V123.725H40.3633V124.003H40.6406ZM40.6406 124.003V124.28H68.8014V124.003V123.725H40.6406V124.003ZM40.6406 131.575H40.918V124.003H40.6406H40.3633V131.575H40.6406Z",
    fill: "#EAEEED",
    style: (_ref79 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref79, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref79, "fillOpacity", 1), _ref79),
    mask: "url(#path-122-inside-40_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 127.789H63.3733",
    stroke: "#CCD5D3",
    style: (_ref80 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref80, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref80, "strokeOpacity", 1), _ref80),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask41 || (_mask41 = /*#__PURE__*/React.createElement("mask", {
    id: "path-125-inside-41_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 124.003H96.9625V131.575H68.8018V124.003Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 124.003H96.9625V131.575H68.8018V124.003Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 124.003V123.725H68.5244V124.003H68.8018ZM68.8018 124.003V124.28H96.9625V124.003V123.725H68.8018V124.003ZM68.8018 131.575H69.0791V124.003H68.8018H68.5244V131.575H68.8018Z",
    fill: "#EAEEED",
    style: (_ref81 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref81, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref81, "fillOpacity", 1), _ref81),
    mask: "url(#path-125-inside-41_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 127.789H91.5345",
    stroke: "#CCD5D3",
    style: (_ref82 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref82, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref82, "strokeOpacity", 1), _ref82),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask42 || (_mask42 = /*#__PURE__*/React.createElement("mask", {
    id: "path-128-inside-42_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 124.003H125.124V131.575H96.9629V124.003Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 124.003H125.124V131.575H96.9629V124.003Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 124.003V123.725H96.6855V124.003H96.9629ZM96.9629 124.003V124.28H125.124V124.003V123.725H96.9629V124.003ZM96.9629 131.575H97.2402V124.003H96.9629H96.6855V131.575H96.9629Z",
    fill: "#EAEEED",
    style: (_ref83 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref83, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref83, "fillOpacity", 1), _ref83),
    mask: "url(#path-128-inside-42_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 127.789H119.696",
    stroke: "#CCD5D3",
    style: (_ref84 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref84, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref84, "strokeOpacity", 1), _ref84),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask43 || (_mask43 = /*#__PURE__*/React.createElement("mask", {
    id: "path-131-inside-43_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 124.003H153.284V131.575H125.123V124.003Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 124.003H153.284V131.575H125.123V124.003Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 124.003V123.725H124.846V124.003H125.123ZM125.123 124.003V124.28H153.284V124.003V123.725H125.123V124.003ZM125.123 131.575H125.4V124.003H125.123H124.846V131.575H125.123Z",
    fill: "#EAEEED",
    style: (_ref85 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref85, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref85, "fillOpacity", 1), _ref85),
    mask: "url(#path-131-inside-43_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 127.789H147.856",
    stroke: "#CCD5D3",
    style: (_ref86 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref86, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref86, "strokeOpacity", 1), _ref86),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 131.575)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask44 || (_mask44 = /*#__PURE__*/React.createElement("mask", {
    id: "path-134-inside-44_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 131.575H12.4801V139.148H-15.6807V131.575Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 131.575H12.4801V139.148H-15.6807V131.575Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 131.575V131.298H-15.958V131.575H-15.6807ZM-15.6807 131.575V131.853H12.4801V131.575V131.298H-15.6807V131.575ZM-15.6807 139.148H-15.4033V131.575H-15.6807H-15.958V139.148H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref87 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref87, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref87, "fillOpacity", 1), _ref87),
    mask: "url(#path-134-inside-44_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 135.362H7.05205",
    stroke: "#CCD5D3",
    style: (_ref88 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref88, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref88, "strokeOpacity", 1), _ref88),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask45 || (_mask45 = /*#__PURE__*/React.createElement("mask", {
    id: "path-137-inside-45_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 131.575H40.6413V139.148H12.4805V131.575Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 131.575H40.6413V139.148H12.4805V131.575Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 131.575V131.298H12.2031V131.575H12.4805ZM12.4805 131.575V131.853H40.6413V131.575V131.298H12.4805V131.575ZM12.4805 139.148H12.7578V131.575H12.4805H12.2031V139.148H12.4805Z",
    fill: "#EAEEED",
    style: (_ref89 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref89, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref89, "fillOpacity", 1), _ref89),
    mask: "url(#path-137-inside-45_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 135.362H35.2132",
    stroke: "#CCD5D3",
    style: (_ref90 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref90, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref90, "strokeOpacity", 1), _ref90),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask46 || (_mask46 = /*#__PURE__*/React.createElement("mask", {
    id: "path-140-inside-46_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 131.575H68.8014V139.148H40.6406V131.575Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 131.575H68.8014V139.148H40.6406V131.575Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 131.575V131.298H40.3633V131.575H40.6406ZM40.6406 131.575V131.853H68.8014V131.575V131.298H40.6406V131.575ZM40.6406 139.148H40.918V131.575H40.6406H40.3633V139.148H40.6406Z",
    fill: "#EAEEED",
    style: (_ref91 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref91, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref91, "fillOpacity", 1), _ref91),
    mask: "url(#path-140-inside-46_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 135.362H63.3733",
    stroke: "#CCD5D3",
    style: (_ref92 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref92, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref92, "strokeOpacity", 1), _ref92),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask47 || (_mask47 = /*#__PURE__*/React.createElement("mask", {
    id: "path-143-inside-47_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 131.575H96.9625V139.148H68.8018V131.575Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 131.575H96.9625V139.148H68.8018V131.575Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 131.575V131.298H68.5244V131.575H68.8018ZM68.8018 131.575V131.853H96.9625V131.575V131.298H68.8018V131.575ZM68.8018 139.148H69.0791V131.575H68.8018H68.5244V139.148H68.8018Z",
    fill: "#EAEEED",
    style: (_ref93 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref93, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref93, "fillOpacity", 1), _ref93),
    mask: "url(#path-143-inside-47_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 135.362H91.5345",
    stroke: "#CCD5D3",
    style: (_ref94 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref94, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref94, "strokeOpacity", 1), _ref94),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask48 || (_mask48 = /*#__PURE__*/React.createElement("mask", {
    id: "path-146-inside-48_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 131.575H125.124V139.148H96.9629V131.575Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 131.575H125.124V139.148H96.9629V131.575Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 131.575V131.298H96.6855V131.575H96.9629ZM96.9629 131.575V131.853H125.124V131.575V131.298H96.9629V131.575ZM96.9629 139.148H97.2402V131.575H96.9629H96.6855V139.148H96.9629Z",
    fill: "#EAEEED",
    style: (_ref95 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref95, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref95, "fillOpacity", 1), _ref95),
    mask: "url(#path-146-inside-48_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 135.362H119.696",
    stroke: "#CCD5D3",
    style: (_ref96 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref96, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref96, "strokeOpacity", 1), _ref96),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask49 || (_mask49 = /*#__PURE__*/React.createElement("mask", {
    id: "path-149-inside-49_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 131.575H153.284V139.148H125.123V131.575Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 131.575H153.284V139.148H125.123V131.575Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 131.575V131.298H124.846V131.575H125.123ZM125.123 131.575V131.853H153.284V131.575V131.298H125.123V131.575ZM125.123 139.148H125.4V131.575H125.123H124.846V139.148H125.123Z",
    fill: "#EAEEED",
    style: (_ref97 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref97, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref97, "fillOpacity", 1), _ref97),
    mask: "url(#path-149-inside-49_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 135.362H147.856",
    stroke: "#CCD5D3",
    style: (_ref98 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref98, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref98, "strokeOpacity", 1), _ref98),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 139.148)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask50 || (_mask50 = /*#__PURE__*/React.createElement("mask", {
    id: "path-152-inside-50_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 139.148H12.4801V146.721H-15.6807V139.148Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 139.148H12.4801V146.721H-15.6807V139.148Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 139.148V138.871H-15.958V139.148H-15.6807ZM-15.6807 139.148V139.425H12.4801V139.148V138.871H-15.6807V139.148ZM-15.6807 146.721H-15.4033V139.148H-15.6807H-15.958V146.721H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref99 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref99, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref99, "fillOpacity", 1), _ref99),
    mask: "url(#path-152-inside-50_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 142.934H7.05205",
    stroke: "#CCD5D3",
    style: (_ref100 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref100, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref100, "strokeOpacity", 1), _ref100),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask51 || (_mask51 = /*#__PURE__*/React.createElement("mask", {
    id: "path-155-inside-51_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 139.148H40.6413V146.721H12.4805V139.148Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 139.148H40.6413V146.721H12.4805V139.148Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 139.148V138.871H12.2031V139.148H12.4805ZM12.4805 139.148V139.425H40.6413V139.148V138.871H12.4805V139.148ZM12.4805 146.721H12.7578V139.148H12.4805H12.2031V146.721H12.4805Z",
    fill: "#EAEEED",
    style: (_ref101 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref101, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref101, "fillOpacity", 1), _ref101),
    mask: "url(#path-155-inside-51_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 142.934H35.2132",
    stroke: "#CCD5D3",
    style: (_ref102 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref102, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref102, "strokeOpacity", 1), _ref102),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask52 || (_mask52 = /*#__PURE__*/React.createElement("mask", {
    id: "path-158-inside-52_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 139.148H68.8014V146.721H40.6406V139.148Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 139.148H68.8014V146.721H40.6406V139.148Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 139.148V138.871H40.3633V139.148H40.6406ZM40.6406 139.148V139.425H68.8014V139.148V138.871H40.6406V139.148ZM40.6406 146.721H40.918V139.148H40.6406H40.3633V146.721H40.6406Z",
    fill: "#EAEEED",
    style: (_ref103 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref103, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref103, "fillOpacity", 1), _ref103),
    mask: "url(#path-158-inside-52_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 142.934H63.3733",
    stroke: "#CCD5D3",
    style: (_ref104 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref104, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref104, "strokeOpacity", 1), _ref104),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask53 || (_mask53 = /*#__PURE__*/React.createElement("mask", {
    id: "path-161-inside-53_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 139.148H96.9625V146.721H68.8018V139.148Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 139.148H96.9625V146.721H68.8018V139.148Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 139.148V138.871H68.5244V139.148H68.8018ZM68.8018 139.148V139.425H96.9625V139.148V138.871H68.8018V139.148ZM68.8018 146.721H69.0791V139.148H68.8018H68.5244V146.721H68.8018Z",
    fill: "#EAEEED",
    style: (_ref105 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref105, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref105, "fillOpacity", 1), _ref105),
    mask: "url(#path-161-inside-53_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 142.934H91.5345",
    stroke: "#CCD5D3",
    style: (_ref106 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref106, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref106, "strokeOpacity", 1), _ref106),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask54 || (_mask54 = /*#__PURE__*/React.createElement("mask", {
    id: "path-164-inside-54_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 139.148H125.124V146.721H96.9629V139.148Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 139.148H125.124V146.721H96.9629V139.148Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 139.148V138.871H96.6855V139.148H96.9629ZM96.9629 139.148V139.425H125.124V139.148V138.871H96.9629V139.148ZM96.9629 146.721H97.2402V139.148H96.9629H96.6855V146.721H96.9629Z",
    fill: "#EAEEED",
    style: (_ref107 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref107, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref107, "fillOpacity", 1), _ref107),
    mask: "url(#path-164-inside-54_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 142.934H119.696",
    stroke: "#CCD5D3",
    style: (_ref108 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref108, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref108, "strokeOpacity", 1), _ref108),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask55 || (_mask55 = /*#__PURE__*/React.createElement("mask", {
    id: "path-167-inside-55_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 139.148H153.284V146.721H125.123V139.148Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 139.148H153.284V146.721H125.123V139.148Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 139.148V138.871H124.846V139.148H125.123ZM125.123 139.148V139.425H153.284V139.148V138.871H125.123V139.148ZM125.123 146.721H125.4V139.148H125.123H124.846V146.721H125.123Z",
    fill: "#EAEEED",
    style: (_ref109 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref109, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref109, "fillOpacity", 1), _ref109),
    mask: "url(#path-167-inside-55_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 142.934H147.856",
    stroke: "#CCD5D3",
    style: (_ref110 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref110, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref110, "strokeOpacity", 1), _ref110),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 146.72)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask56 || (_mask56 = /*#__PURE__*/React.createElement("mask", {
    id: "path-170-inside-56_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 146.72H12.4801V154.293H-15.6807V146.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 146.72H12.4801V154.293H-15.6807V146.72Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 146.72V146.443H-15.958V146.72H-15.6807ZM-15.6807 146.72V146.998H12.4801V146.72V146.443H-15.6807V146.72ZM-15.6807 154.293H-15.4033V146.72H-15.6807H-15.958V154.293H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref111 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref111, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref111, "fillOpacity", 1), _ref111),
    mask: "url(#path-170-inside-56_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 150.507H7.05205",
    stroke: "#CCD5D3",
    style: (_ref112 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref112, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref112, "strokeOpacity", 1), _ref112),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask57 || (_mask57 = /*#__PURE__*/React.createElement("mask", {
    id: "path-173-inside-57_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 146.72H40.6413V154.293H12.4805V146.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 146.72H40.6413V154.293H12.4805V146.72Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 146.72V146.443H12.2031V146.72H12.4805ZM12.4805 146.72V146.998H40.6413V146.72V146.443H12.4805V146.72ZM12.4805 154.293H12.7578V146.72H12.4805H12.2031V154.293H12.4805Z",
    fill: "#EAEEED",
    style: (_ref113 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref113, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref113, "fillOpacity", 1), _ref113),
    mask: "url(#path-173-inside-57_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 150.507H35.2132",
    stroke: "#CCD5D3",
    style: (_ref114 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref114, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref114, "strokeOpacity", 1), _ref114),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask58 || (_mask58 = /*#__PURE__*/React.createElement("mask", {
    id: "path-176-inside-58_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 146.72H68.8014V154.293H40.6406V146.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 146.72H68.8014V154.293H40.6406V146.72Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 146.72V146.443H40.3633V146.72H40.6406ZM40.6406 146.72V146.998H68.8014V146.72V146.443H40.6406V146.72ZM40.6406 154.293H40.918V146.72H40.6406H40.3633V154.293H40.6406Z",
    fill: "#EAEEED",
    style: (_ref115 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref115, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref115, "fillOpacity", 1), _ref115),
    mask: "url(#path-176-inside-58_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 150.507H63.3733",
    stroke: "#CCD5D3",
    style: (_ref116 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref116, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref116, "strokeOpacity", 1), _ref116),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask59 || (_mask59 = /*#__PURE__*/React.createElement("mask", {
    id: "path-179-inside-59_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 146.72H96.9625V154.293H68.8018V146.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 146.72H96.9625V154.293H68.8018V146.72Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 146.72V146.443H68.5244V146.72H68.8018ZM68.8018 146.72V146.998H96.9625V146.72V146.443H68.8018V146.72ZM68.8018 154.293H69.0791V146.72H68.8018H68.5244V154.293H68.8018Z",
    fill: "#EAEEED",
    style: (_ref117 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref117, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref117, "fillOpacity", 1), _ref117),
    mask: "url(#path-179-inside-59_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 150.507H91.5345",
    stroke: "#CCD5D3",
    style: (_ref118 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref118, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref118, "strokeOpacity", 1), _ref118),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask60 || (_mask60 = /*#__PURE__*/React.createElement("mask", {
    id: "path-182-inside-60_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 146.72H125.124V154.293H96.9629V146.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 146.72H125.124V154.293H96.9629V146.72Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 146.72V146.443H96.6855V146.72H96.9629ZM96.9629 146.72V146.998H125.124V146.72V146.443H96.9629V146.72ZM96.9629 154.293H97.2402V146.72H96.9629H96.6855V154.293H96.9629Z",
    fill: "#EAEEED",
    style: (_ref119 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref119, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref119, "fillOpacity", 1), _ref119),
    mask: "url(#path-182-inside-60_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 150.507H119.696",
    stroke: "#CCD5D3",
    style: (_ref120 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref120, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref120, "strokeOpacity", 1), _ref120),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask61 || (_mask61 = /*#__PURE__*/React.createElement("mask", {
    id: "path-185-inside-61_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 146.72H153.284V154.293H125.123V146.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 146.72H153.284V154.293H125.123V146.72Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 146.72V146.443H124.846V146.72H125.123ZM125.123 146.72V146.998H153.284V146.72V146.443H125.123V146.72ZM125.123 154.293H125.4V146.72H125.123H124.846V154.293H125.123Z",
    fill: "#EAEEED",
    style: (_ref121 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref121, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref121, "fillOpacity", 1), _ref121),
    mask: "url(#path-185-inside-61_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 150.507H147.856",
    stroke: "#CCD5D3",
    style: (_ref122 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref122, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref122, "strokeOpacity", 1), _ref122),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 154.293)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask62 || (_mask62 = /*#__PURE__*/React.createElement("mask", {
    id: "path-188-inside-62_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 154.293H12.4801V161.866H-15.6807V154.293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 154.293H12.4801V161.866H-15.6807V154.293Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 154.293V154.016H-15.958V154.293H-15.6807ZM-15.6807 154.293V154.57H12.4801V154.293V154.016H-15.6807V154.293ZM-15.6807 161.866H-15.4033V154.293H-15.6807H-15.958V161.866H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref123 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref123, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref123, "fillOpacity", 1), _ref123),
    mask: "url(#path-188-inside-62_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 158.079H7.05205",
    stroke: "#CCD5D3",
    style: (_ref124 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref124, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref124, "strokeOpacity", 1), _ref124),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask63 || (_mask63 = /*#__PURE__*/React.createElement("mask", {
    id: "path-191-inside-63_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 154.293H40.6413V161.866H12.4805V154.293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 154.293H40.6413V161.866H12.4805V154.293Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 154.293V154.016H12.2031V154.293H12.4805ZM12.4805 154.293V154.57H40.6413V154.293V154.016H12.4805V154.293ZM12.4805 161.866H12.7578V154.293H12.4805H12.2031V161.866H12.4805Z",
    fill: "#EAEEED",
    style: (_ref125 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref125, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref125, "fillOpacity", 1), _ref125),
    mask: "url(#path-191-inside-63_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 158.079H35.2132",
    stroke: "#CCD5D3",
    style: (_ref126 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref126, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref126, "strokeOpacity", 1), _ref126),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask64 || (_mask64 = /*#__PURE__*/React.createElement("mask", {
    id: "path-194-inside-64_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 154.293H68.8014V161.866H40.6406V154.293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 154.293H68.8014V161.866H40.6406V154.293Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 154.293V154.016H40.3633V154.293H40.6406ZM40.6406 154.293V154.57H68.8014V154.293V154.016H40.6406V154.293ZM40.6406 161.866H40.918V154.293H40.6406H40.3633V161.866H40.6406Z",
    fill: "#EAEEED",
    style: (_ref127 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref127, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref127, "fillOpacity", 1), _ref127),
    mask: "url(#path-194-inside-64_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 158.079H63.3733",
    stroke: "#CCD5D3",
    style: (_ref128 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref128, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref128, "strokeOpacity", 1), _ref128),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask65 || (_mask65 = /*#__PURE__*/React.createElement("mask", {
    id: "path-197-inside-65_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 154.293H96.9625V161.866H68.8018V154.293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 154.293H96.9625V161.866H68.8018V154.293Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 154.293V154.016H68.5244V154.293H68.8018ZM68.8018 154.293V154.57H96.9625V154.293V154.016H68.8018V154.293ZM68.8018 161.866H69.0791V154.293H68.8018H68.5244V161.866H68.8018Z",
    fill: "#EAEEED",
    style: (_ref129 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref129, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref129, "fillOpacity", 1), _ref129),
    mask: "url(#path-197-inside-65_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 158.079H91.5345",
    stroke: "#CCD5D3",
    style: (_ref130 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref130, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref130, "strokeOpacity", 1), _ref130),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask66 || (_mask66 = /*#__PURE__*/React.createElement("mask", {
    id: "path-200-inside-66_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 154.293H125.124V161.866H96.9629V154.293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 154.293H125.124V161.866H96.9629V154.293Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 154.293V154.016H96.6855V154.293H96.9629ZM96.9629 154.293V154.57H125.124V154.293V154.016H96.9629V154.293ZM96.9629 161.866H97.2402V154.293H96.9629H96.6855V161.866H96.9629Z",
    fill: "#EAEEED",
    style: (_ref131 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref131, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref131, "fillOpacity", 1), _ref131),
    mask: "url(#path-200-inside-66_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 158.079H119.696",
    stroke: "#CCD5D3",
    style: (_ref132 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref132, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref132, "strokeOpacity", 1), _ref132),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask67 || (_mask67 = /*#__PURE__*/React.createElement("mask", {
    id: "path-203-inside-67_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 154.293H153.284V161.866H125.123V154.293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 154.293H153.284V161.866H125.123V154.293Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 154.293V154.016H124.846V154.293H125.123ZM125.123 154.293V154.57H153.284V154.293V154.016H125.123V154.293ZM125.123 161.866H125.4V154.293H125.123H124.846V161.866H125.123Z",
    fill: "#EAEEED",
    style: (_ref133 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref133, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref133, "fillOpacity", 1), _ref133),
    mask: "url(#path-203-inside-67_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 158.079H147.856",
    stroke: "#CCD5D3",
    style: (_ref134 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref134, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref134, "strokeOpacity", 1), _ref134),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 161.866)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask68 || (_mask68 = /*#__PURE__*/React.createElement("mask", {
    id: "path-206-inside-68_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 161.866H12.4801V169.438H-15.6807V161.866Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 161.866H12.4801V169.438H-15.6807V161.866Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 161.866V161.588H-15.958V161.866H-15.6807ZM-15.6807 161.866V162.143H12.4801V161.866V161.588H-15.6807V161.866ZM-15.6807 169.438H-15.4033V161.866H-15.6807H-15.958V169.438H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref135 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref135, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref135, "fillOpacity", 1), _ref135),
    mask: "url(#path-206-inside-68_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-10.2529 165.652H7.05205",
    stroke: "#CCD5D3",
    style: (_ref136 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref136, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref136, "strokeOpacity", 1), _ref136),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask69 || (_mask69 = /*#__PURE__*/React.createElement("mask", {
    id: "path-209-inside-69_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 161.866H40.6413V169.438H12.4805V161.866Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 161.866H40.6413V169.438H12.4805V161.866Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 161.866V161.588H12.2031V161.866H12.4805ZM12.4805 161.866V162.143H40.6413V161.866V161.588H12.4805V161.866ZM12.4805 169.438H12.7578V161.866H12.4805H12.2031V169.438H12.4805Z",
    fill: "#EAEEED",
    style: (_ref137 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref137, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref137, "fillOpacity", 1), _ref137),
    mask: "url(#path-209-inside-69_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.9082 165.652H35.2132",
    stroke: "#CCD5D3",
    style: (_ref138 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref138, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref138, "strokeOpacity", 1), _ref138),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask70 || (_mask70 = /*#__PURE__*/React.createElement("mask", {
    id: "path-212-inside-70_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 161.866H68.8014V169.438H40.6406V161.866Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 161.866H68.8014V169.438H40.6406V161.866Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 161.866V161.588H40.3633V161.866H40.6406ZM40.6406 161.866V162.143H68.8014V161.866V161.588H40.6406V161.866ZM40.6406 169.438H40.918V161.866H40.6406H40.3633V169.438H40.6406Z",
    fill: "#EAEEED",
    style: (_ref139 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref139, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref139, "fillOpacity", 1), _ref139),
    mask: "url(#path-212-inside-70_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M46.0684 165.652H63.3733",
    stroke: "#CCD5D3",
    style: (_ref140 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref140, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref140, "strokeOpacity", 1), _ref140),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask71 || (_mask71 = /*#__PURE__*/React.createElement("mask", {
    id: "path-215-inside-71_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 161.866H96.9625V169.438H68.8018V161.866Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 161.866H96.9625V169.438H68.8018V161.866Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 161.866V161.588H68.5244V161.866H68.8018ZM68.8018 161.866V162.143H96.9625V161.866V161.588H68.8018V161.866ZM68.8018 169.438H69.0791V161.866H68.8018H68.5244V169.438H68.8018Z",
    fill: "#EAEEED",
    style: (_ref141 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref141, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref141, "fillOpacity", 1), _ref141),
    mask: "url(#path-215-inside-71_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.2295 165.652H91.5345",
    stroke: "#CCD5D3",
    style: (_ref142 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref142, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref142, "strokeOpacity", 1), _ref142),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask72 || (_mask72 = /*#__PURE__*/React.createElement("mask", {
    id: "path-218-inside-72_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 161.866H125.124V169.438H96.9629V161.866Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 161.866H125.124V169.438H96.9629V161.866Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 161.866V161.588H96.6855V161.866H96.9629ZM96.9629 161.866V162.143H125.124V161.866V161.588H96.9629V161.866ZM96.9629 169.438H97.2402V161.866H96.9629H96.6855V169.438H96.9629Z",
    fill: "#EAEEED",
    style: (_ref143 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref143, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref143, "fillOpacity", 1), _ref143),
    mask: "url(#path-218-inside-72_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.391 165.652H119.696",
    stroke: "#CCD5D3",
    style: (_ref144 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref144, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref144, "strokeOpacity", 1), _ref144),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask73 || (_mask73 = /*#__PURE__*/React.createElement("mask", {
    id: "path-221-inside-73_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 161.866H153.284V169.438H125.123V161.866Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 161.866H153.284V169.438H125.123V161.866Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 161.866V161.588H124.846V161.866H125.123ZM125.123 161.866V162.143H153.284V161.866V161.588H125.123V161.866ZM125.123 169.438H125.4V161.866H125.123H124.846V169.438H125.123Z",
    fill: "#EAEEED",
    style: (_ref145 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref145, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref145, "fillOpacity", 1), _ref145),
    mask: "url(#path-221-inside-73_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.551 165.652H147.856",
    stroke: "#CCD5D3",
    style: (_ref146 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref146, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref146, "strokeOpacity", 1), _ref146),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 169.438)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask74 || (_mask74 = /*#__PURE__*/React.createElement("mask", {
    id: "path-224-inside-74_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 169.438H12.4801V177.011H-15.6807V169.438Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 169.438H12.4801V177.011H-15.6807V169.438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 169.438V169.161H-15.958V169.438H-15.6807ZM-15.6807 169.438V169.716H12.4801V169.438V169.161H-15.6807V169.438ZM-15.6807 177.011H-15.4033V169.438H-15.6807H-15.958V177.011H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref147 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref147, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref147, "fillOpacity", 1), _ref147),
    mask: "url(#path-224-inside-74_17113_221003)"
  }), _mask75 || (_mask75 = /*#__PURE__*/React.createElement("mask", {
    id: "path-226-inside-75_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 169.438H40.6413V177.011H12.4805V169.438Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 169.438H40.6413V177.011H12.4805V169.438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 169.438V169.161H12.2031V169.438H12.4805ZM12.4805 169.438V169.716H40.6413V169.438V169.161H12.4805V169.438ZM12.4805 177.011H12.7578V169.438H12.4805H12.2031V177.011H12.4805Z",
    fill: "#EAEEED",
    style: (_ref148 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref148, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref148, "fillOpacity", 1), _ref148),
    mask: "url(#path-226-inside-75_17113_221003)"
  }), _mask76 || (_mask76 = /*#__PURE__*/React.createElement("mask", {
    id: "path-228-inside-76_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 169.438H68.8014V177.011H40.6406V169.438Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 169.438H68.8014V177.011H40.6406V169.438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 169.438V169.161H40.3633V169.438H40.6406ZM40.6406 169.438V169.716H68.8014V169.438V169.161H40.6406V169.438ZM40.6406 177.011H40.918V169.438H40.6406H40.3633V177.011H40.6406Z",
    fill: "#EAEEED",
    style: (_ref149 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref149, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref149, "fillOpacity", 1), _ref149),
    mask: "url(#path-228-inside-76_17113_221003)"
  }), _mask77 || (_mask77 = /*#__PURE__*/React.createElement("mask", {
    id: "path-230-inside-77_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 169.438H96.9626V177.011H68.8018V169.438Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 169.438H96.9626V177.011H68.8018V169.438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 169.438V169.161H68.5244V169.438H68.8018ZM68.8018 169.438V169.716H96.9626V169.438V169.161H68.8018V169.438ZM68.8018 177.011H69.0791V169.438H68.8018H68.5244V177.011H68.8018Z",
    fill: "#EAEEED",
    style: (_ref150 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref150, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref150, "fillOpacity", 1), _ref150),
    mask: "url(#path-230-inside-77_17113_221003)"
  }), _mask78 || (_mask78 = /*#__PURE__*/React.createElement("mask", {
    id: "path-232-inside-78_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 169.438H125.124V177.011H96.9629V169.438Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 169.438H125.124V177.011H96.9629V169.438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 169.438V169.161H96.6855V169.438H96.9629ZM96.9629 169.438V169.716H125.124V169.438V169.161H96.9629V169.438ZM96.9629 177.011H97.2402V169.438H96.9629H96.6855V177.011H96.9629Z",
    fill: "#EAEEED",
    style: (_ref151 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref151, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref151, "fillOpacity", 1), _ref151),
    mask: "url(#path-232-inside-78_17113_221003)"
  }), _mask79 || (_mask79 = /*#__PURE__*/React.createElement("mask", {
    id: "path-234-inside-79_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 169.438H153.284V177.011H125.123V169.438Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 169.438H153.284V177.011H125.123V169.438Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 169.438V169.161H124.846V169.438H125.123ZM125.123 169.438V169.716H153.284V169.438V169.161H125.123V169.438ZM125.123 177.011H125.4V169.438H125.123H124.846V177.011H125.123Z",
    fill: "#EAEEED",
    style: (_ref152 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref152, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref152, "fillOpacity", 1), _ref152),
    mask: "url(#path-234-inside-79_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 177.011)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask80 || (_mask80 = /*#__PURE__*/React.createElement("mask", {
    id: "path-236-inside-80_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 177.011H12.4801V184.584H-15.6807V177.011Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 177.011H12.4801V184.584H-15.6807V177.011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 177.011V176.734H-15.958V177.011H-15.6807ZM-15.6807 177.011V177.288H12.4801V177.011V176.734H-15.6807V177.011ZM-15.6807 184.584H-15.4033V177.011H-15.6807H-15.958V184.584H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref153 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref153, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref153, "fillOpacity", 1), _ref153),
    mask: "url(#path-236-inside-80_17113_221003)"
  }), _mask81 || (_mask81 = /*#__PURE__*/React.createElement("mask", {
    id: "path-238-inside-81_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 177.011H40.6413V184.584H12.4805V177.011Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 177.011H40.6413V184.584H12.4805V177.011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 177.011V176.734H12.2031V177.011H12.4805ZM12.4805 177.011V177.288H40.6413V177.011V176.734H12.4805V177.011ZM12.4805 184.584H12.7578V177.011H12.4805H12.2031V184.584H12.4805Z",
    fill: "#EAEEED",
    style: (_ref154 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref154, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref154, "fillOpacity", 1), _ref154),
    mask: "url(#path-238-inside-81_17113_221003)"
  }), _mask82 || (_mask82 = /*#__PURE__*/React.createElement("mask", {
    id: "path-240-inside-82_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 177.011H68.8014V184.584H40.6406V177.011Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 177.011H68.8014V184.584H40.6406V177.011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 177.011V176.734H40.3633V177.011H40.6406ZM40.6406 177.011V177.288H68.8014V177.011V176.734H40.6406V177.011ZM40.6406 184.584H40.918V177.011H40.6406H40.3633V184.584H40.6406Z",
    fill: "#EAEEED",
    style: (_ref155 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref155, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref155, "fillOpacity", 1), _ref155),
    mask: "url(#path-240-inside-82_17113_221003)"
  }), _mask83 || (_mask83 = /*#__PURE__*/React.createElement("mask", {
    id: "path-242-inside-83_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 177.011H96.9626V184.584H68.8018V177.011Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 177.011H96.9626V184.584H68.8018V177.011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 177.011V176.734H68.5244V177.011H68.8018ZM68.8018 177.011V177.288H96.9626V177.011V176.734H68.8018V177.011ZM68.8018 184.584H69.0791V177.011H68.8018H68.5244V184.584H68.8018Z",
    fill: "#EAEEED",
    style: (_ref156 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref156, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref156, "fillOpacity", 1), _ref156),
    mask: "url(#path-242-inside-83_17113_221003)"
  }), _mask84 || (_mask84 = /*#__PURE__*/React.createElement("mask", {
    id: "path-244-inside-84_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 177.011H125.124V184.584H96.9629V177.011Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 177.011H125.124V184.584H96.9629V177.011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 177.011V176.734H96.6855V177.011H96.9629ZM96.9629 177.011V177.288H125.124V177.011V176.734H96.9629V177.011ZM96.9629 184.584H97.2402V177.011H96.9629H96.6855V184.584H96.9629Z",
    fill: "#EAEEED",
    style: (_ref157 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref157, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref157, "fillOpacity", 1), _ref157),
    mask: "url(#path-244-inside-84_17113_221003)"
  }), _mask85 || (_mask85 = /*#__PURE__*/React.createElement("mask", {
    id: "path-246-inside-85_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 177.011H153.284V184.584H125.123V177.011Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 177.011H153.284V184.584H125.123V177.011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 177.011V176.734H124.846V177.011H125.123ZM125.123 177.011V177.288H153.284V177.011V176.734H125.123V177.011ZM125.123 184.584H125.4V177.011H125.123H124.846V184.584H125.123Z",
    fill: "#EAEEED",
    style: (_ref158 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref158, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref158, "fillOpacity", 1), _ref158),
    mask: "url(#path-246-inside-85_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 184.584)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask86 || (_mask86 = /*#__PURE__*/React.createElement("mask", {
    id: "path-248-inside-86_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 184.584H12.4801V192.156H-15.6807V184.584Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 184.584H12.4801V192.156H-15.6807V184.584Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 184.584V184.306H-15.958V184.584H-15.6807ZM-15.6807 184.584V184.861H12.4801V184.584V184.306H-15.6807V184.584ZM-15.6807 192.156H-15.4033V184.584H-15.6807H-15.958V192.156H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref159 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref159, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref159, "fillOpacity", 1), _ref159),
    mask: "url(#path-248-inside-86_17113_221003)"
  }), _mask87 || (_mask87 = /*#__PURE__*/React.createElement("mask", {
    id: "path-250-inside-87_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 184.584H40.6413V192.156H12.4805V184.584Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 184.584H40.6413V192.156H12.4805V184.584Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 184.584V184.306H12.2031V184.584H12.4805ZM12.4805 184.584V184.861H40.6413V184.584V184.306H12.4805V184.584ZM12.4805 192.156H12.7578V184.584H12.4805H12.2031V192.156H12.4805Z",
    fill: "#EAEEED",
    style: (_ref160 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref160, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref160, "fillOpacity", 1), _ref160),
    mask: "url(#path-250-inside-87_17113_221003)"
  }), _mask88 || (_mask88 = /*#__PURE__*/React.createElement("mask", {
    id: "path-252-inside-88_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 184.584H68.8014V192.156H40.6406V184.584Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 184.584H68.8014V192.156H40.6406V184.584Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 184.584V184.306H40.3633V184.584H40.6406ZM40.6406 184.584V184.861H68.8014V184.584V184.306H40.6406V184.584ZM40.6406 192.156H40.918V184.584H40.6406H40.3633V192.156H40.6406Z",
    fill: "#EAEEED",
    style: (_ref161 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref161, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref161, "fillOpacity", 1), _ref161),
    mask: "url(#path-252-inside-88_17113_221003)"
  }), _mask89 || (_mask89 = /*#__PURE__*/React.createElement("mask", {
    id: "path-254-inside-89_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 184.584H96.9626V192.156H68.8018V184.584Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 184.584H96.9626V192.156H68.8018V184.584Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 184.584V184.306H68.5244V184.584H68.8018ZM68.8018 184.584V184.861H96.9626V184.584V184.306H68.8018V184.584ZM68.8018 192.156H69.0791V184.584H68.8018H68.5244V192.156H68.8018Z",
    fill: "#EAEEED",
    style: (_ref162 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref162, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref162, "fillOpacity", 1), _ref162),
    mask: "url(#path-254-inside-89_17113_221003)"
  }), _mask90 || (_mask90 = /*#__PURE__*/React.createElement("mask", {
    id: "path-256-inside-90_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 184.584H125.124V192.156H96.9629V184.584Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 184.584H125.124V192.156H96.9629V184.584Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 184.584V184.306H96.6855V184.584H96.9629ZM96.9629 184.584V184.861H125.124V184.584V184.306H96.9629V184.584ZM96.9629 192.156H97.2402V184.584H96.9629H96.6855V192.156H96.9629Z",
    fill: "#EAEEED",
    style: (_ref163 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref163, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref163, "fillOpacity", 1), _ref163),
    mask: "url(#path-256-inside-90_17113_221003)"
  }), _mask91 || (_mask91 = /*#__PURE__*/React.createElement("mask", {
    id: "path-258-inside-91_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 184.584H153.284V192.156H125.123V184.584Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 184.584H153.284V192.156H125.123V184.584Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 184.584V184.306H124.846V184.584H125.123ZM125.123 184.584V184.861H153.284V184.584V184.306H125.123V184.584ZM125.123 192.156H125.4V184.584H125.123H124.846V192.156H125.123Z",
    fill: "#EAEEED",
    style: (_ref164 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref164, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref164, "fillOpacity", 1), _ref164),
    mask: "url(#path-258-inside-91_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 192.156)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask92 || (_mask92 = /*#__PURE__*/React.createElement("mask", {
    id: "path-260-inside-92_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 192.156H12.4801V199.729H-15.6807V192.156Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 192.156H12.4801V199.729H-15.6807V192.156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 192.156V191.879H-15.958V192.156H-15.6807ZM-15.6807 192.156V192.434H12.4801V192.156V191.879H-15.6807V192.156ZM-15.6807 199.729H-15.4033V192.156H-15.6807H-15.958V199.729H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref165 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref165, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref165, "fillOpacity", 1), _ref165),
    mask: "url(#path-260-inside-92_17113_221003)"
  }), _mask93 || (_mask93 = /*#__PURE__*/React.createElement("mask", {
    id: "path-262-inside-93_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 192.156H40.6413V199.729H12.4805V192.156Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 192.156H40.6413V199.729H12.4805V192.156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 192.156V191.879H12.2031V192.156H12.4805ZM12.4805 192.156V192.434H40.6413V192.156V191.879H12.4805V192.156ZM12.4805 199.729H12.7578V192.156H12.4805H12.2031V199.729H12.4805Z",
    fill: "#EAEEED",
    style: (_ref166 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref166, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref166, "fillOpacity", 1), _ref166),
    mask: "url(#path-262-inside-93_17113_221003)"
  }), _mask94 || (_mask94 = /*#__PURE__*/React.createElement("mask", {
    id: "path-264-inside-94_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 192.156H68.8014V199.729H40.6406V192.156Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 192.156H68.8014V199.729H40.6406V192.156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 192.156V191.879H40.3633V192.156H40.6406ZM40.6406 192.156V192.434H68.8014V192.156V191.879H40.6406V192.156ZM40.6406 199.729H40.918V192.156H40.6406H40.3633V199.729H40.6406Z",
    fill: "#EAEEED",
    style: (_ref167 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref167, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref167, "fillOpacity", 1), _ref167),
    mask: "url(#path-264-inside-94_17113_221003)"
  }), _mask95 || (_mask95 = /*#__PURE__*/React.createElement("mask", {
    id: "path-266-inside-95_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 192.156H96.9626V199.729H68.8018V192.156Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 192.156H96.9626V199.729H68.8018V192.156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 192.156V191.879H68.5244V192.156H68.8018ZM68.8018 192.156V192.434H96.9626V192.156V191.879H68.8018V192.156ZM68.8018 199.729H69.0791V192.156H68.8018H68.5244V199.729H68.8018Z",
    fill: "#EAEEED",
    style: (_ref168 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref168, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref168, "fillOpacity", 1), _ref168),
    mask: "url(#path-266-inside-95_17113_221003)"
  }), _mask96 || (_mask96 = /*#__PURE__*/React.createElement("mask", {
    id: "path-268-inside-96_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 192.156H125.124V199.729H96.9629V192.156Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 192.156H125.124V199.729H96.9629V192.156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 192.156V191.879H96.6855V192.156H96.9629ZM96.9629 192.156V192.434H125.124V192.156V191.879H96.9629V192.156ZM96.9629 199.729H97.2402V192.156H96.9629H96.6855V199.729H96.9629Z",
    fill: "#EAEEED",
    style: (_ref169 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref169, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref169, "fillOpacity", 1), _ref169),
    mask: "url(#path-268-inside-96_17113_221003)"
  }), _mask97 || (_mask97 = /*#__PURE__*/React.createElement("mask", {
    id: "path-270-inside-97_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 192.156H153.284V199.729H125.123V192.156Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 192.156H153.284V199.729H125.123V192.156Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 192.156V191.879H124.846V192.156H125.123ZM125.123 192.156V192.434H153.284V192.156V191.879H125.123V192.156ZM125.123 199.729H125.4V192.156H125.123H124.846V199.729H125.123Z",
    fill: "#EAEEED",
    style: (_ref170 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref170, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref170, "fillOpacity", 1), _ref170),
    mask: "url(#path-270-inside-97_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 199.729)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask98 || (_mask98 = /*#__PURE__*/React.createElement("mask", {
    id: "path-272-inside-98_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 199.729H12.4801V207.302H-15.6807V199.729Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 199.729H12.4801V207.302H-15.6807V199.729Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 199.729V199.452H-15.958V199.729H-15.6807ZM-15.6807 199.729V200.006H12.4801V199.729V199.452H-15.6807V199.729ZM-15.6807 207.302H-15.4033V199.729H-15.6807H-15.958V207.302H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref171 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref171, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref171, "fillOpacity", 1), _ref171),
    mask: "url(#path-272-inside-98_17113_221003)"
  }), _mask99 || (_mask99 = /*#__PURE__*/React.createElement("mask", {
    id: "path-274-inside-99_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 199.729H40.6413V207.302H12.4805V199.729Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 199.729H40.6413V207.302H12.4805V199.729Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 199.729V199.452H12.2031V199.729H12.4805ZM12.4805 199.729V200.006H40.6413V199.729V199.452H12.4805V199.729ZM12.4805 207.302H12.7578V199.729H12.4805H12.2031V207.302H12.4805Z",
    fill: "#EAEEED",
    style: (_ref172 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref172, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref172, "fillOpacity", 1), _ref172),
    mask: "url(#path-274-inside-99_17113_221003)"
  }), _mask100 || (_mask100 = /*#__PURE__*/React.createElement("mask", {
    id: "path-276-inside-100_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 199.729H68.8014V207.302H40.6406V199.729Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 199.729H68.8014V207.302H40.6406V199.729Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 199.729V199.452H40.3633V199.729H40.6406ZM40.6406 199.729V200.006H68.8014V199.729V199.452H40.6406V199.729ZM40.6406 207.302H40.918V199.729H40.6406H40.3633V207.302H40.6406Z",
    fill: "#EAEEED",
    style: (_ref173 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref173, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref173, "fillOpacity", 1), _ref173),
    mask: "url(#path-276-inside-100_17113_221003)"
  }), _mask101 || (_mask101 = /*#__PURE__*/React.createElement("mask", {
    id: "path-278-inside-101_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 199.729H96.9626V207.302H68.8018V199.729Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 199.729H96.9626V207.302H68.8018V199.729Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 199.729V199.452H68.5244V199.729H68.8018ZM68.8018 199.729V200.006H96.9626V199.729V199.452H68.8018V199.729ZM68.8018 207.302H69.0791V199.729H68.8018H68.5244V207.302H68.8018Z",
    fill: "#EAEEED",
    style: (_ref174 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref174, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref174, "fillOpacity", 1), _ref174),
    mask: "url(#path-278-inside-101_17113_221003)"
  }), _mask102 || (_mask102 = /*#__PURE__*/React.createElement("mask", {
    id: "path-280-inside-102_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 199.729H125.124V207.302H96.9629V199.729Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 199.729H125.124V207.302H96.9629V199.729Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 199.729V199.452H96.6855V199.729H96.9629ZM96.9629 199.729V200.006H125.124V199.729V199.452H96.9629V199.729ZM96.9629 207.302H97.2402V199.729H96.9629H96.6855V207.302H96.9629Z",
    fill: "#EAEEED",
    style: (_ref175 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref175, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref175, "fillOpacity", 1), _ref175),
    mask: "url(#path-280-inside-102_17113_221003)"
  }), _mask103 || (_mask103 = /*#__PURE__*/React.createElement("mask", {
    id: "path-282-inside-103_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 199.729H153.284V207.302H125.123V199.729Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 199.729H153.284V207.302H125.123V199.729Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 199.729V199.452H124.846V199.729H125.123ZM125.123 199.729V200.006H153.284V199.729V199.452H125.123V199.729ZM125.123 207.302H125.4V199.729H125.123H124.846V207.302H125.123Z",
    fill: "#EAEEED",
    style: (_ref176 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref176, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref176, "fillOpacity", 1), _ref176),
    mask: "url(#path-282-inside-103_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 207.301)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask104 || (_mask104 = /*#__PURE__*/React.createElement("mask", {
    id: "path-284-inside-104_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 207.301H12.4801V214.874H-15.6807V207.301Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 207.301H12.4801V214.874H-15.6807V207.301Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 207.301V207.024H-15.958V207.301H-15.6807ZM-15.6807 207.301V207.579H12.4801V207.301V207.024H-15.6807V207.301ZM-15.6807 214.874H-15.4033V207.301H-15.6807H-15.958V214.874H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref177 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref177, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref177, "fillOpacity", 1), _ref177),
    mask: "url(#path-284-inside-104_17113_221003)"
  }), _mask105 || (_mask105 = /*#__PURE__*/React.createElement("mask", {
    id: "path-286-inside-105_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 207.301H40.6413V214.874H12.4805V207.301Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 207.301H40.6413V214.874H12.4805V207.301Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 207.301V207.024H12.2031V207.301H12.4805ZM12.4805 207.301V207.579H40.6413V207.301V207.024H12.4805V207.301ZM12.4805 214.874H12.7578V207.301H12.4805H12.2031V214.874H12.4805Z",
    fill: "#EAEEED",
    style: (_ref178 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref178, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref178, "fillOpacity", 1), _ref178),
    mask: "url(#path-286-inside-105_17113_221003)"
  }), _mask106 || (_mask106 = /*#__PURE__*/React.createElement("mask", {
    id: "path-288-inside-106_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 207.301H68.8014V214.874H40.6406V207.301Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 207.301H68.8014V214.874H40.6406V207.301Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 207.301V207.024H40.3633V207.301H40.6406ZM40.6406 207.301V207.579H68.8014V207.301V207.024H40.6406V207.301ZM40.6406 214.874H40.918V207.301H40.6406H40.3633V214.874H40.6406Z",
    fill: "#EAEEED",
    style: (_ref179 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref179, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref179, "fillOpacity", 1), _ref179),
    mask: "url(#path-288-inside-106_17113_221003)"
  }), _mask107 || (_mask107 = /*#__PURE__*/React.createElement("mask", {
    id: "path-290-inside-107_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 207.301H96.9626V214.874H68.8018V207.301Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 207.301H96.9626V214.874H68.8018V207.301Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 207.301V207.024H68.5244V207.301H68.8018ZM68.8018 207.301V207.579H96.9626V207.301V207.024H68.8018V207.301ZM68.8018 214.874H69.0791V207.301H68.8018H68.5244V214.874H68.8018Z",
    fill: "#EAEEED",
    style: (_ref180 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref180, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref180, "fillOpacity", 1), _ref180),
    mask: "url(#path-290-inside-107_17113_221003)"
  }), _mask108 || (_mask108 = /*#__PURE__*/React.createElement("mask", {
    id: "path-292-inside-108_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 207.301H125.124V214.874H96.9629V207.301Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 207.301H125.124V214.874H96.9629V207.301Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 207.301V207.024H96.6855V207.301H96.9629ZM96.9629 207.301V207.579H125.124V207.301V207.024H96.9629V207.301ZM96.9629 214.874H97.2402V207.301H96.9629H96.6855V214.874H96.9629Z",
    fill: "#EAEEED",
    style: (_ref181 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref181, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref181, "fillOpacity", 1), _ref181),
    mask: "url(#path-292-inside-108_17113_221003)"
  }), _mask109 || (_mask109 = /*#__PURE__*/React.createElement("mask", {
    id: "path-294-inside-109_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 207.301H153.284V214.874H125.123V207.301Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 207.301H153.284V214.874H125.123V207.301Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 207.301V207.024H124.846V207.301H125.123ZM125.123 207.301V207.579H153.284V207.301V207.024H125.123V207.301ZM125.123 214.874H125.4V207.301H125.123H124.846V214.874H125.123Z",
    fill: "#EAEEED",
    style: (_ref182 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref182, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref182, "fillOpacity", 1), _ref182),
    mask: "url(#path-294-inside-109_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 214.874)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask110 || (_mask110 = /*#__PURE__*/React.createElement("mask", {
    id: "path-296-inside-110_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 214.874H12.4801V222.447H-15.6807V214.874Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 214.874H12.4801V222.447H-15.6807V214.874Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 214.874V214.597H-15.958V214.874H-15.6807ZM-15.6807 214.874V215.151H12.4801V214.874V214.597H-15.6807V214.874ZM-15.6807 222.447H-15.4033V214.874H-15.6807H-15.958V222.447H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref183 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref183, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref183, "fillOpacity", 1), _ref183),
    mask: "url(#path-296-inside-110_17113_221003)"
  }), _mask111 || (_mask111 = /*#__PURE__*/React.createElement("mask", {
    id: "path-298-inside-111_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 214.874H40.6413V222.447H12.4805V214.874Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 214.874H40.6413V222.447H12.4805V214.874Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 214.874V214.597H12.2031V214.874H12.4805ZM12.4805 214.874V215.151H40.6413V214.874V214.597H12.4805V214.874ZM12.4805 222.447H12.7578V214.874H12.4805H12.2031V222.447H12.4805Z",
    fill: "#EAEEED",
    style: (_ref184 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref184, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref184, "fillOpacity", 1), _ref184),
    mask: "url(#path-298-inside-111_17113_221003)"
  }), _mask112 || (_mask112 = /*#__PURE__*/React.createElement("mask", {
    id: "path-300-inside-112_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 214.874H68.8014V222.447H40.6406V214.874Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 214.874H68.8014V222.447H40.6406V214.874Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 214.874V214.597H40.3633V214.874H40.6406ZM40.6406 214.874V215.151H68.8014V214.874V214.597H40.6406V214.874ZM40.6406 222.447H40.918V214.874H40.6406H40.3633V222.447H40.6406Z",
    fill: "#EAEEED",
    style: (_ref185 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref185, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref185, "fillOpacity", 1), _ref185),
    mask: "url(#path-300-inside-112_17113_221003)"
  }), _mask113 || (_mask113 = /*#__PURE__*/React.createElement("mask", {
    id: "path-302-inside-113_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 214.874H96.9626V222.447H68.8018V214.874Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 214.874H96.9626V222.447H68.8018V214.874Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 214.874V214.597H68.5244V214.874H68.8018ZM68.8018 214.874V215.151H96.9626V214.874V214.597H68.8018V214.874ZM68.8018 222.447H69.0791V214.874H68.8018H68.5244V222.447H68.8018Z",
    fill: "#EAEEED",
    style: (_ref186 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref186, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref186, "fillOpacity", 1), _ref186),
    mask: "url(#path-302-inside-113_17113_221003)"
  }), _mask114 || (_mask114 = /*#__PURE__*/React.createElement("mask", {
    id: "path-304-inside-114_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 214.874H125.124V222.447H96.9629V214.874Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 214.874H125.124V222.447H96.9629V214.874Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 214.874V214.597H96.6855V214.874H96.9629ZM96.9629 214.874V215.151H125.124V214.874V214.597H96.9629V214.874ZM96.9629 222.447H97.2402V214.874H96.9629H96.6855V222.447H96.9629Z",
    fill: "#EAEEED",
    style: (_ref187 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref187, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref187, "fillOpacity", 1), _ref187),
    mask: "url(#path-304-inside-114_17113_221003)"
  }), _mask115 || (_mask115 = /*#__PURE__*/React.createElement("mask", {
    id: "path-306-inside-115_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 214.874H153.284V222.447H125.123V214.874Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 214.874H153.284V222.447H125.123V214.874Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 214.874V214.597H124.846V214.874H125.123ZM125.123 214.874V215.151H153.284V214.874V214.597H125.123V214.874ZM125.123 222.447H125.4V214.874H125.123H124.846V222.447H125.123Z",
    fill: "#EAEEED",
    style: (_ref188 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref188, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref188, "fillOpacity", 1), _ref188),
    mask: "url(#path-306-inside-115_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 222.447)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask116 || (_mask116 = /*#__PURE__*/React.createElement("mask", {
    id: "path-308-inside-116_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 222.447H12.4801V230.019H-15.6807V222.447Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 222.447H12.4801V230.019H-15.6807V222.447Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 222.447V222.169H-15.958V222.447H-15.6807ZM-15.6807 222.447V222.724H12.4801V222.447V222.169H-15.6807V222.447ZM-15.6807 230.019H-15.4033V222.447H-15.6807H-15.958V230.019H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref189 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref189, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref189, "fillOpacity", 1), _ref189),
    mask: "url(#path-308-inside-116_17113_221003)"
  }), _mask117 || (_mask117 = /*#__PURE__*/React.createElement("mask", {
    id: "path-310-inside-117_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 222.447H40.6413V230.019H12.4805V222.447Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 222.447H40.6413V230.019H12.4805V222.447Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 222.447V222.169H12.2031V222.447H12.4805ZM12.4805 222.447V222.724H40.6413V222.447V222.169H12.4805V222.447ZM12.4805 230.019H12.7578V222.447H12.4805H12.2031V230.019H12.4805Z",
    fill: "#EAEEED",
    style: (_ref190 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref190, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref190, "fillOpacity", 1), _ref190),
    mask: "url(#path-310-inside-117_17113_221003)"
  }), _mask118 || (_mask118 = /*#__PURE__*/React.createElement("mask", {
    id: "path-312-inside-118_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 222.447H68.8014V230.019H40.6406V222.447Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 222.447H68.8014V230.019H40.6406V222.447Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 222.447V222.169H40.3633V222.447H40.6406ZM40.6406 222.447V222.724H68.8014V222.447V222.169H40.6406V222.447ZM40.6406 230.019H40.918V222.447H40.6406H40.3633V230.019H40.6406Z",
    fill: "#EAEEED",
    style: (_ref191 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref191, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref191, "fillOpacity", 1), _ref191),
    mask: "url(#path-312-inside-118_17113_221003)"
  }), _mask119 || (_mask119 = /*#__PURE__*/React.createElement("mask", {
    id: "path-314-inside-119_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 222.447H96.9626V230.019H68.8018V222.447Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 222.447H96.9626V230.019H68.8018V222.447Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 222.447V222.169H68.5244V222.447H68.8018ZM68.8018 222.447V222.724H96.9626V222.447V222.169H68.8018V222.447ZM68.8018 230.019H69.0791V222.447H68.8018H68.5244V230.019H68.8018Z",
    fill: "#EAEEED",
    style: (_ref192 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref192, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref192, "fillOpacity", 1), _ref192),
    mask: "url(#path-314-inside-119_17113_221003)"
  }), _mask120 || (_mask120 = /*#__PURE__*/React.createElement("mask", {
    id: "path-316-inside-120_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 222.447H125.124V230.019H96.9629V222.447Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 222.447H125.124V230.019H96.9629V222.447Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 222.447V222.169H96.6855V222.447H96.9629ZM96.9629 222.447V222.724H125.124V222.447V222.169H96.9629V222.447ZM96.9629 230.019H97.2402V222.447H96.9629H96.6855V230.019H96.9629Z",
    fill: "#EAEEED",
    style: (_ref193 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref193, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref193, "fillOpacity", 1), _ref193),
    mask: "url(#path-316-inside-120_17113_221003)"
  }), _mask121 || (_mask121 = /*#__PURE__*/React.createElement("mask", {
    id: "path-318-inside-121_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 222.447H153.284V230.019H125.123V222.447Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 222.447H153.284V230.019H125.123V222.447Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 222.447V222.169H124.846V222.447H125.123ZM125.123 222.447V222.724H153.284V222.447V222.169H125.123V222.447ZM125.123 230.019H125.4V222.447H125.123H124.846V230.019H125.123Z",
    fill: "#EAEEED",
    style: (_ref194 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref194, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref194, "fillOpacity", 1), _ref194),
    mask: "url(#path-318-inside-121_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(-24.001 230.019)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask122 || (_mask122 = /*#__PURE__*/React.createElement("mask", {
    id: "path-320-inside-122_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 230.019H12.4801V237.592H-15.6807V230.019Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 230.019H12.4801V237.592H-15.6807V230.019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.6807 230.019V229.742H-15.958V230.019H-15.6807ZM-15.6807 230.019V230.297H12.4801V230.019V229.742H-15.6807V230.019ZM-15.6807 237.592H-15.4033V230.019H-15.6807H-15.958V237.592H-15.6807Z",
    fill: "#EAEEED",
    style: (_ref195 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref195, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref195, "fillOpacity", 1), _ref195),
    mask: "url(#path-320-inside-122_17113_221003)"
  }), _mask123 || (_mask123 = /*#__PURE__*/React.createElement("mask", {
    id: "path-322-inside-123_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 230.019H40.6413V237.592H12.4805V230.019Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 230.019H40.6413V237.592H12.4805V230.019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 230.019V229.742H12.2031V230.019H12.4805ZM12.4805 230.019V230.297H40.6413V230.019V229.742H12.4805V230.019ZM12.4805 237.592H12.7578V230.019H12.4805H12.2031V237.592H12.4805Z",
    fill: "#EAEEED",
    style: (_ref196 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref196, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref196, "fillOpacity", 1), _ref196),
    mask: "url(#path-322-inside-123_17113_221003)"
  }), _mask124 || (_mask124 = /*#__PURE__*/React.createElement("mask", {
    id: "path-324-inside-124_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 230.019H68.8014V237.592H40.6406V230.019Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 230.019H68.8014V237.592H40.6406V230.019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 230.019V229.742H40.3633V230.019H40.6406ZM40.6406 230.019V230.297H68.8014V230.019V229.742H40.6406V230.019ZM40.6406 237.592H40.918V230.019H40.6406H40.3633V237.592H40.6406Z",
    fill: "#EAEEED",
    style: (_ref197 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref197, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref197, "fillOpacity", 1), _ref197),
    mask: "url(#path-324-inside-124_17113_221003)"
  }), _mask125 || (_mask125 = /*#__PURE__*/React.createElement("mask", {
    id: "path-326-inside-125_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 230.019H96.9626V237.592H68.8018V230.019Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 230.019H96.9626V237.592H68.8018V230.019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8018 230.019V229.742H68.5244V230.019H68.8018ZM68.8018 230.019V230.297H96.9626V230.019V229.742H68.8018V230.019ZM68.8018 237.592H69.0791V230.019H68.8018H68.5244V237.592H68.8018Z",
    fill: "#EAEEED",
    style: (_ref198 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref198, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref198, "fillOpacity", 1), _ref198),
    mask: "url(#path-326-inside-125_17113_221003)"
  }), _mask126 || (_mask126 = /*#__PURE__*/React.createElement("mask", {
    id: "path-328-inside-126_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 230.019H125.124V237.592H96.9629V230.019Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 230.019H125.124V237.592H96.9629V230.019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9629 230.019V229.742H96.6855V230.019H96.9629ZM96.9629 230.019V230.297H125.124V230.019V229.742H96.9629V230.019ZM96.9629 237.592H97.2402V230.019H96.9629H96.6855V237.592H96.9629Z",
    fill: "#EAEEED",
    style: (_ref199 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref199, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref199, "fillOpacity", 1), _ref199),
    mask: "url(#path-328-inside-126_17113_221003)"
  }), _mask127 || (_mask127 = /*#__PURE__*/React.createElement("mask", {
    id: "path-330-inside-127_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.123 230.019H153.284V237.592H125.123V230.019Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 230.019H153.284V237.592H125.123V230.019Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.123 230.019V229.742H124.846V230.019H125.123ZM125.123 230.019V230.297H153.284V230.019V229.742H125.123V230.019ZM125.123 237.592H125.4V230.019H125.123H124.846V237.592H125.123Z",
    fill: "#EAEEED",
    style: (_ref200 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref200, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref200, "fillOpacity", 1), _ref200),
    mask: "url(#path-330-inside-127_17113_221003)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -24.0703,
    y: 66.6564,
    width: 374.549,
    height: 208.145,
    rx: 2.28806,
    stroke: "#EAEEED",
    style: (_ref201 = {
      stroke: "#EAEEED"
    }, _defineProperty(_ref201, "stroke", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref201, "strokeOpacity", 1), _ref201),
    strokeWidth: 0.138671,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -23.8206,
    y: 66.9051,
    width: 168.5,
    height: 169.962,
    rx: 5.68596,
    stroke: "#C2E6D1",
    style: (_ref202 = {
      stroke: "#C2E6D1"
    }, _defineProperty(_ref202, "stroke", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref202, "strokeOpacity", 1), _ref202),
    strokeWidth: 0.358752
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.992,
    y: 50.6439,
    width: 169.589,
    height: 138.157,
    rx: 5.86533,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17113_221003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 9.98428,
    transform: "translate(206.992 50.6439)",
    fill: "#E4F2E6",
    style: (_ref203 = {
      fill: "#E4F2E6"
    }, _defineProperty(_ref203, "fill", "color(display-p3 0.8941 0.9490 0.9020)"), _defineProperty(_ref203, "fillOpacity", 1), _ref203)
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_17113_221003)"
  }, _mask128 || (_mask128 = /*#__PURE__*/React.createElement("mask", {
    id: "path-336-inside-128_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 60.6282H581.403V70.0578H206.992V60.6282Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 60.6282H581.403V70.0578H206.992V60.6282Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.32023,
    height: 9.4296,
    transform: "translate(206.992 60.6282)",
    fill: "#FAFAFA",
    style: (_ref204 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref204, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref204, "fillOpacity", 1), _ref204)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.896 69.6418H207.914L214.896 61.7278V69.6418Z",
    fill: "#EAEEED",
    stroke: "#FAFAFA",
    style: (_ref205 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref205, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref205, "fillOpacity", 1), _defineProperty(_ref205, "stroke", "#FAFAFA"), _defineProperty(_ref205, "stroke", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref205, "strokeOpacity", 1), _ref205),
    strokeWidth: 0.832024,
    strokeLinejoin: "round"
  }), _mask129 || (_mask129 = /*#__PURE__*/React.createElement("mask", {
    id: "path-339-inside-129_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 60.6282H243.473V70.0578H215.312V60.6282Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 60.6282H243.473V70.0578H215.312V60.6282Z",
    fill: "#FAFAFA",
    style: (_ref206 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref206, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref206, "fillOpacity", 1), _ref206)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 70.0578H215.59V60.6282H215.312H215.035V70.0578H215.312Z",
    fill: "url(#paint6_linear_17113_221003)",
    style: {},
    mask: "url(#path-339-inside-129_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22 66.6282L229.222 63.9102H229.568L230.565 66.6282H230.22L229.393 64.3179L228.562 66.6282H228.22ZM228.678 65.9293L228.772 65.6652H230.002L230.096 65.9293H228.678Z",
    fill: "#7F7F7D",
    style: (_ref207 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref207, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref207, "fillOpacity", 1), _ref207)
  }), _mask130 || (_mask130 = /*#__PURE__*/React.createElement("mask", {
    id: "path-342-inside-130_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 60.6282H271.634V70.0578H243.474V60.6282Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 60.6282H271.634V70.0578H243.474V60.6282Z",
    fill: "#FAFAFA",
    style: (_ref208 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref208, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref208, "fillOpacity", 1), _ref208)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 70.0578H243.751V60.6282H243.474H243.196V70.0578H243.474Z",
    fill: "url(#paint7_linear_17113_221003)",
    style: {},
    mask: "url(#path-342-inside-130_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.675 66.6282V63.9102H257.631C257.822 63.9102 257.98 63.9413 258.104 64.0034C258.231 64.063 258.326 64.1458 258.388 64.2519C258.45 64.3555 258.481 64.4719 258.481 64.6014C258.481 64.7411 258.45 64.8576 258.388 64.9508C258.328 65.044 258.249 65.1152 258.151 65.1644C258.055 65.2135 257.953 65.2433 257.844 65.2537L257.899 65.2148C258.015 65.2174 258.122 65.2485 258.221 65.308C258.319 65.3676 258.397 65.4478 258.454 65.5488C258.513 65.6497 258.543 65.7623 258.543 65.8866C258.543 66.0238 258.509 66.1493 258.442 66.2632C258.375 66.3745 258.275 66.4638 258.143 66.5311C258.014 66.5958 257.853 66.6282 257.662 66.6282H256.675ZM257.002 66.3564H257.627C257.811 66.3564 257.953 66.3137 258.054 66.2282C258.157 66.1402 258.209 66.0186 258.209 65.8633C258.209 65.7105 258.156 65.5889 258.05 65.4983C257.946 65.4051 257.803 65.3585 257.619 65.3585H257.002V66.3564ZM257.002 65.0984H257.607C257.783 65.0984 257.917 65.0569 258.007 64.9741C258.1 64.8913 258.147 64.7787 258.147 64.6363C258.147 64.4991 258.1 64.3891 258.007 64.3063C257.917 64.2234 257.779 64.182 257.596 64.182H257.002V65.0984Z",
    fill: "#7F7F7D",
    style: (_ref209 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref209, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref209, "fillOpacity", 1), _ref209)
  }), _mask131 || (_mask131 = /*#__PURE__*/React.createElement("mask", {
    id: "path-345-inside-131_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 60.6282H299.795V70.0578H271.634V60.6282Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 60.6282H299.795V70.0578H271.634V60.6282Z",
    fill: "#FAFAFA",
    style: (_ref210 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref210, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref210, "fillOpacity", 1), _ref210)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 70.0578H271.911V60.6282H271.634H271.356V70.0578H271.634Z",
    fill: "url(#paint8_linear_17113_221003)",
    style: {},
    mask: "url(#path-345-inside-131_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.794 66.6748C285.53 66.6748 285.301 66.6165 285.107 66.5C284.915 66.381 284.768 66.2166 284.664 66.0069C284.561 65.7947 284.509 65.5488 284.509 65.2692C284.509 64.9896 284.561 64.745 284.664 64.5354C284.768 64.3231 284.915 64.1587 285.107 64.0422C285.301 63.9232 285.53 63.8636 285.794 63.8636C286.105 63.8636 286.357 63.9374 286.551 64.085C286.745 64.2325 286.87 64.4409 286.924 64.7101H286.563C286.522 64.5418 286.437 64.4072 286.311 64.3063C286.184 64.2027 286.012 64.151 285.794 64.151C285.6 64.151 285.432 64.1963 285.289 64.2869C285.147 64.3749 285.037 64.503 284.959 64.6713C284.882 64.8369 284.843 65.0362 284.843 65.2692C284.843 65.5022 284.882 65.7028 284.959 65.871C285.037 66.0367 285.147 66.1648 285.289 66.2554C285.432 66.3434 285.6 66.3874 285.794 66.3874C286.012 66.3874 286.184 66.3383 286.311 66.2399C286.437 66.1389 286.522 66.0056 286.563 65.84H286.924C286.87 66.1014 286.745 66.3059 286.551 66.4534C286.357 66.601 286.105 66.6748 285.794 66.6748Z",
    fill: "#7F7F7D",
    style: (_ref211 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref211, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref211, "fillOpacity", 1), _ref211)
  }), _mask132 || (_mask132 = /*#__PURE__*/React.createElement("mask", {
    id: "path-348-inside-132_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 60.6282H327.956V70.0578H299.795V60.6282Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 60.6282H327.956V70.0578H299.795V60.6282Z",
    fill: "#FAFAFA",
    style: (_ref212 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref212, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref212, "fillOpacity", 1), _ref212)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 70.0578H300.072V60.6282H299.795H299.518V70.0578H299.795Z",
    fill: "url(#paint9_linear_17113_221003)",
    style: {},
    mask: "url(#path-348-inside-132_17113_221003)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 60.6282V60.9055H581.403V60.6282V60.3508H206.992V60.6282Z",
    fill: "#EAEEED",
    style: (_ref213 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref213, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref213, "fillOpacity", 1), _ref213),
    mask: "url(#path-336-inside-128_17113_221003)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 70.0577)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask133 || (_mask133 = /*#__PURE__*/React.createElement("mask", {
    id: "path-350-inside-133_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 70.0577H215.312V77.6304H206.992V70.0577Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 70.0577H215.312V77.6304H206.992V70.0577Z",
    fill: "#FAFAFA",
    style: (_ref214 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref214, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref214, "fillOpacity", 1), _ref214)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 70.0577V70.3351H215.312V70.0577V69.7804H206.992V70.0577Z",
    fill: "url(#paint10_linear_17113_221003)",
    style: {},
    mask: "url(#path-350-inside-133_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.14 75.0577V73.0409L210.74 73.1408V72.9411L211.233 72.7281H211.423V75.0577H211.14Z",
    fill: "#7F7F7D",
    style: (_ref215 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref215, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref215, "fillOpacity", 1), _ref215)
  }), _mask134 || (_mask134 = /*#__PURE__*/React.createElement("mask", {
    id: "path-353-inside-134_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 70.0577H243.473V77.6304H215.312V70.0577Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 70.0577H243.473V77.6304H215.312V70.0577Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 70.0577V69.7804H215.035V70.0577H215.312ZM215.312 70.0577V70.3351H243.473V70.0577V69.7804H215.312V70.0577ZM215.312 77.6304H215.59V70.0577H215.312H215.035V77.6304H215.312Z",
    fill: "#EAEEED",
    style: (_ref216 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref216, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref216, "fillOpacity", 1), _ref216),
    mask: "url(#path-353-inside-134_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 73.844H238.045",
    stroke: "#99ABA7",
    style: (_ref217 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref217, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref217, "strokeOpacity", 1), _ref217),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask135 || (_mask135 = /*#__PURE__*/React.createElement("mask", {
    id: "path-356-inside-135_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 70.0577H271.634V77.6304H243.474V70.0577Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 70.0577H271.634V77.6304H243.474V70.0577Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 70.0577V69.7804H243.196V70.0577H243.474ZM243.474 70.0577V70.3351H271.634V70.0577V69.7804H243.474V70.0577ZM243.474 77.6304H243.751V70.0577H243.474H243.196V77.6304H243.474Z",
    fill: "#EAEEED",
    style: (_ref218 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref218, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref218, "fillOpacity", 1), _ref218),
    mask: "url(#path-356-inside-135_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 73.844H266.206",
    stroke: "#99ABA7",
    style: (_ref219 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref219, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref219, "strokeOpacity", 1), _ref219),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask136 || (_mask136 = /*#__PURE__*/React.createElement("mask", {
    id: "path-359-inside-136_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 70.0577H299.795V77.6304H271.634V70.0577Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 70.0577H299.795V77.6304H271.634V70.0577Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 70.0577V69.7804H271.356V70.0577H271.634ZM271.634 70.0577V70.3351H299.795V70.0577V69.7804H271.634V70.0577ZM271.634 77.6304H271.911V70.0577H271.634H271.356V77.6304H271.634Z",
    fill: "#EAEEED",
    style: (_ref220 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref220, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref220, "fillOpacity", 1), _ref220),
    mask: "url(#path-359-inside-136_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 73.844H294.367",
    stroke: "#99ABA7",
    style: (_ref221 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref221, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref221, "strokeOpacity", 1), _ref221),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask137 || (_mask137 = /*#__PURE__*/React.createElement("mask", {
    id: "path-362-inside-137_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 70.0577H327.956V77.6304H299.795V70.0577Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 70.0577H327.956V77.6304H299.795V70.0577Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 70.0577V69.7804H299.518V70.0577H299.795ZM299.795 70.0577V70.3351H327.956V70.0577V69.7804H299.795V70.0577ZM299.795 77.6304H300.072V70.0577H299.795H299.518V77.6304H299.795Z",
    fill: "#EAEEED",
    style: (_ref222 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref222, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref222, "fillOpacity", 1), _ref222),
    mask: "url(#path-362-inside-137_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 73.844H322.528",
    stroke: "#99ABA7",
    style: (_ref223 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref223, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref223, "strokeOpacity", 1), _ref223),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 77.6304)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask138 || (_mask138 = /*#__PURE__*/React.createElement("mask", {
    id: "path-365-inside-138_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 77.6304H215.312V85.203H206.992V77.6304Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 77.6304H215.312V85.203H206.992V77.6304Z",
    fill: "#FAFAFA",
    style: (_ref224 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref224, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref224, "fillOpacity", 1), _ref224)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 77.6304V77.9077H215.312V77.6304V77.353H206.992V77.6304Z",
    fill: "url(#paint11_linear_17113_221003)",
    style: {},
    mask: "url(#path-365-inside-138_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.407 82.6304V82.434C210.564 82.3098 210.714 82.1844 210.856 82.0579C211 81.9315 211.128 81.8061 211.239 81.6819C211.349 81.5554 211.436 81.4323 211.498 81.3124C211.562 81.1926 211.595 81.0773 211.595 80.9663C211.595 80.8842 211.58 80.8088 211.551 80.74C211.523 80.669 211.476 80.6113 211.412 80.567C211.349 80.5226 211.265 80.5004 211.159 80.5004C211.054 80.5004 210.968 80.5237 210.899 80.5703C210.83 80.6147 210.778 80.6746 210.743 80.75C210.709 80.8232 210.693 80.9042 210.693 80.9929H210.423C210.425 80.8399 210.458 80.709 210.52 80.6002C210.584 80.4893 210.672 80.405 210.783 80.3473C210.894 80.2896 211.02 80.2608 211.162 80.2608C211.302 80.2608 211.425 80.2874 211.531 80.3406C211.638 80.3917 211.721 80.4682 211.781 80.5703C211.843 80.6723 211.874 80.801 211.874 80.9563C211.874 81.0651 211.851 81.1738 211.804 81.2825C211.76 81.3912 211.7 81.4977 211.625 81.602C211.549 81.7041 211.465 81.8028 211.372 81.8982C211.281 81.9936 211.186 82.0835 211.089 82.1678C210.993 82.2521 210.904 82.3286 210.819 82.3974H211.954V82.6304H210.407Z",
    fill: "#7F7F7D",
    style: (_ref225 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref225, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref225, "fillOpacity", 1), _ref225)
  }), _mask139 || (_mask139 = /*#__PURE__*/React.createElement("mask", {
    id: "path-368-inside-139_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 77.6304H243.473V85.203H215.312V77.6304Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 77.6304H243.473V85.203H215.312V77.6304Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 77.6304V77.353H215.035V77.6304H215.312ZM215.312 77.6304V77.9077H243.473V77.6304V77.353H215.312V77.6304ZM215.312 85.203H215.59V77.6304H215.312H215.035V85.203H215.312Z",
    fill: "#EAEEED",
    style: (_ref226 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref226, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref226, "fillOpacity", 1), _ref226),
    mask: "url(#path-368-inside-139_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 81.4166H238.045",
    stroke: "#CCD5D3",
    style: (_ref227 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref227, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref227, "strokeOpacity", 1), _ref227),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask140 || (_mask140 = /*#__PURE__*/React.createElement("mask", {
    id: "path-371-inside-140_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 77.6304H271.634V85.203H243.474V77.6304Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 77.6304H271.634V85.203H243.474V77.6304Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 77.6304V77.353H243.196V77.6304H243.474ZM243.474 77.6304V77.9077H271.634V77.6304V77.353H243.474V77.6304ZM243.474 85.203H243.751V77.6304H243.474H243.196V85.203H243.474Z",
    fill: "#EAEEED",
    style: (_ref228 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref228, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref228, "fillOpacity", 1), _ref228),
    mask: "url(#path-371-inside-140_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 81.4166H266.206",
    stroke: "#CCD5D3",
    style: (_ref229 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref229, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref229, "strokeOpacity", 1), _ref229),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask141 || (_mask141 = /*#__PURE__*/React.createElement("mask", {
    id: "path-374-inside-141_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 77.6304H299.795V85.203H271.634V77.6304Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 77.6304H299.795V85.203H271.634V77.6304Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 77.6304V77.353H271.356V77.6304H271.634ZM271.634 77.6304V77.9077H299.795V77.6304V77.353H271.634V77.6304ZM271.634 85.203H271.911V77.6304H271.634H271.356V85.203H271.634Z",
    fill: "#EAEEED",
    style: (_ref230 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref230, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref230, "fillOpacity", 1), _ref230),
    mask: "url(#path-374-inside-141_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 81.4166H294.367",
    stroke: "#CCD5D3",
    style: (_ref231 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref231, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref231, "strokeOpacity", 1), _ref231),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask142 || (_mask142 = /*#__PURE__*/React.createElement("mask", {
    id: "path-377-inside-142_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 77.6304H327.956V85.203H299.795V77.6304Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 77.6304H327.956V85.203H299.795V77.6304Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 77.6304V77.353H299.518V77.6304H299.795ZM299.795 77.6304V77.9077H327.956V77.6304V77.353H299.795V77.6304ZM299.795 85.203H300.072V77.6304H299.795H299.518V85.203H299.795Z",
    fill: "#EAEEED",
    style: (_ref232 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref232, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref232, "fillOpacity", 1), _ref232),
    mask: "url(#path-377-inside-142_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 81.4166H322.528",
    stroke: "#CCD5D3",
    style: (_ref233 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref233, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref233, "strokeOpacity", 1), _ref233),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 85.203)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask143 || (_mask143 = /*#__PURE__*/React.createElement("mask", {
    id: "path-380-inside-143_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 85.203H215.312V92.7756H206.992V85.203Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 85.203H215.312V92.7756H206.992V85.203Z",
    fill: "#FAFAFA",
    style: (_ref234 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref234, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref234, "fillOpacity", 1), _ref234)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 85.203V85.4803H215.312V85.203V84.9257H206.992V85.203Z",
    fill: "url(#paint12_linear_17113_221003)",
    style: {},
    mask: "url(#path-380-inside-143_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.144 90.2429C210.996 90.2429 210.86 90.2163 210.738 90.1631C210.618 90.1076 210.523 90.0255 210.452 89.9168C210.381 89.8081 210.343 89.6727 210.339 89.5108H210.622C210.624 89.5995 210.645 89.6816 210.685 89.757C210.727 89.8303 210.787 89.8891 210.865 89.9334C210.942 89.9778 211.036 90 211.144 90C211.253 90 211.344 89.9789 211.417 89.9368C211.49 89.8946 211.546 89.8391 211.584 89.7704C211.621 89.6994 211.64 89.6206 211.64 89.5341C211.64 89.4253 211.614 89.3377 211.56 89.2711C211.509 89.2024 211.439 89.1524 211.351 89.1214C211.264 89.0881 211.169 89.0715 211.064 89.0715H210.891V88.8352H211.064C211.218 88.8352 211.337 88.7997 211.424 88.7287C211.51 88.6577 211.554 88.56 211.554 88.4358C211.554 88.3337 211.519 88.2483 211.45 88.1795C211.384 88.1107 211.282 88.0764 211.144 88.0764C211.013 88.0764 210.909 88.1141 210.831 88.1895C210.754 88.2649 210.709 88.3615 210.698 88.4791H210.415C210.422 88.3526 210.456 88.2405 210.519 88.1429C210.581 88.0453 210.665 87.9699 210.772 87.9166C210.878 87.8611 211.003 87.8334 211.148 87.8334C211.298 87.8334 211.425 87.86 211.527 87.9133C211.629 87.9665 211.706 88.0375 211.757 88.1263C211.81 88.215 211.837 88.3126 211.837 88.4191C211.837 88.499 211.822 88.5745 211.793 88.6455C211.764 88.7142 211.721 88.7753 211.663 88.8285C211.606 88.8817 211.533 88.9195 211.444 88.9417C211.535 88.9594 211.616 88.9938 211.687 89.0448C211.76 89.0959 211.818 89.1624 211.86 89.2445C211.902 89.3266 211.923 89.4231 211.923 89.5341C211.923 89.6605 211.893 89.7781 211.833 89.8868C211.776 89.9933 211.689 90.0799 211.574 90.1464C211.458 90.2108 211.315 90.2429 211.144 90.2429Z",
    fill: "#7F7F7D",
    style: (_ref235 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref235, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref235, "fillOpacity", 1), _ref235)
  }), _mask144 || (_mask144 = /*#__PURE__*/React.createElement("mask", {
    id: "path-383-inside-144_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 85.203H243.473V92.7756H215.312V85.203Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 85.203H243.473V92.7756H215.312V85.203Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 85.203V84.9257H215.035V85.203H215.312ZM215.312 85.203V85.4803H243.473V85.203V84.9257H215.312V85.203ZM215.312 92.7756H215.59V85.203H215.312H215.035V92.7756H215.312Z",
    fill: "#EAEEED",
    style: (_ref236 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref236, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref236, "fillOpacity", 1), _ref236),
    mask: "url(#path-383-inside-144_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 88.9893H238.045",
    stroke: "#CCD5D3",
    style: (_ref237 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref237, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref237, "strokeOpacity", 1), _ref237),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask145 || (_mask145 = /*#__PURE__*/React.createElement("mask", {
    id: "path-386-inside-145_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 85.203H271.634V92.7756H243.474V85.203Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 85.203H271.634V92.7756H243.474V85.203Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 85.203V84.9257H243.196V85.203H243.474ZM243.474 85.203V85.4803H271.634V85.203V84.9257H243.474V85.203ZM243.474 92.7756H243.751V85.203H243.474H243.196V92.7756H243.474Z",
    fill: "#EAEEED",
    style: (_ref238 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref238, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref238, "fillOpacity", 1), _ref238),
    mask: "url(#path-386-inside-145_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 88.9893H266.206",
    stroke: "#CCD5D3",
    style: (_ref239 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref239, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref239, "strokeOpacity", 1), _ref239),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask146 || (_mask146 = /*#__PURE__*/React.createElement("mask", {
    id: "path-389-inside-146_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 85.203H299.795V92.7756H271.634V85.203Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 85.203H299.795V92.7756H271.634V85.203Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 85.203V84.9257H271.356V85.203H271.634ZM271.634 85.203V85.4803H299.795V85.203V84.9257H271.634V85.203ZM271.634 92.7756H271.911V85.203H271.634H271.356V92.7756H271.634Z",
    fill: "#EAEEED",
    style: (_ref240 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref240, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref240, "fillOpacity", 1), _ref240),
    mask: "url(#path-389-inside-146_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 88.9893H294.367",
    stroke: "#CCD5D3",
    style: (_ref241 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref241, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref241, "strokeOpacity", 1), _ref241),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask147 || (_mask147 = /*#__PURE__*/React.createElement("mask", {
    id: "path-392-inside-147_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 85.203H327.956V92.7756H299.795V85.203Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 85.203H327.956V92.7756H299.795V85.203Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 85.203V84.9257H299.518V85.203H299.795ZM299.795 85.203V85.4803H327.956V85.203V84.9257H299.795V85.203ZM299.795 92.7756H300.072V85.203H299.795H299.518V92.7756H299.795Z",
    fill: "#EAEEED",
    style: (_ref242 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref242, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref242, "fillOpacity", 1), _ref242),
    mask: "url(#path-392-inside-147_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 88.9893H322.528",
    stroke: "#CCD5D3",
    style: (_ref243 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref243, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref243, "strokeOpacity", 1), _ref243),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 92.7756)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask148 || (_mask148 = /*#__PURE__*/React.createElement("mask", {
    id: "path-395-inside-148_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 92.7756H215.312V100.348H206.992V92.7756Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 92.7756H215.312V100.348H206.992V92.7756Z",
    fill: "#FAFAFA",
    style: (_ref244 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref244, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref244, "fillOpacity", 1), _ref244)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 92.7756V93.053H215.312V92.7756V92.4983H206.992V92.7756Z",
    fill: "url(#paint13_linear_17113_221003)",
    style: {},
    mask: "url(#path-395-inside-148_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.446 97.7756V97.2764H210.265V97.0601L211.396 95.446H211.722V97.0301H212.068V97.2764H211.722V97.7756H211.446ZM210.574 97.0301H211.459V95.7555L210.574 97.0301Z",
    fill: "#7F7F7D",
    style: (_ref245 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref245, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref245, "fillOpacity", 1), _ref245)
  }), _mask149 || (_mask149 = /*#__PURE__*/React.createElement("mask", {
    id: "path-398-inside-149_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 92.7756H243.473V100.348H215.312V92.7756Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 92.7756H243.473V100.348H215.312V92.7756Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 92.7756V92.4983H215.035V92.7756H215.312ZM215.312 92.7756V93.053H243.473V92.7756V92.4983H215.312V92.7756ZM215.312 100.348H215.59V92.7756H215.312H215.035V100.348H215.312Z",
    fill: "#EAEEED",
    style: (_ref246 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref246, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref246, "fillOpacity", 1), _ref246),
    mask: "url(#path-398-inside-149_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 96.5619H238.045",
    stroke: "#CCD5D3",
    style: (_ref247 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref247, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref247, "strokeOpacity", 1), _ref247),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask150 || (_mask150 = /*#__PURE__*/React.createElement("mask", {
    id: "path-401-inside-150_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 92.7756H271.634V100.348H243.474V92.7756Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 92.7756H271.634V100.348H243.474V92.7756Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 92.7756V92.4983H243.196V92.7756H243.474ZM243.474 92.7756V93.053H271.634V92.7756V92.4983H243.474V92.7756ZM243.474 100.348H243.751V92.7756H243.474H243.196V100.348H243.474Z",
    fill: "#EAEEED",
    style: (_ref248 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref248, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref248, "fillOpacity", 1), _ref248),
    mask: "url(#path-401-inside-150_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 96.5619H266.206",
    stroke: "#CCD5D3",
    style: (_ref249 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref249, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref249, "strokeOpacity", 1), _ref249),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask151 || (_mask151 = /*#__PURE__*/React.createElement("mask", {
    id: "path-404-inside-151_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 92.7756H299.795V100.348H271.634V92.7756Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 92.7756H299.795V100.348H271.634V92.7756Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 92.7756V92.4983H271.356V92.7756H271.634ZM271.634 92.7756V93.053H299.795V92.7756V92.4983H271.634V92.7756ZM271.634 100.348H271.911V92.7756H271.634H271.356V100.348H271.634Z",
    fill: "#EAEEED",
    style: (_ref250 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref250, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref250, "fillOpacity", 1), _ref250),
    mask: "url(#path-404-inside-151_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 96.5619H294.367",
    stroke: "#CCD5D3",
    style: (_ref251 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref251, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref251, "strokeOpacity", 1), _ref251),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask152 || (_mask152 = /*#__PURE__*/React.createElement("mask", {
    id: "path-407-inside-152_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 92.7756H327.956V100.348H299.795V92.7756Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 92.7756H327.956V100.348H299.795V92.7756Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 92.7756V92.4983H299.518V92.7756H299.795ZM299.795 92.7756V93.053H327.956V92.7756V92.4983H299.795V92.7756ZM299.795 100.348H300.072V92.7756H299.795H299.518V100.348H299.795Z",
    fill: "#EAEEED",
    style: (_ref252 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref252, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref252, "fillOpacity", 1), _ref252),
    mask: "url(#path-407-inside-152_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 96.5619H322.528",
    stroke: "#CCD5D3",
    style: (_ref253 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref253, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref253, "strokeOpacity", 1), _ref253),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 100.348)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask153 || (_mask153 = /*#__PURE__*/React.createElement("mask", {
    id: "path-410-inside-153_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 100.348H215.312V107.921H206.992V100.348Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 100.348H215.312V107.921H206.992V100.348Z",
    fill: "#FAFAFA",
    style: (_ref254 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref254, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref254, "fillOpacity", 1), _ref254)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 100.348V100.626H215.312V100.348V100.071H206.992V100.348Z",
    fill: "url(#paint14_linear_17113_221003)",
    style: {},
    mask: "url(#path-410-inside-153_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.172 105.388C211.012 105.388 210.873 105.359 210.756 105.302C210.64 105.244 210.548 105.165 210.479 105.065C210.413 104.966 210.371 104.853 210.353 104.729H210.626C210.653 104.853 210.714 104.954 210.809 105.032C210.904 105.11 211.026 105.149 211.175 105.149C211.286 105.149 211.38 105.123 211.458 105.072C211.538 105.021 211.599 104.951 211.641 104.862C211.685 104.774 211.708 104.675 211.708 104.566C211.708 104.453 211.685 104.353 211.641 104.267C211.597 104.18 211.536 104.114 211.458 104.067C211.38 104.018 211.289 103.994 211.185 103.994C211.059 103.994 210.951 104.021 210.862 104.077C210.773 104.132 210.707 104.203 210.662 104.29H210.393L210.586 103.019H211.817V103.262H210.802L210.672 103.977C210.728 103.913 210.801 103.861 210.892 103.821C210.985 103.779 211.093 103.757 211.215 103.757C211.33 103.757 211.435 103.777 211.528 103.817C211.621 103.857 211.701 103.914 211.767 103.987C211.834 104.06 211.885 104.146 211.921 104.243C211.958 104.341 211.977 104.447 211.977 104.563C211.977 104.676 211.958 104.782 211.921 104.882C211.885 104.98 211.833 105.068 211.764 105.145C211.695 105.221 211.611 105.281 211.511 105.325C211.411 105.367 211.298 105.388 211.172 105.388Z",
    fill: "#7F7F7D",
    style: (_ref255 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref255, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref255, "fillOpacity", 1), _ref255)
  }), _mask154 || (_mask154 = /*#__PURE__*/React.createElement("mask", {
    id: "path-413-inside-154_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 100.348H243.473V107.921H215.312V100.348Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 100.348H243.473V107.921H215.312V100.348Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 100.348V100.071H215.035V100.348H215.312ZM215.312 100.348V100.626H243.473V100.348V100.071H215.312V100.348ZM215.312 107.921H215.59V100.348H215.312H215.035V107.921H215.312Z",
    fill: "#EAEEED",
    style: (_ref256 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref256, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref256, "fillOpacity", 1), _ref256),
    mask: "url(#path-413-inside-154_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 104.135H238.045",
    stroke: "#CCD5D3",
    style: (_ref257 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref257, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref257, "strokeOpacity", 1), _ref257),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask155 || (_mask155 = /*#__PURE__*/React.createElement("mask", {
    id: "path-416-inside-155_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 100.348H271.634V107.921H243.474V100.348Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 100.348H271.634V107.921H243.474V100.348Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 100.348V100.071H243.196V100.348H243.474ZM243.474 100.348V100.626H271.634V100.348V100.071H243.474V100.348ZM243.474 107.921H243.751V100.348H243.474H243.196V107.921H243.474Z",
    fill: "#EAEEED",
    style: (_ref258 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref258, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref258, "fillOpacity", 1), _ref258),
    mask: "url(#path-416-inside-155_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 104.135H266.206",
    stroke: "#CCD5D3",
    style: (_ref259 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref259, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref259, "strokeOpacity", 1), _ref259),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask156 || (_mask156 = /*#__PURE__*/React.createElement("mask", {
    id: "path-419-inside-156_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 100.348H299.795V107.921H271.634V100.348Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 100.348H299.795V107.921H271.634V100.348Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 100.348V100.071H271.356V100.348H271.634ZM271.634 100.348V100.626H299.795V100.348V100.071H271.634V100.348ZM271.634 107.921H271.911V100.348H271.634H271.356V107.921H271.634Z",
    fill: "#EAEEED",
    style: (_ref260 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref260, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref260, "fillOpacity", 1), _ref260),
    mask: "url(#path-419-inside-156_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 104.135H294.367",
    stroke: "#CCD5D3",
    style: (_ref261 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref261, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref261, "strokeOpacity", 1), _ref261),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask157 || (_mask157 = /*#__PURE__*/React.createElement("mask", {
    id: "path-422-inside-157_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 100.348H327.956V107.921H299.795V100.348Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 100.348H327.956V107.921H299.795V100.348Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 100.348V100.071H299.518V100.348H299.795ZM299.795 100.348V100.626H327.956V100.348V100.071H299.795V100.348ZM299.795 107.921H300.072V100.348H299.795H299.518V107.921H299.795Z",
    fill: "#EAEEED",
    style: (_ref262 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref262, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref262, "fillOpacity", 1), _ref262),
    mask: "url(#path-422-inside-157_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 104.135H322.528",
    stroke: "#CCD5D3",
    style: (_ref263 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref263, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref263, "strokeOpacity", 1), _ref263),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 107.921)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask158 || (_mask158 = /*#__PURE__*/React.createElement("mask", {
    id: "path-425-inside-158_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 107.921H215.312V115.494H206.992V107.921Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 107.921H215.312V115.494H206.992V107.921Z",
    fill: "#FAFAFA",
    style: (_ref264 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref264, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref264, "fillOpacity", 1), _ref264)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 107.921V108.198H215.312V107.921V107.644H206.992V107.921Z",
    fill: "url(#paint15_linear_17113_221003)",
    style: {},
    mask: "url(#path-425-inside-158_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.192 112.961C211.024 112.961 210.882 112.93 210.766 112.868C210.651 112.803 210.559 112.719 210.49 112.615C210.421 112.508 210.37 112.388 210.337 112.255C210.306 112.122 210.29 111.987 210.29 111.849C210.29 111.592 210.326 111.367 210.397 111.174C210.468 110.978 210.57 110.826 210.703 110.718C210.838 110.607 211 110.551 211.189 110.551C211.335 110.551 211.461 110.58 211.565 110.638C211.672 110.693 211.756 110.769 211.818 110.864C211.88 110.96 211.918 111.066 211.931 111.184H211.672C211.649 111.059 211.595 110.964 211.509 110.897C211.424 110.829 211.317 110.794 211.186 110.794C211.07 110.794 210.966 110.831 210.873 110.904C210.78 110.975 210.705 111.085 210.65 111.234C210.597 111.38 210.566 111.567 210.557 111.796C210.557 111.798 210.557 111.802 210.557 111.806C210.557 111.81 210.557 111.815 210.557 111.819C210.592 111.751 210.641 111.686 210.703 111.626C210.767 111.566 210.844 111.519 210.933 111.483C211.022 111.448 211.12 111.43 211.229 111.43C211.36 111.43 211.483 111.461 211.598 111.523C211.714 111.585 211.807 111.673 211.878 111.786C211.951 111.897 211.988 112.028 211.988 112.179C211.988 112.31 211.956 112.435 211.891 112.555C211.829 112.675 211.738 112.772 211.618 112.848C211.499 112.923 211.357 112.961 211.192 112.961ZM211.172 112.715C211.274 112.715 211.365 112.692 211.445 112.648C211.527 112.601 211.591 112.539 211.635 112.462C211.682 112.382 211.705 112.292 211.705 112.192C211.705 112.088 211.682 111.997 211.635 111.919C211.591 111.841 211.527 111.782 211.445 111.739C211.365 111.695 211.274 111.673 211.172 111.673C211.07 111.673 210.978 111.696 210.896 111.743C210.814 111.789 210.749 111.853 210.7 111.932C210.653 112.01 210.63 112.098 210.63 112.195C210.63 112.295 210.653 112.385 210.7 112.465C210.749 112.543 210.814 112.604 210.896 112.648C210.978 112.692 211.07 112.715 211.172 112.715Z",
    fill: "#7F7F7D",
    style: (_ref265 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref265, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref265, "fillOpacity", 1), _ref265)
  }), _mask159 || (_mask159 = /*#__PURE__*/React.createElement("mask", {
    id: "path-428-inside-159_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 107.921H243.473V115.494H215.312V107.921Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 107.921H243.473V115.494H215.312V107.921Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 107.921V107.644H215.035V107.921H215.312ZM215.312 107.921V108.198H243.473V107.921V107.644H215.312V107.921ZM215.312 115.494H215.59V107.921H215.312H215.035V115.494H215.312Z",
    fill: "#EAEEED",
    style: (_ref266 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref266, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref266, "fillOpacity", 1), _ref266),
    mask: "url(#path-428-inside-159_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 111.707H238.045",
    stroke: "#CCD5D3",
    style: (_ref267 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref267, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref267, "strokeOpacity", 1), _ref267),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask160 || (_mask160 = /*#__PURE__*/React.createElement("mask", {
    id: "path-431-inside-160_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 107.921H271.634V115.494H243.474V107.921Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 107.921H271.634V115.494H243.474V107.921Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 107.921V107.644H243.196V107.921H243.474ZM243.474 107.921V108.198H271.634V107.921V107.644H243.474V107.921ZM243.474 115.494H243.751V107.921H243.474H243.196V115.494H243.474Z",
    fill: "#EAEEED",
    style: (_ref268 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref268, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref268, "fillOpacity", 1), _ref268),
    mask: "url(#path-431-inside-160_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 111.707H266.206",
    stroke: "#CCD5D3",
    style: (_ref269 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref269, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref269, "strokeOpacity", 1), _ref269),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask161 || (_mask161 = /*#__PURE__*/React.createElement("mask", {
    id: "path-434-inside-161_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 107.921H299.795V115.494H271.634V107.921Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 107.921H299.795V115.494H271.634V107.921Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 107.921V107.644H271.356V107.921H271.634ZM271.634 107.921V108.198H299.795V107.921V107.644H271.634V107.921ZM271.634 115.494H271.911V107.921H271.634H271.356V115.494H271.634Z",
    fill: "#EAEEED",
    style: (_ref270 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref270, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref270, "fillOpacity", 1), _ref270),
    mask: "url(#path-434-inside-161_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 111.707H294.367",
    stroke: "#CCD5D3",
    style: (_ref271 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref271, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref271, "strokeOpacity", 1), _ref271),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask162 || (_mask162 = /*#__PURE__*/React.createElement("mask", {
    id: "path-437-inside-162_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 107.921H327.956V115.494H299.795V107.921Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 107.921H327.956V115.494H299.795V107.921Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 107.921V107.644H299.518V107.921H299.795ZM299.795 107.921V108.198H327.956V107.921V107.644H299.795V107.921ZM299.795 115.494H300.072V107.921H299.795H299.518V115.494H299.795Z",
    fill: "#EAEEED",
    style: (_ref272 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref272, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref272, "fillOpacity", 1), _ref272),
    mask: "url(#path-437-inside-162_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 111.707H322.528",
    stroke: "#CCD5D3",
    style: (_ref273 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref273, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref273, "strokeOpacity", 1), _ref273),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 115.494)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask163 || (_mask163 = /*#__PURE__*/React.createElement("mask", {
    id: "path-440-inside-163_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 115.494H215.312V123.066H206.992V115.494Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 115.494H215.312V123.066H206.992V115.494Z",
    fill: "#FAFAFA",
    style: (_ref274 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref274, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref274, "fillOpacity", 1), _ref274)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 115.494V115.771H215.312V115.494V115.216H206.992V115.494Z",
    fill: "url(#paint16_linear_17113_221003)",
    style: {},
    mask: "url(#path-440-inside-163_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.723 120.494L211.631 118.403H210.353V118.164H211.917V118.374L211.019 120.494H210.723Z",
    fill: "#7F7F7D",
    style: (_ref275 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref275, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref275, "fillOpacity", 1), _ref275)
  }), _mask164 || (_mask164 = /*#__PURE__*/React.createElement("mask", {
    id: "path-443-inside-164_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 115.494H243.473V123.066H215.312V115.494Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 115.494H243.473V123.066H215.312V115.494Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 115.494V115.216H215.035V115.494H215.312ZM215.312 115.494V115.771H243.473V115.494V115.216H215.312V115.494ZM215.312 123.066H215.59V115.494H215.312H215.035V123.066H215.312Z",
    fill: "#EAEEED",
    style: (_ref276 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref276, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref276, "fillOpacity", 1), _ref276),
    mask: "url(#path-443-inside-164_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 119.28H238.045",
    stroke: "#CCD5D3",
    style: (_ref277 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref277, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref277, "strokeOpacity", 1), _ref277),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask165 || (_mask165 = /*#__PURE__*/React.createElement("mask", {
    id: "path-446-inside-165_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 115.494H271.634V123.066H243.474V115.494Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 115.494H271.634V123.066H243.474V115.494Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 115.494V115.216H243.196V115.494H243.474ZM243.474 115.494V115.771H271.634V115.494V115.216H243.474V115.494ZM243.474 123.066H243.751V115.494H243.474H243.196V123.066H243.474Z",
    fill: "#EAEEED",
    style: (_ref278 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref278, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref278, "fillOpacity", 1), _ref278),
    mask: "url(#path-446-inside-165_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 119.28H266.206",
    stroke: "#CCD5D3",
    style: (_ref279 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref279, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref279, "strokeOpacity", 1), _ref279),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask166 || (_mask166 = /*#__PURE__*/React.createElement("mask", {
    id: "path-449-inside-166_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 115.494H299.795V123.066H271.634V115.494Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 115.494H299.795V123.066H271.634V115.494Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 115.494V115.216H271.356V115.494H271.634ZM271.634 115.494V115.771H299.795V115.494V115.216H271.634V115.494ZM271.634 123.066H271.911V115.494H271.634H271.356V123.066H271.634Z",
    fill: "#EAEEED",
    style: (_ref280 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref280, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref280, "fillOpacity", 1), _ref280),
    mask: "url(#path-449-inside-166_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 119.28H294.367",
    stroke: "#CCD5D3",
    style: (_ref281 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref281, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref281, "strokeOpacity", 1), _ref281),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask167 || (_mask167 = /*#__PURE__*/React.createElement("mask", {
    id: "path-452-inside-167_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 115.494H327.956V123.066H299.795V115.494Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 115.494H327.956V123.066H299.795V115.494Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 115.494V115.216H299.518V115.494H299.795ZM299.795 115.494V115.771H327.956V115.494V115.216H299.795V115.494ZM299.795 123.066H300.072V115.494H299.795H299.518V123.066H299.795Z",
    fill: "#EAEEED",
    style: (_ref282 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref282, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref282, "fillOpacity", 1), _ref282),
    mask: "url(#path-452-inside-167_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 119.28H322.528",
    stroke: "#CCD5D3",
    style: (_ref283 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref283, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref283, "strokeOpacity", 1), _ref283),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 123.066)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask168 || (_mask168 = /*#__PURE__*/React.createElement("mask", {
    id: "path-455-inside-168_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 123.066H215.312V130.639H206.992V123.066Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 123.066H215.312V130.639H206.992V123.066Z",
    fill: "#FAFAFA",
    style: (_ref284 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref284, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref284, "fillOpacity", 1), _ref284)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 123.066V123.344H215.312V123.066V122.789H206.992V123.066Z",
    fill: "url(#paint17_linear_17113_221003)",
    style: {},
    mask: "url(#path-455-inside-168_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.152 128.106C211.001 128.106 210.865 128.078 210.746 128.023C210.626 127.965 210.53 127.886 210.459 127.787C210.388 127.685 210.353 127.567 210.353 127.434C210.353 127.338 210.372 127.25 210.409 127.168C210.447 127.085 210.499 127.014 210.566 126.955C210.635 126.892 210.713 126.849 210.802 126.825C210.678 126.78 210.581 126.712 210.513 126.618C210.446 126.525 210.413 126.424 210.413 126.316C210.413 126.2 210.443 126.096 210.503 126.003C210.563 125.91 210.647 125.835 210.756 125.78C210.867 125.724 210.999 125.697 211.152 125.697C211.307 125.697 211.439 125.724 211.548 125.78C211.659 125.835 211.743 125.91 211.801 126.003C211.861 126.096 211.89 126.2 211.89 126.316C211.89 126.424 211.856 126.525 211.787 126.618C211.721 126.712 211.625 126.78 211.501 126.825C211.592 126.849 211.671 126.892 211.737 126.955C211.806 127.014 211.858 127.085 211.894 127.168C211.932 127.25 211.95 127.338 211.95 127.434C211.95 127.567 211.915 127.685 211.844 127.787C211.775 127.886 211.68 127.965 211.558 128.023C211.438 128.078 211.303 128.106 211.152 128.106ZM211.152 127.86C211.327 127.86 211.457 127.82 211.541 127.74C211.628 127.658 211.671 127.55 211.671 127.417C211.671 127.266 211.623 127.152 211.528 127.074C211.435 126.997 211.309 126.958 211.152 126.958C210.994 126.958 210.868 126.997 210.772 127.074C210.679 127.152 210.632 127.266 210.632 127.417C210.632 127.55 210.676 127.658 210.762 127.74C210.849 127.82 210.979 127.86 211.152 127.86ZM211.152 126.725C211.291 126.725 211.402 126.688 211.484 126.615C211.567 126.542 211.608 126.448 211.608 126.332C211.608 126.201 211.567 126.103 211.484 126.036C211.405 125.969 211.294 125.936 211.152 125.936C211.012 125.936 210.901 125.969 210.819 126.036C210.739 126.103 210.699 126.201 210.699 126.332C210.699 126.448 210.739 126.542 210.819 126.615C210.901 126.688 211.012 126.725 211.152 126.725Z",
    fill: "#7F7F7D",
    style: (_ref285 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref285, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref285, "fillOpacity", 1), _ref285)
  }), _mask169 || (_mask169 = /*#__PURE__*/React.createElement("mask", {
    id: "path-458-inside-169_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 123.066H243.473V130.639H215.312V123.066Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 123.066H243.473V130.639H215.312V123.066Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 123.066V122.789H215.035V123.066H215.312ZM215.312 123.066V123.344H243.473V123.066V122.789H215.312V123.066ZM215.312 130.639H215.59V123.066H215.312H215.035V130.639H215.312Z",
    fill: "#EAEEED",
    style: (_ref286 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref286, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref286, "fillOpacity", 1), _ref286),
    mask: "url(#path-458-inside-169_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 126.852H238.045",
    stroke: "#CCD5D3",
    style: (_ref287 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref287, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref287, "strokeOpacity", 1), _ref287),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask170 || (_mask170 = /*#__PURE__*/React.createElement("mask", {
    id: "path-461-inside-170_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 123.066H271.634V130.639H243.474V123.066Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 123.066H271.634V130.639H243.474V123.066Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 123.066V122.789H243.196V123.066H243.474ZM243.474 123.066V123.344H271.634V123.066V122.789H243.474V123.066ZM243.474 130.639H243.751V123.066H243.474H243.196V130.639H243.474Z",
    fill: "#EAEEED",
    style: (_ref288 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref288, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref288, "fillOpacity", 1), _ref288),
    mask: "url(#path-461-inside-170_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 126.852H266.206",
    stroke: "#CCD5D3",
    style: (_ref289 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref289, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref289, "strokeOpacity", 1), _ref289),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask171 || (_mask171 = /*#__PURE__*/React.createElement("mask", {
    id: "path-464-inside-171_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 123.066H299.795V130.639H271.634V123.066Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 123.066H299.795V130.639H271.634V123.066Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 123.066V122.789H271.356V123.066H271.634ZM271.634 123.066V123.344H299.795V123.066V122.789H271.634V123.066ZM271.634 130.639H271.911V123.066H271.634H271.356V130.639H271.634Z",
    fill: "#EAEEED",
    style: (_ref290 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref290, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref290, "fillOpacity", 1), _ref290),
    mask: "url(#path-464-inside-171_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 126.852H294.367",
    stroke: "#CCD5D3",
    style: (_ref291 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref291, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref291, "strokeOpacity", 1), _ref291),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask172 || (_mask172 = /*#__PURE__*/React.createElement("mask", {
    id: "path-467-inside-172_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 123.066H327.956V130.639H299.795V123.066Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 123.066H327.956V130.639H299.795V123.066Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 123.066V122.789H299.518V123.066H299.795ZM299.795 123.066V123.344H327.956V123.066V122.789H299.795V123.066ZM299.795 130.639H300.072V123.066H299.795H299.518V130.639H299.795Z",
    fill: "#EAEEED",
    style: (_ref292 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref292, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref292, "fillOpacity", 1), _ref292),
    mask: "url(#path-467-inside-172_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 126.852H322.528",
    stroke: "#CCD5D3",
    style: (_ref293 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref293, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref293, "strokeOpacity", 1), _ref293),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 130.639)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask173 || (_mask173 = /*#__PURE__*/React.createElement("mask", {
    id: "path-470-inside-173_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 130.639H215.312V138.211H206.992V130.639Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 130.639H215.312V138.211H206.992V130.639Z",
    fill: "#FAFAFA",
    style: (_ref294 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref294, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref294, "fillOpacity", 1), _ref294)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 130.639V130.916H215.312V130.639V130.361H206.992V130.639Z",
    fill: "url(#paint18_linear_17113_221003)",
    style: {},
    mask: "url(#path-470-inside-173_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.116 135.679C210.969 135.679 210.844 135.651 210.74 135.595C210.635 135.538 210.552 135.461 210.49 135.366C210.43 135.268 210.394 135.162 210.38 135.046H210.64C210.662 135.171 210.715 135.267 210.8 135.336C210.884 135.402 210.99 135.436 211.119 135.436C211.237 135.436 211.341 135.4 211.432 135.329C211.523 135.258 211.596 135.151 211.652 135.006C211.709 134.86 211.741 134.675 211.748 134.451C211.748 134.444 211.748 134.437 211.748 134.431C211.748 134.424 211.748 134.417 211.748 134.411C211.715 134.479 211.666 134.544 211.602 134.604C211.537 134.664 211.461 134.711 211.372 134.747C211.286 134.782 211.188 134.8 211.079 134.8C210.948 134.8 210.824 134.769 210.706 134.707C210.591 134.645 210.497 134.558 210.424 134.447C210.353 134.334 210.317 134.202 210.317 134.051C210.317 133.92 210.349 133.795 210.414 133.675C210.478 133.555 210.57 133.458 210.69 133.382C210.81 133.307 210.952 133.269 211.116 133.269C211.282 133.269 211.423 133.301 211.538 133.366C211.654 133.428 211.746 133.512 211.815 133.619C211.886 133.723 211.937 133.842 211.968 133.975C211.999 134.108 212.014 134.243 212.014 134.381C212.014 134.636 211.979 134.861 211.908 135.056C211.839 135.252 211.737 135.405 211.602 135.516C211.469 135.624 211.307 135.679 211.116 135.679ZM211.136 134.557C211.238 134.557 211.33 134.534 211.412 134.487C211.494 134.441 211.558 134.377 211.605 134.297C211.654 134.218 211.678 134.13 211.678 134.035C211.678 133.932 211.654 133.843 211.605 133.765C211.558 133.687 211.494 133.626 211.412 133.582C211.33 133.538 211.238 133.515 211.136 133.515C211.034 133.515 210.942 133.539 210.86 133.585C210.78 133.63 210.716 133.691 210.67 133.768C210.623 133.846 210.6 133.936 210.6 134.038C210.6 134.142 210.623 134.233 210.67 134.311C210.716 134.388 210.78 134.449 210.86 134.494C210.942 134.536 211.034 134.557 211.136 134.557Z",
    fill: "#7F7F7D",
    style: (_ref295 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref295, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref295, "fillOpacity", 1), _ref295)
  }), _mask174 || (_mask174 = /*#__PURE__*/React.createElement("mask", {
    id: "path-473-inside-174_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 130.639H243.473V138.211H215.312V130.639Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 130.639H243.473V138.211H215.312V130.639Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 130.639V130.361H215.035V130.639H215.312ZM215.312 130.639V130.916H243.473V130.639V130.361H215.312V130.639ZM215.312 138.211H215.59V130.639H215.312H215.035V138.211H215.312Z",
    fill: "#EAEEED",
    style: (_ref296 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref296, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref296, "fillOpacity", 1), _ref296),
    mask: "url(#path-473-inside-174_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 134.425H238.045",
    stroke: "#CCD5D3",
    style: (_ref297 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref297, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref297, "strokeOpacity", 1), _ref297),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask175 || (_mask175 = /*#__PURE__*/React.createElement("mask", {
    id: "path-476-inside-175_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 130.639H271.634V138.211H243.474V130.639Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 130.639H271.634V138.211H243.474V130.639Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 130.639V130.361H243.196V130.639H243.474ZM243.474 130.639V130.916H271.634V130.639V130.361H243.474V130.639ZM243.474 138.211H243.751V130.639H243.474H243.196V138.211H243.474Z",
    fill: "#EAEEED",
    style: (_ref298 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref298, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref298, "fillOpacity", 1), _ref298),
    mask: "url(#path-476-inside-175_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 134.425H266.206",
    stroke: "#CCD5D3",
    style: (_ref299 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref299, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref299, "strokeOpacity", 1), _ref299),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask176 || (_mask176 = /*#__PURE__*/React.createElement("mask", {
    id: "path-479-inside-176_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 130.639H299.795V138.211H271.634V130.639Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 130.639H299.795V138.211H271.634V130.639Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 130.639V130.361H271.356V130.639H271.634ZM271.634 130.639V130.916H299.795V130.639V130.361H271.634V130.639ZM271.634 138.211H271.911V130.639H271.634H271.356V138.211H271.634Z",
    fill: "#EAEEED",
    style: (_ref300 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref300, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref300, "fillOpacity", 1), _ref300),
    mask: "url(#path-479-inside-176_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 134.425H294.367",
    stroke: "#CCD5D3",
    style: (_ref301 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref301, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref301, "strokeOpacity", 1), _ref301),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask177 || (_mask177 = /*#__PURE__*/React.createElement("mask", {
    id: "path-482-inside-177_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 130.639H327.956V138.211H299.795V130.639Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 130.639H327.956V138.211H299.795V130.639Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 130.639V130.361H299.518V130.639H299.795ZM299.795 130.639V130.916H327.956V130.639V130.361H299.795V130.639ZM299.795 138.211H300.072V130.639H299.795H299.518V138.211H299.795Z",
    fill: "#EAEEED",
    style: (_ref302 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref302, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref302, "fillOpacity", 1), _ref302),
    mask: "url(#path-482-inside-177_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 134.425H322.528",
    stroke: "#CCD5D3",
    style: (_ref303 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref303, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref303, "strokeOpacity", 1), _ref303),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 138.211)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask178 || (_mask178 = /*#__PURE__*/React.createElement("mask", {
    id: "path-485-inside-178_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 138.211H215.312V145.784H206.992V138.211Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 138.211H215.312V145.784H206.992V138.211Z",
    fill: "#FAFAFA",
    style: (_ref304 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref304, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref304, "fillOpacity", 1), _ref304)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 138.211V138.489H215.312V138.211V137.934H206.992V138.211Z",
    fill: "url(#paint19_linear_17113_221003)",
    style: {},
    mask: "url(#path-485-inside-178_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.002 143.211V141.194L209.603 141.294V141.095L210.095 140.882H210.285V143.211H210.002ZM211.675 143.251C211.471 143.251 211.294 143.201 211.146 143.101C210.999 142.999 210.887 142.859 210.809 142.679C210.732 142.497 210.693 142.286 210.693 142.046C210.693 141.807 210.732 141.597 210.809 141.417C210.887 141.236 210.999 141.095 211.146 140.995C211.294 140.893 211.471 140.842 211.675 140.842C211.879 140.842 212.053 140.893 212.197 140.995C212.344 141.095 212.456 141.236 212.533 141.417C212.611 141.597 212.65 141.807 212.65 142.046C212.65 142.286 212.611 142.497 212.533 142.679C212.456 142.859 212.344 142.999 212.197 143.101C212.053 143.201 211.879 143.251 211.675 143.251ZM211.671 143.005C211.804 143.005 211.923 142.967 212.027 142.892C212.132 142.814 212.214 142.704 212.274 142.562C212.334 142.418 212.364 142.246 212.364 142.046C212.364 141.847 212.334 141.676 212.274 141.534C212.214 141.39 212.132 141.28 212.027 141.204C211.923 141.129 211.804 141.091 211.671 141.091C211.538 141.091 211.418 141.129 211.312 141.204C211.208 141.28 211.126 141.39 211.066 141.534C211.008 141.676 210.979 141.847 210.979 142.046C210.979 142.246 211.008 142.418 211.066 142.562C211.126 142.704 211.208 142.814 211.312 142.892C211.418 142.967 211.538 143.005 211.671 143.005Z",
    fill: "#7F7F7D",
    style: (_ref305 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref305, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref305, "fillOpacity", 1), _ref305)
  }), _mask179 || (_mask179 = /*#__PURE__*/React.createElement("mask", {
    id: "path-488-inside-179_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 138.211H243.473V145.784H215.312V138.211Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 138.211H243.473V145.784H215.312V138.211Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 138.211V137.934H215.035V138.211H215.312ZM215.312 138.211V138.489H243.473V138.211V137.934H215.312V138.211ZM215.312 145.784H215.59V138.211H215.312H215.035V145.784H215.312Z",
    fill: "#EAEEED",
    style: (_ref306 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref306, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref306, "fillOpacity", 1), _ref306),
    mask: "url(#path-488-inside-179_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 141.998H238.045",
    stroke: "#CCD5D3",
    style: (_ref307 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref307, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref307, "strokeOpacity", 1), _ref307),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask180 || (_mask180 = /*#__PURE__*/React.createElement("mask", {
    id: "path-491-inside-180_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 138.211H271.634V145.784H243.474V138.211Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 138.211H271.634V145.784H243.474V138.211Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 138.211V137.934H243.196V138.211H243.474ZM243.474 138.211V138.489H271.634V138.211V137.934H243.474V138.211ZM243.474 145.784H243.751V138.211H243.474H243.196V145.784H243.474Z",
    fill: "#EAEEED",
    style: (_ref308 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref308, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref308, "fillOpacity", 1), _ref308),
    mask: "url(#path-491-inside-180_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 141.998H266.206",
    stroke: "#CCD5D3",
    style: (_ref309 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref309, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref309, "strokeOpacity", 1), _ref309),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask181 || (_mask181 = /*#__PURE__*/React.createElement("mask", {
    id: "path-494-inside-181_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 138.211H299.795V145.784H271.634V138.211Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 138.211H299.795V145.784H271.634V138.211Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 138.211V137.934H271.356V138.211H271.634ZM271.634 138.211V138.489H299.795V138.211V137.934H271.634V138.211ZM271.634 145.784H271.911V138.211H271.634H271.356V145.784H271.634Z",
    fill: "#EAEEED",
    style: (_ref310 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref310, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref310, "fillOpacity", 1), _ref310),
    mask: "url(#path-494-inside-181_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 141.998H294.367",
    stroke: "#CCD5D3",
    style: (_ref311 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref311, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref311, "strokeOpacity", 1), _ref311),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask182 || (_mask182 = /*#__PURE__*/React.createElement("mask", {
    id: "path-497-inside-182_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 138.211H327.956V145.784H299.795V138.211Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 138.211H327.956V145.784H299.795V138.211Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 138.211V137.934H299.518V138.211H299.795ZM299.795 138.211V138.489H327.956V138.211V137.934H299.795V138.211ZM299.795 145.784H300.072V138.211H299.795H299.518V145.784H299.795Z",
    fill: "#EAEEED",
    style: (_ref312 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref312, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref312, "fillOpacity", 1), _ref312),
    mask: "url(#path-497-inside-182_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 141.998H322.528",
    stroke: "#CCD5D3",
    style: (_ref313 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref313, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref313, "strokeOpacity", 1), _ref313),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 145.784)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask183 || (_mask183 = /*#__PURE__*/React.createElement("mask", {
    id: "path-500-inside-183_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 145.784H215.312V153.357H206.992V145.784Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 145.784H215.312V153.357H206.992V145.784Z",
    fill: "#FAFAFA",
    style: (_ref314 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref314, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref314, "fillOpacity", 1), _ref314)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 145.784V146.061H215.312V145.784V145.507H206.992V145.784Z",
    fill: "url(#paint20_linear_17113_221003)",
    style: {},
    mask: "url(#path-500-inside-183_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.621 150.784V148.767L210.222 148.867V148.667L210.715 148.454H210.904V150.784H210.621ZM211.658 150.784V148.767L211.259 148.867V148.667L211.751 148.454H211.941V150.784H211.658Z",
    fill: "#7F7F7D",
    style: (_ref315 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref315, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref315, "fillOpacity", 1), _ref315)
  }), _mask184 || (_mask184 = /*#__PURE__*/React.createElement("mask", {
    id: "path-503-inside-184_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 145.784H243.473V153.357H215.312V145.784Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 145.784H243.473V153.357H215.312V145.784Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 145.784V145.507H215.035V145.784H215.312ZM215.312 145.784V146.061H243.473V145.784V145.507H215.312V145.784ZM215.312 153.357H215.59V145.784H215.312H215.035V153.357H215.312Z",
    fill: "#EAEEED",
    style: (_ref316 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref316, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref316, "fillOpacity", 1), _ref316),
    mask: "url(#path-503-inside-184_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.74 149.57H238.045",
    stroke: "#CCD5D3",
    style: (_ref317 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref317, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref317, "strokeOpacity", 1), _ref317),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask185 || (_mask185 = /*#__PURE__*/React.createElement("mask", {
    id: "path-506-inside-185_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 145.784H271.634V153.357H243.474V145.784Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 145.784H271.634V153.357H243.474V145.784Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 145.784V145.507H243.196V145.784H243.474ZM243.474 145.784V146.061H271.634V145.784V145.507H243.474V145.784ZM243.474 153.357H243.751V145.784H243.474H243.196V153.357H243.474Z",
    fill: "#EAEEED",
    style: (_ref318 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref318, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref318, "fillOpacity", 1), _ref318),
    mask: "url(#path-506-inside-185_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M248.901 149.57H266.206",
    stroke: "#CCD5D3",
    style: (_ref319 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref319, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref319, "strokeOpacity", 1), _ref319),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask186 || (_mask186 = /*#__PURE__*/React.createElement("mask", {
    id: "path-509-inside-186_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 145.784H299.795V153.357H271.634V145.784Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 145.784H299.795V153.357H271.634V145.784Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 145.784V145.507H271.356V145.784H271.634ZM271.634 145.784V146.061H299.795V145.784V145.507H271.634V145.784ZM271.634 153.357H271.911V145.784H271.634H271.356V153.357H271.634Z",
    fill: "#EAEEED",
    style: (_ref320 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref320, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref320, "fillOpacity", 1), _ref320),
    mask: "url(#path-509-inside-186_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.062 149.57H294.367",
    stroke: "#CCD5D3",
    style: (_ref321 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref321, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref321, "strokeOpacity", 1), _ref321),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask187 || (_mask187 = /*#__PURE__*/React.createElement("mask", {
    id: "path-512-inside-187_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 145.784H327.956V153.357H299.795V145.784Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 145.784H327.956V153.357H299.795V145.784Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 145.784V145.507H299.518V145.784H299.795ZM299.795 145.784V146.061H327.956V145.784V145.507H299.795V145.784ZM299.795 153.357H300.072V145.784H299.795H299.518V153.357H299.795Z",
    fill: "#EAEEED",
    style: (_ref322 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref322, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref322, "fillOpacity", 1), _ref322),
    mask: "url(#path-512-inside-187_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M305.223 149.57H322.528",
    stroke: "#CCD5D3",
    style: (_ref323 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref323, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref323, "strokeOpacity", 1), _ref323),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 153.357)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask188 || (_mask188 = /*#__PURE__*/React.createElement("mask", {
    id: "path-515-inside-188_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 153.357H215.312V160.929H206.992V153.357Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 153.357H215.312V160.929H206.992V153.357Z",
    fill: "#FAFAFA",
    style: (_ref324 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref324, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref324, "fillOpacity", 1), _ref324)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 153.357V153.634H215.312V153.357V153.079H206.992V153.357Z",
    fill: "url(#paint21_linear_17113_221003)",
    style: {},
    mask: "url(#path-515-inside-188_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.181 158.357V156.34L209.782 156.44V156.24L210.274 156.027H210.464V158.357H210.181ZM210.925 158.357V158.16C211.082 158.036 211.232 157.911 211.374 157.784C211.518 157.658 211.646 157.532 211.757 157.408C211.868 157.282 211.954 157.158 212.017 157.039C212.081 156.919 212.113 156.803 212.113 156.693C212.113 156.61 212.099 156.535 212.07 156.466C212.041 156.395 211.994 156.338 211.93 156.293C211.868 156.249 211.784 156.227 211.677 156.227C211.573 156.227 211.486 156.25 211.417 156.296C211.349 156.341 211.297 156.401 211.261 156.476C211.228 156.549 211.211 156.63 211.211 156.719H210.942C210.944 156.566 210.976 156.435 211.038 156.326C211.102 156.215 211.19 156.131 211.301 156.073C211.412 156.016 211.538 155.987 211.68 155.987C211.82 155.987 211.943 156.014 212.05 156.067C212.156 156.118 212.24 156.194 212.299 156.296C212.362 156.399 212.393 156.527 212.393 156.683C212.393 156.791 212.369 156.9 212.323 157.009C212.278 157.117 212.218 157.224 212.143 157.328C212.068 157.43 211.983 157.529 211.89 157.624C211.799 157.72 211.705 157.81 211.607 157.894C211.512 157.978 211.422 158.055 211.338 158.124H212.472V158.357H210.925Z",
    fill: "#7F7F7D",
    style: (_ref325 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref325, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref325, "fillOpacity", 1), _ref325)
  }), _mask189 || (_mask189 = /*#__PURE__*/React.createElement("mask", {
    id: "path-518-inside-189_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 153.357H243.473V160.929H215.312V153.357Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 153.357H243.473V160.929H215.312V153.357Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 153.357V153.079H215.035V153.357H215.312ZM215.312 153.357V153.634H243.473V153.357V153.079H215.312V153.357ZM215.312 160.929H215.59V153.357H215.312H215.035V160.929H215.312Z",
    fill: "#EAEEED",
    style: (_ref326 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref326, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref326, "fillOpacity", 1), _ref326),
    mask: "url(#path-518-inside-189_17113_221003)"
  }), _mask190 || (_mask190 = /*#__PURE__*/React.createElement("mask", {
    id: "path-520-inside-190_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 153.357H271.634V160.929H243.474V153.357Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 153.357H271.634V160.929H243.474V153.357Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 153.357V153.079H243.196V153.357H243.474ZM243.474 153.357V153.634H271.634V153.357V153.079H243.474V153.357ZM243.474 160.929H243.751V153.357H243.474H243.196V160.929H243.474Z",
    fill: "#EAEEED",
    style: (_ref327 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref327, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref327, "fillOpacity", 1), _ref327),
    mask: "url(#path-520-inside-190_17113_221003)"
  }), _mask191 || (_mask191 = /*#__PURE__*/React.createElement("mask", {
    id: "path-522-inside-191_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 153.357H299.795V160.929H271.634V153.357Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 153.357H299.795V160.929H271.634V153.357Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 153.357V153.079H271.356V153.357H271.634ZM271.634 153.357V153.634H299.795V153.357V153.079H271.634V153.357ZM271.634 160.929H271.911V153.357H271.634H271.356V160.929H271.634Z",
    fill: "#EAEEED",
    style: (_ref328 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref328, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref328, "fillOpacity", 1), _ref328),
    mask: "url(#path-522-inside-191_17113_221003)"
  }), _mask192 || (_mask192 = /*#__PURE__*/React.createElement("mask", {
    id: "path-524-inside-192_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 153.357H327.956V160.929H299.795V153.357Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 153.357H327.956V160.929H299.795V153.357Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 153.357V153.079H299.518V153.357H299.795ZM299.795 153.357V153.634H327.956V153.357V153.079H299.795V153.357ZM299.795 160.929H300.072V153.357H299.795H299.518V160.929H299.795Z",
    fill: "#EAEEED",
    style: (_ref329 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref329, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref329, "fillOpacity", 1), _ref329),
    mask: "url(#path-524-inside-192_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 160.929)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask193 || (_mask193 = /*#__PURE__*/React.createElement("mask", {
    id: "path-526-inside-193_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 160.929H215.312V168.502H206.992V160.929Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 160.929H215.312V168.502H206.992V160.929Z",
    fill: "#FAFAFA",
    style: (_ref330 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref330, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref330, "fillOpacity", 1), _ref330)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 160.929V161.207H215.312V160.929V160.652H206.992V160.929Z",
    fill: "url(#paint22_linear_17113_221003)",
    style: {},
    mask: "url(#path-526-inside-193_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.157 165.929V163.912L209.757 164.012V163.813L210.25 163.6H210.44V165.929H210.157ZM211.663 165.969C211.514 165.969 211.379 165.943 211.257 165.889C211.137 165.834 211.041 165.752 210.97 165.643C210.899 165.534 210.862 165.399 210.857 165.237H211.14C211.142 165.326 211.163 165.408 211.203 165.483C211.246 165.556 211.305 165.615 211.383 165.66C211.461 165.704 211.554 165.726 211.663 165.726C211.771 165.726 211.862 165.705 211.936 165.663C212.009 165.621 212.064 165.565 212.102 165.497C212.14 165.426 212.159 165.347 212.159 165.26C212.159 165.152 212.132 165.064 212.079 164.997C212.028 164.929 211.958 164.879 211.869 164.848C211.782 164.814 211.687 164.798 211.583 164.798H211.41V164.561H211.583C211.736 164.561 211.856 164.526 211.942 164.455C212.029 164.384 212.072 164.286 212.072 164.162C212.072 164.06 212.038 163.974 211.969 163.906C211.902 163.837 211.8 163.803 211.663 163.803C211.532 163.803 211.427 163.84 211.35 163.916C211.272 163.991 211.228 164.088 211.217 164.205H210.934C210.94 164.079 210.975 163.967 211.037 163.869C211.099 163.771 211.183 163.696 211.29 163.643C211.396 163.587 211.522 163.56 211.666 163.56C211.817 163.56 211.943 163.586 212.045 163.639C212.147 163.693 212.224 163.764 212.275 163.852C212.328 163.941 212.355 164.039 212.355 164.145C212.355 164.225 212.34 164.301 212.312 164.372C212.283 164.44 212.24 164.501 212.182 164.555C212.124 164.608 212.051 164.646 211.962 164.668C212.053 164.686 212.134 164.72 212.205 164.771C212.278 164.822 212.336 164.889 212.378 164.971C212.42 165.053 212.441 165.149 212.441 165.26C212.441 165.387 212.411 165.504 212.352 165.613C212.294 165.72 212.207 165.806 212.092 165.873C211.977 165.937 211.834 165.969 211.663 165.969Z",
    fill: "#7F7F7D",
    style: (_ref331 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref331, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref331, "fillOpacity", 1), _ref331)
  }), _mask194 || (_mask194 = /*#__PURE__*/React.createElement("mask", {
    id: "path-529-inside-194_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 160.929H243.473V168.502H215.312V160.929Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 160.929H243.473V168.502H215.312V160.929Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 160.929V160.652H215.035V160.929H215.312ZM215.312 160.929V161.207H243.473V160.929V160.652H215.312V160.929ZM215.312 168.502H215.59V160.929H215.312H215.035V168.502H215.312Z",
    fill: "#EAEEED",
    style: (_ref332 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref332, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref332, "fillOpacity", 1), _ref332),
    mask: "url(#path-529-inside-194_17113_221003)"
  }), _mask195 || (_mask195 = /*#__PURE__*/React.createElement("mask", {
    id: "path-531-inside-195_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 160.929H271.634V168.502H243.474V160.929Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 160.929H271.634V168.502H243.474V160.929Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 160.929V160.652H243.196V160.929H243.474ZM243.474 160.929V161.207H271.634V160.929V160.652H243.474V160.929ZM243.474 168.502H243.751V160.929H243.474H243.196V168.502H243.474Z",
    fill: "#EAEEED",
    style: (_ref333 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref333, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref333, "fillOpacity", 1), _ref333),
    mask: "url(#path-531-inside-195_17113_221003)"
  }), _mask196 || (_mask196 = /*#__PURE__*/React.createElement("mask", {
    id: "path-533-inside-196_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 160.929H299.795V168.502H271.634V160.929Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 160.929H299.795V168.502H271.634V160.929Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 160.929V160.652H271.356V160.929H271.634ZM271.634 160.929V161.207H299.795V160.929V160.652H271.634V160.929ZM271.634 168.502H271.911V160.929H271.634H271.356V168.502H271.634Z",
    fill: "#EAEEED",
    style: (_ref334 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref334, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref334, "fillOpacity", 1), _ref334),
    mask: "url(#path-533-inside-196_17113_221003)"
  }), _mask197 || (_mask197 = /*#__PURE__*/React.createElement("mask", {
    id: "path-535-inside-197_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 160.929H327.956V168.502H299.795V160.929Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 160.929H327.956V168.502H299.795V160.929Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 160.929V160.652H299.518V160.929H299.795ZM299.795 160.929V161.207H327.956V160.929V160.652H299.795V160.929ZM299.795 168.502H300.072V160.929H299.795H299.518V168.502H299.795Z",
    fill: "#EAEEED",
    style: (_ref335 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref335, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref335, "fillOpacity", 1), _ref335),
    mask: "url(#path-535-inside-197_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 168.502)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask198 || (_mask198 = /*#__PURE__*/React.createElement("mask", {
    id: "path-537-inside-198_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 168.502H215.312V176.074H206.992V168.502Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 168.502H215.312V176.074H206.992V168.502Z",
    fill: "#FAFAFA",
    style: (_ref336 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref336, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref336, "fillOpacity", 1), _ref336)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 168.502V168.779H215.312V168.502V168.224H206.992V168.502Z",
    fill: "url(#paint23_linear_17113_221003)",
    style: {},
    mask: "url(#path-537-inside-198_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.129 173.502V171.485L209.73 171.585V171.385L210.222 171.172H210.412V173.502H210.129ZM211.965 173.502V173.003H210.783V172.786L211.915 171.172H212.241V172.756H212.587V173.003H212.241V173.502H211.965ZM211.093 172.756H211.978V171.482L211.093 172.756Z",
    fill: "#7F7F7D",
    style: (_ref337 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref337, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref337, "fillOpacity", 1), _ref337)
  }), _mask199 || (_mask199 = /*#__PURE__*/React.createElement("mask", {
    id: "path-540-inside-199_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 168.502H243.473V176.074H215.312V168.502Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 168.502H243.473V176.074H215.312V168.502Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 168.502V168.224H215.035V168.502H215.312ZM215.312 168.502V168.779H243.473V168.502V168.224H215.312V168.502ZM215.312 176.074H215.59V168.502H215.312H215.035V176.074H215.312Z",
    fill: "#EAEEED",
    style: (_ref338 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref338, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref338, "fillOpacity", 1), _ref338),
    mask: "url(#path-540-inside-199_17113_221003)"
  }), _mask200 || (_mask200 = /*#__PURE__*/React.createElement("mask", {
    id: "path-542-inside-200_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 168.502H271.634V176.074H243.474V168.502Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 168.502H271.634V176.074H243.474V168.502Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 168.502V168.224H243.196V168.502H243.474ZM243.474 168.502V168.779H271.634V168.502V168.224H243.474V168.502ZM243.474 176.074H243.751V168.502H243.474H243.196V176.074H243.474Z",
    fill: "#EAEEED",
    style: (_ref339 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref339, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref339, "fillOpacity", 1), _ref339),
    mask: "url(#path-542-inside-200_17113_221003)"
  }), _mask201 || (_mask201 = /*#__PURE__*/React.createElement("mask", {
    id: "path-544-inside-201_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 168.502H299.795V176.074H271.634V168.502Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 168.502H299.795V176.074H271.634V168.502Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 168.502V168.224H271.356V168.502H271.634ZM271.634 168.502V168.779H299.795V168.502V168.224H271.634V168.502ZM271.634 176.074H271.911V168.502H271.634H271.356V176.074H271.634Z",
    fill: "#EAEEED",
    style: (_ref340 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref340, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref340, "fillOpacity", 1), _ref340),
    mask: "url(#path-544-inside-201_17113_221003)"
  }), _mask202 || (_mask202 = /*#__PURE__*/React.createElement("mask", {
    id: "path-546-inside-202_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 168.502H327.956V176.074H299.795V168.502Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 168.502H327.956V176.074H299.795V168.502Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 168.502V168.224H299.518V168.502H299.795ZM299.795 168.502V168.779H327.956V168.502V168.224H299.795V168.502ZM299.795 176.074H300.072V168.502H299.795H299.518V176.074H299.795Z",
    fill: "#EAEEED",
    style: (_ref341 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref341, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref341, "fillOpacity", 1), _ref341),
    mask: "url(#path-546-inside-202_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 176.074)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask203 || (_mask203 = /*#__PURE__*/React.createElement("mask", {
    id: "path-548-inside-203_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 176.074H215.312V183.647H206.992V176.074Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 176.074H215.312V183.647H206.992V176.074Z",
    fill: "#FAFAFA",
    style: (_ref342 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref342, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref342, "fillOpacity", 1), _ref342)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 176.074V176.352H215.312V176.074V175.797H206.992V176.074Z",
    fill: "url(#paint24_linear_17113_221003)",
    style: {},
    mask: "url(#path-548-inside-203_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.124 181.074V179.058L209.725 179.157V178.958L210.217 178.745H210.407V181.074H210.124ZM211.69 181.114C211.53 181.114 211.392 181.086 211.274 181.028C211.159 180.97 211.067 180.891 210.998 180.792C210.931 180.692 210.889 180.58 210.871 180.455H211.144C211.171 180.58 211.232 180.681 211.327 180.758C211.423 180.836 211.545 180.875 211.693 180.875C211.804 180.875 211.899 180.849 211.976 180.798C212.056 180.747 212.117 180.677 212.159 180.589C212.204 180.5 212.226 180.401 212.226 180.292C212.226 180.179 212.204 180.079 212.159 179.993C212.115 179.906 212.054 179.84 211.976 179.793C211.899 179.744 211.808 179.72 211.703 179.72C211.577 179.72 211.469 179.748 211.381 179.803C211.292 179.859 211.225 179.93 211.181 180.016H210.911L211.104 178.745H212.336V178.988H211.321L211.191 179.703C211.246 179.639 211.32 179.587 211.411 179.547C211.504 179.505 211.611 179.484 211.733 179.484C211.849 179.484 211.953 179.504 212.046 179.544C212.139 179.583 212.219 179.64 212.286 179.713C212.352 179.786 212.403 179.872 212.439 179.97C212.477 180.067 212.495 180.174 212.495 180.289C212.495 180.402 212.477 180.509 212.439 180.609C212.403 180.706 212.351 180.794 212.282 180.871C212.214 180.947 212.129 181.007 212.03 181.051C211.93 181.093 211.817 181.114 211.69 181.114Z",
    fill: "#7F7F7D",
    style: (_ref343 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref343, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref343, "fillOpacity", 1), _ref343)
  }), _mask204 || (_mask204 = /*#__PURE__*/React.createElement("mask", {
    id: "path-551-inside-204_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 176.074H243.473V183.647H215.312V176.074Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 176.074H243.473V183.647H215.312V176.074Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 176.074V175.797H215.035V176.074H215.312ZM215.312 176.074V176.352H243.473V176.074V175.797H215.312V176.074ZM215.312 183.647H215.59V176.074H215.312H215.035V183.647H215.312Z",
    fill: "#EAEEED",
    style: (_ref344 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref344, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref344, "fillOpacity", 1), _ref344),
    mask: "url(#path-551-inside-204_17113_221003)"
  }), _mask205 || (_mask205 = /*#__PURE__*/React.createElement("mask", {
    id: "path-553-inside-205_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 176.074H271.634V183.647H243.474V176.074Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 176.074H271.634V183.647H243.474V176.074Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 176.074V175.797H243.196V176.074H243.474ZM243.474 176.074V176.352H271.634V176.074V175.797H243.474V176.074ZM243.474 183.647H243.751V176.074H243.474H243.196V183.647H243.474Z",
    fill: "#EAEEED",
    style: (_ref345 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref345, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref345, "fillOpacity", 1), _ref345),
    mask: "url(#path-553-inside-205_17113_221003)"
  }), _mask206 || (_mask206 = /*#__PURE__*/React.createElement("mask", {
    id: "path-555-inside-206_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 176.074H299.795V183.647H271.634V176.074Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 176.074H299.795V183.647H271.634V176.074Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 176.074V175.797H271.356V176.074H271.634ZM271.634 176.074V176.352H299.795V176.074V175.797H271.634V176.074ZM271.634 183.647H271.911V176.074H271.634H271.356V183.647H271.634Z",
    fill: "#EAEEED",
    style: (_ref346 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref346, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref346, "fillOpacity", 1), _ref346),
    mask: "url(#path-555-inside-206_17113_221003)"
  }), _mask207 || (_mask207 = /*#__PURE__*/React.createElement("mask", {
    id: "path-557-inside-207_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 176.074H327.956V183.647H299.795V176.074Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 176.074H327.956V183.647H299.795V176.074Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 176.074V175.797H299.518V176.074H299.795ZM299.795 176.074V176.352H327.956V176.074V175.797H299.795V176.074ZM299.795 183.647H300.072V176.074H299.795H299.518V183.647H299.795Z",
    fill: "#EAEEED",
    style: (_ref347 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref347, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref347, "fillOpacity", 1), _ref347),
    mask: "url(#path-557-inside-207_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(206.992 183.647)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask208 || (_mask208 = /*#__PURE__*/React.createElement("mask", {
    id: "path-559-inside-208_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 183.647H215.312V191.22H206.992V183.647Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 183.647H215.312V191.22H206.992V183.647Z",
    fill: "#FAFAFA",
    style: (_ref348 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref348, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref348, "fillOpacity", 1), _ref348)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.992 183.647V183.924H215.312V183.647V183.37H206.992V183.647Z",
    fill: "url(#paint25_linear_17113_221003)",
    style: {},
    mask: "url(#path-559-inside-208_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.095 188.647V186.63L209.696 186.73V186.53L210.188 186.317H210.378V188.647H210.095ZM211.711 188.687C211.542 188.687 211.4 188.656 211.285 188.594C211.169 188.53 211.077 188.445 211.009 188.341C210.94 188.234 210.889 188.115 210.855 187.981C210.824 187.848 210.809 187.713 210.809 187.575C210.809 187.318 210.844 187.093 210.915 186.9C210.986 186.705 211.088 186.553 211.222 186.444C211.357 186.333 211.519 186.277 211.707 186.277C211.854 186.277 211.979 186.306 212.083 186.364C212.19 186.419 212.274 186.495 212.336 186.59C212.399 186.686 212.436 186.792 212.45 186.91H212.19C212.168 186.786 212.113 186.69 212.027 186.624C211.943 186.555 211.835 186.52 211.704 186.52C211.589 186.52 211.484 186.557 211.391 186.63C211.298 186.701 211.224 186.811 211.168 186.96C211.115 187.106 211.084 187.294 211.075 187.522C211.075 187.524 211.075 187.528 211.075 187.532C211.075 187.537 211.075 187.541 211.075 187.545C211.111 187.477 211.159 187.412 211.222 187.352C211.286 187.293 211.362 187.245 211.451 187.209C211.54 187.174 211.639 187.156 211.747 187.156C211.878 187.156 212.001 187.187 212.117 187.249C212.232 187.311 212.325 187.399 212.396 187.512C212.47 187.623 212.506 187.754 212.506 187.905C212.506 188.036 212.474 188.161 212.41 188.281C212.348 188.401 212.257 188.498 212.137 188.574C212.017 188.649 211.875 188.687 211.711 188.687ZM211.691 188.441C211.793 188.441 211.884 188.419 211.964 188.374C212.046 188.328 212.109 188.265 212.153 188.188C212.2 188.108 212.223 188.018 212.223 187.918C212.223 187.814 212.2 187.723 212.153 187.645C212.109 187.568 212.046 187.508 211.964 187.466C211.884 187.421 211.793 187.399 211.691 187.399C211.589 187.399 211.497 187.422 211.415 187.469C211.332 187.516 211.267 187.579 211.218 187.659C211.172 187.736 211.148 187.824 211.148 187.922C211.148 188.021 211.172 188.111 211.218 188.191C211.267 188.269 211.332 188.33 211.415 188.374C211.497 188.419 211.589 188.441 211.691 188.441Z",
    fill: "#7F7F7D",
    style: (_ref349 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref349, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref349, "fillOpacity", 1), _ref349)
  }), _mask209 || (_mask209 = /*#__PURE__*/React.createElement("mask", {
    id: "path-562-inside-209_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.312 183.647H243.473V191.22H215.312V183.647Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 183.647H243.473V191.22H215.312V183.647Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.312 183.647V183.37H215.035V183.647H215.312ZM215.312 183.647V183.924H243.473V183.647V183.37H215.312V183.647ZM215.312 191.22H215.59V183.647H215.312H215.035V191.22H215.312Z",
    fill: "#EAEEED",
    style: (_ref350 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref350, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref350, "fillOpacity", 1), _ref350),
    mask: "url(#path-562-inside-209_17113_221003)"
  }), _mask210 || (_mask210 = /*#__PURE__*/React.createElement("mask", {
    id: "path-564-inside-210_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.474 183.647H271.634V191.22H243.474V183.647Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 183.647H271.634V191.22H243.474V183.647Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.474 183.647V183.37H243.196V183.647H243.474ZM243.474 183.647V183.924H271.634V183.647V183.37H243.474V183.647ZM243.474 191.22H243.751V183.647H243.474H243.196V191.22H243.474Z",
    fill: "#EAEEED",
    style: (_ref351 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref351, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref351, "fillOpacity", 1), _ref351),
    mask: "url(#path-564-inside-210_17113_221003)"
  }), _mask211 || (_mask211 = /*#__PURE__*/React.createElement("mask", {
    id: "path-566-inside-211_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.634 183.647H299.795V191.22H271.634V183.647Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 183.647H299.795V191.22H271.634V183.647Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.634 183.647V183.37H271.356V183.647H271.634ZM271.634 183.647V183.924H299.795V183.647V183.37H271.634V183.647ZM271.634 191.22H271.911V183.647H271.634H271.356V191.22H271.634Z",
    fill: "#EAEEED",
    style: (_ref352 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref352, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref352, "fillOpacity", 1), _ref352),
    mask: "url(#path-566-inside-211_17113_221003)"
  }), _mask212 || (_mask212 = /*#__PURE__*/React.createElement("mask", {
    id: "path-568-inside-212_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.795 183.647H327.956V191.22H299.795V183.647Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 183.647H327.956V191.22H299.795V183.647Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 183.647V183.37H299.518V183.647H299.795ZM299.795 183.647V183.924H327.956V183.647V183.37H299.795V183.647ZM299.795 191.22H300.072V183.647H299.795H299.518V191.22H299.795Z",
    fill: "#EAEEED",
    style: (_ref353 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref353, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref353, "fillOpacity", 1), _ref353),
    mask: "url(#path-568-inside-212_17113_221003)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 206.923,
    y: 50.5746,
    width: 374.549,
    height: 208.145,
    rx: 2.28806,
    stroke: "#EAEEED",
    style: (_ref354 = {
      stroke: "#EAEEED"
    }, _defineProperty(_ref354, "stroke", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref354, "strokeOpacity", 1), _ref354),
    strokeWidth: 0.138671,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 207.172,
    y: 50.8233,
    width: 169.231,
    height: 137.798,
    rx: 5.68596,
    stroke: "#C2E6D1",
    style: (_ref355 = {
      stroke: "#C2E6D1"
    }, _defineProperty(_ref355, "stroke", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref355, "strokeOpacity", 1), _ref355),
    strokeWidth: 0.358752
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_17113_221003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_17113_221003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 99.9572C29.5166 96.1832 32.576 93.1238 36.35 93.1238H191.676C195.45 93.1238 198.51 96.1832 198.51 99.9572V196.345C198.51 200.119 195.45 203.178 191.676 203.178H36.35C32.576 203.178 29.5166 200.119 29.5166 196.345V99.9572Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_17113_221003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 9.98428,
    transform: "translate(29.5166 93.1238)",
    fill: "#E4F2E6",
    style: (_ref356 = {
      fill: "#E4F2E6"
    }, _defineProperty(_ref356, "fill", "color(display-p3 0.8941 0.9490 0.9020)"), _defineProperty(_ref356, "fillOpacity", 1), _ref356)
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_17113_221003)"
  }, _mask213 || (_mask213 = /*#__PURE__*/React.createElement("mask", {
    id: "path-574-inside-213_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 103.108H403.927V112.538H29.5166V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 103.108H403.927V112.538H29.5166V103.108Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.32023,
    height: 9.4296,
    transform: "translate(29.5166 103.108)",
    fill: "#FAFAFA",
    style: (_ref357 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref357, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref357, "fillOpacity", 1), _ref357)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4209 112.122H30.4385L37.4209 104.208V112.122Z",
    fill: "#EAEEED",
    stroke: "#FAFAFA",
    style: (_ref358 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref358, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref358, "fillOpacity", 1), _defineProperty(_ref358, "stroke", "#FAFAFA"), _defineProperty(_ref358, "stroke", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref358, "strokeOpacity", 1), _ref358),
    strokeWidth: 0.832024,
    strokeLinejoin: "round"
  }), _mask214 || (_mask214 = /*#__PURE__*/React.createElement("mask", {
    id: "path-577-inside-214_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 103.108H65.9977V112.538H37.8369V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 103.108H65.9977V112.538H37.8369V103.108Z",
    fill: "#FAFAFA",
    style: (_ref359 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref359, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref359, "fillOpacity", 1), _ref359)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 112.538H38.1143V103.108H37.8369H37.5596V112.538H37.8369Z",
    fill: "url(#paint26_linear_17113_221003)",
    style: {},
    mask: "url(#path-577-inside-214_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7446 109.108L51.7463 106.39H52.0919L53.0898 109.108H52.7442L51.9172 106.798L51.0863 109.108H50.7446ZM51.2028 108.409L51.2959 108.145H52.5268L52.62 108.409H51.2028Z",
    fill: "#7F7F7D",
    style: (_ref360 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref360, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref360, "fillOpacity", 1), _ref360)
  }), _mask215 || (_mask215 = /*#__PURE__*/React.createElement("mask", {
    id: "path-580-inside-215_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 103.108H94.1588V112.538H65.998V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 103.108H94.1588V112.538H65.998V103.108Z",
    fill: "#FAFAFA",
    style: (_ref361 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref361, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref361, "fillOpacity", 1), _ref361)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 112.538H66.2754V103.108H65.998H65.7207V112.538H65.998Z",
    fill: "url(#paint27_linear_17113_221003)",
    style: {},
    mask: "url(#path-580-inside-215_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1999 109.108V106.39H80.1551C80.3466 106.39 80.5045 106.421 80.6288 106.483C80.7556 106.543 80.8501 106.626 80.9122 106.732C80.9743 106.835 81.0054 106.952 81.0054 107.081C81.0054 107.221 80.9743 107.337 80.9122 107.431C80.8527 107.524 80.7737 107.595 80.6753 107.644C80.5796 107.693 80.4773 107.723 80.3686 107.734L80.423 107.695C80.5394 107.697 80.6469 107.728 80.7452 107.788C80.8436 107.847 80.9213 107.928 80.9782 108.029C81.0377 108.13 81.0675 108.242 81.0675 108.366C81.0675 108.504 81.0339 108.629 80.9666 108.743C80.8993 108.854 80.7996 108.944 80.6676 109.011C80.5382 109.076 80.3777 109.108 80.1861 109.108H79.1999ZM79.526 108.836H80.1512C80.335 108.836 80.4773 108.794 80.5783 108.708C80.6818 108.62 80.7336 108.498 80.7336 108.343C80.7336 108.19 80.6805 108.069 80.5744 107.978C80.4709 107.885 80.3272 107.838 80.1434 107.838H79.526V108.836ZM79.526 107.578H80.1318C80.3078 107.578 80.4411 107.537 80.5317 107.454C80.6249 107.371 80.6715 107.259 80.6715 107.116C80.6715 106.979 80.6249 106.869 80.5317 106.786C80.4411 106.703 80.3039 106.662 80.1201 106.662H79.526V107.578Z",
    fill: "#7F7F7D",
    style: (_ref362 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref362, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref362, "fillOpacity", 1), _ref362)
  }), _mask216 || (_mask216 = /*#__PURE__*/React.createElement("mask", {
    id: "path-583-inside-216_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 103.108H122.319V112.538H94.1582V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 103.108H122.319V112.538H94.1582V103.108Z",
    fill: "#FAFAFA",
    style: (_ref363 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref363, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref363, "fillOpacity", 1), _ref363)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 112.538H94.4355V103.108H94.1582H93.8809V112.538H94.1582Z",
    fill: "url(#paint28_linear_17113_221003)",
    style: {},
    mask: "url(#path-583-inside-216_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.319 109.155C108.055 109.155 107.825 109.096 107.631 108.98C107.44 108.861 107.292 108.696 107.189 108.487C107.085 108.275 107.033 108.029 107.033 107.749C107.033 107.47 107.085 107.225 107.189 107.015C107.292 106.803 107.44 106.639 107.631 106.522C107.825 106.403 108.055 106.343 108.319 106.343C108.629 106.343 108.882 106.417 109.076 106.565C109.27 106.712 109.394 106.921 109.448 107.19H109.087C109.046 107.022 108.962 106.887 108.835 106.786C108.708 106.683 108.536 106.631 108.319 106.631C108.124 106.631 107.956 106.676 107.814 106.767C107.671 106.855 107.561 106.983 107.484 107.151C107.406 107.317 107.367 107.516 107.367 107.749C107.367 107.982 107.406 108.183 107.484 108.351C107.561 108.517 107.671 108.645 107.814 108.735C107.956 108.823 108.124 108.867 108.319 108.867C108.536 108.867 108.708 108.818 108.835 108.72C108.962 108.619 109.046 108.485 109.087 108.32H109.448C109.394 108.581 109.27 108.786 109.076 108.933C108.882 109.081 108.629 109.155 108.319 109.155Z",
    fill: "#7F7F7D",
    style: (_ref364 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref364, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref364, "fillOpacity", 1), _ref364)
  }), _mask217 || (_mask217 = /*#__PURE__*/React.createElement("mask", {
    id: "path-586-inside-217_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 103.108H150.48V112.538H122.319V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 103.108H150.48V112.538H122.319V103.108Z",
    fill: "#FAFAFA",
    style: (_ref365 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref365, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref365, "fillOpacity", 1), _ref365)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 112.538H122.597V103.108H122.319H122.042V112.538H122.319Z",
    fill: "url(#paint29_linear_17113_221003)",
    style: {},
    mask: "url(#path-586-inside-217_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.354 109.108V106.39H136.154C136.473 106.39 136.734 106.446 136.939 106.557C137.146 106.666 137.298 106.822 137.397 107.027C137.498 107.229 137.548 107.472 137.548 107.757C137.548 108.036 137.498 108.277 137.397 108.479C137.298 108.681 137.146 108.836 136.939 108.945C136.734 109.054 136.473 109.108 136.154 109.108H135.354ZM135.68 108.836H136.146C136.41 108.836 136.62 108.794 136.775 108.708C136.931 108.62 137.042 108.496 137.109 108.335C137.177 108.172 137.21 107.979 137.21 107.757C137.21 107.529 137.177 107.334 137.109 107.171C137.042 107.007 136.931 106.882 136.775 106.794C136.62 106.706 136.41 106.662 136.146 106.662H135.68V108.836Z",
    fill: "#7F7F7D",
    style: (_ref366 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref366, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref366, "fillOpacity", 1), _ref366)
  }), _mask218 || (_mask218 = /*#__PURE__*/React.createElement("mask", {
    id: "path-589-inside-218_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 103.108H178.641V112.538H150.48V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 103.108H178.641V112.538H150.48V103.108Z",
    fill: "#FAFAFA",
    style: (_ref367 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref367, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref367, "fillOpacity", 1), _ref367)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 112.538H150.758V103.108H150.48H150.203V112.538H150.48Z",
    fill: "url(#paint30_linear_17113_221003)",
    style: {},
    mask: "url(#path-589-inside-218_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.754 109.108V106.39H165.436V106.658H164.081V107.605H165.319V107.869H164.081V108.84H165.436V109.108H163.754Z",
    fill: "#7F7F7D",
    style: (_ref368 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref368, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref368, "fillOpacity", 1), _ref368)
  }), _mask219 || (_mask219 = /*#__PURE__*/React.createElement("mask", {
    id: "path-592-inside-219_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 103.108H206.801V112.538H178.641V103.108Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 103.108H206.801V112.538H178.641V103.108Z",
    fill: "#FAFAFA",
    style: (_ref369 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref369, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref369, "fillOpacity", 1), _ref369)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 112.538H178.918V103.108H178.641H178.363V112.538H178.641Z",
    fill: "url(#paint31_linear_17113_221003)",
    style: {},
    mask: "url(#path-592-inside-219_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.973 109.108V106.39H193.627V106.658H192.299V107.613H193.429V107.877H192.299V109.108H191.973Z",
    fill: "#7F7F7D",
    style: (_ref370 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref370, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref370, "fillOpacity", 1), _ref370)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 103.108V103.385H403.927V103.108V102.831H29.5166V103.108Z",
    fill: "#EAEEED",
    style: (_ref371 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref371, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref371, "fillOpacity", 1), _ref371),
    mask: "url(#path-574-inside-213_17113_221003)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 112.538)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask220 || (_mask220 = /*#__PURE__*/React.createElement("mask", {
    id: "path-595-inside-220_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 112.538H37.8368V120.11H29.5166V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 112.538H37.8368V120.11H29.5166V112.538Z",
    fill: "#FAFAFA",
    style: (_ref372 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref372, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref372, "fillOpacity", 1), _ref372)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 112.538V112.815H37.8368V112.538V112.26H29.5166V112.538Z",
    fill: "url(#paint32_linear_17113_221003)",
    style: {},
    mask: "url(#path-595-inside-220_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6642 117.538V115.521L33.2648 115.621V115.421L33.7574 115.208H33.9471V117.538H33.6642Z",
    fill: "#7F7F7D",
    style: (_ref373 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref373, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref373, "fillOpacity", 1), _ref373)
  }), _mask221 || (_mask221 = /*#__PURE__*/React.createElement("mask", {
    id: "path-598-inside-221_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 112.538H65.9977V120.11H37.8369V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 112.538H65.9977V120.11H37.8369V112.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 112.538V112.26H37.5596V112.538H37.8369ZM37.8369 112.538V112.815H65.9977V112.538V112.26H37.8369V112.538ZM37.8369 120.11H38.1143V112.538H37.8369H37.5596V120.11H37.8369Z",
    fill: "#EAEEED",
    style: (_ref374 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref374, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref374, "fillOpacity", 1), _ref374),
    mask: "url(#path-598-inside-221_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 116.324H60.5696",
    stroke: "#99ABA7",
    style: (_ref375 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref375, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref375, "strokeOpacity", 1), _ref375),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask222 || (_mask222 = /*#__PURE__*/React.createElement("mask", {
    id: "path-601-inside-222_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 112.538H94.1588V120.11H65.998V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 112.538H94.1588V120.11H65.998V112.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 112.538V112.26H65.7207V112.538H65.998ZM65.998 112.538V112.815H94.1588V112.538V112.26H65.998V112.538ZM65.998 120.11H66.2754V112.538H65.998H65.7207V120.11H65.998Z",
    fill: "#EAEEED",
    style: (_ref376 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref376, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref376, "fillOpacity", 1), _ref376),
    mask: "url(#path-601-inside-222_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 116.324H88.7308",
    stroke: "#99ABA7",
    style: (_ref377 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref377, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref377, "strokeOpacity", 1), _ref377),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask223 || (_mask223 = /*#__PURE__*/React.createElement("mask", {
    id: "path-604-inside-223_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 112.538H122.319V120.11H94.1582V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 112.538H122.319V120.11H94.1582V112.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 112.538V112.26H93.8809V112.538H94.1582ZM94.1582 112.538V112.815H122.319V112.538V112.26H94.1582V112.538ZM94.1582 120.11H94.4355V112.538H94.1582H93.8809V120.11H94.1582Z",
    fill: "#EAEEED",
    style: (_ref378 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref378, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref378, "fillOpacity", 1), _ref378),
    mask: "url(#path-604-inside-223_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 116.324H116.891",
    stroke: "#99ABA7",
    style: (_ref379 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref379, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref379, "strokeOpacity", 1), _ref379),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask224 || (_mask224 = /*#__PURE__*/React.createElement("mask", {
    id: "path-607-inside-224_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 112.538H150.48V120.11H122.319V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 112.538H150.48V120.11H122.319V112.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 112.538V112.26H122.042V112.538H122.319ZM122.319 112.538V112.815H150.48V112.538V112.26H122.319V112.538ZM122.319 120.11H122.597V112.538H122.319H122.042V120.11H122.319Z",
    fill: "#EAEEED",
    style: (_ref380 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref380, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref380, "fillOpacity", 1), _ref380),
    mask: "url(#path-607-inside-224_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 116.324H145.052",
    stroke: "#99ABA7",
    style: (_ref381 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref381, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref381, "strokeOpacity", 1), _ref381),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask225 || (_mask225 = /*#__PURE__*/React.createElement("mask", {
    id: "path-610-inside-225_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 112.538H178.641V120.11H150.48V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 112.538H178.641V120.11H150.48V112.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 112.538V112.26H150.203V112.538H150.48ZM150.48 112.538V112.815H178.641V112.538V112.26H150.48V112.538ZM150.48 120.11H150.758V112.538H150.48H150.203V120.11H150.48Z",
    fill: "#EAEEED",
    style: (_ref382 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref382, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref382, "fillOpacity", 1), _ref382),
    mask: "url(#path-610-inside-225_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 116.324H173.213",
    stroke: "#99ABA7",
    style: (_ref383 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref383, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref383, "strokeOpacity", 1), _ref383),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask226 || (_mask226 = /*#__PURE__*/React.createElement("mask", {
    id: "path-613-inside-226_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 112.538H206.801V120.11H178.641V112.538Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 112.538H206.801V120.11H178.641V112.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 112.538V112.26H178.363V112.538H178.641ZM178.641 112.538V112.815H206.801V112.538V112.26H178.641V112.538ZM178.641 120.11H178.918V112.538H178.641H178.363V120.11H178.641Z",
    fill: "#EAEEED",
    style: (_ref384 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref384, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref384, "fillOpacity", 1), _ref384),
    mask: "url(#path-613-inside-226_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 116.324H201.373",
    stroke: "#99ABA7",
    style: (_ref385 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref385, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref385, "strokeOpacity", 1), _ref385),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 120.11)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask227 || (_mask227 = /*#__PURE__*/React.createElement("mask", {
    id: "path-616-inside-227_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 120.11H37.8368V127.683H29.5166V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 120.11H37.8368V127.683H29.5166V120.11Z",
    fill: "#FAFAFA",
    style: (_ref386 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref386, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref386, "fillOpacity", 1), _ref386)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 120.11V120.388H37.8368V120.11V119.833H29.5166V120.11Z",
    fill: "url(#paint33_linear_17113_221003)",
    style: {},
    mask: "url(#path-616-inside-227_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9309 125.11V124.914C33.0885 124.79 33.2382 124.664 33.3802 124.538C33.5244 124.411 33.652 124.286 33.763 124.162C33.8739 124.035 33.9604 123.912 34.0226 123.792C34.0869 123.672 34.1191 123.557 34.1191 123.446C34.1191 123.364 34.1046 123.289 34.0758 123.22C34.047 123.149 34.0004 123.091 33.936 123.047C33.8739 123.002 33.7896 122.98 33.6831 122.98C33.5788 122.98 33.4923 123.004 33.4235 123.05C33.3547 123.095 33.3026 123.154 33.2671 123.23C33.2338 123.303 33.2172 123.384 33.2172 123.473H32.9476C32.9498 123.32 32.982 123.189 33.0441 123.08C33.1084 122.969 33.1961 122.885 33.307 122.827C33.418 122.769 33.5444 122.741 33.6864 122.741C33.8262 122.741 33.9493 122.767 34.0558 122.821C34.1623 122.872 34.2455 122.948 34.3054 123.05C34.3676 123.152 34.3986 123.281 34.3986 123.436C34.3986 123.545 34.3753 123.654 34.3287 123.762C34.2844 123.871 34.2245 123.978 34.149 124.082C34.0736 124.184 33.9893 124.283 33.8961 124.378C33.8051 124.473 33.7108 124.563 33.6132 124.648C33.5178 124.732 33.4279 124.808 33.3436 124.877H34.4785V125.11H32.9309Z",
    fill: "#7F7F7D",
    style: (_ref387 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref387, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref387, "fillOpacity", 1), _ref387)
  }), _mask228 || (_mask228 = /*#__PURE__*/React.createElement("mask", {
    id: "path-619-inside-228_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 120.11H65.9977V127.683H37.8369V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 120.11H65.9977V127.683H37.8369V120.11Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 120.11V119.833H37.5596V120.11H37.8369ZM37.8369 120.11V120.388H65.9977V120.11V119.833H37.8369V120.11ZM37.8369 127.683H38.1143V120.11H37.8369H37.5596V127.683H37.8369Z",
    fill: "#EAEEED",
    style: (_ref388 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref388, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref388, "fillOpacity", 1), _ref388),
    mask: "url(#path-619-inside-228_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 123.896H60.5696",
    stroke: "#CCD5D3",
    style: (_ref389 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref389, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref389, "strokeOpacity", 1), _ref389),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask229 || (_mask229 = /*#__PURE__*/React.createElement("mask", {
    id: "path-622-inside-229_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 120.11H94.1588V127.683H65.998V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 120.11H94.1588V127.683H65.998V120.11Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 120.11V119.833H65.7207V120.11H65.998ZM65.998 120.11V120.388H94.1588V120.11V119.833H65.998V120.11ZM65.998 127.683H66.2754V120.11H65.998H65.7207V127.683H65.998Z",
    fill: "#EAEEED",
    style: (_ref390 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref390, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref390, "fillOpacity", 1), _ref390),
    mask: "url(#path-622-inside-229_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 123.896H88.7308",
    stroke: "#CCD5D3",
    style: (_ref391 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref391, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref391, "strokeOpacity", 1), _ref391),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask230 || (_mask230 = /*#__PURE__*/React.createElement("mask", {
    id: "path-625-inside-230_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 120.11H122.319V127.683H94.1582V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 120.11H122.319V127.683H94.1582V120.11Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 120.11V119.833H93.8809V120.11H94.1582ZM94.1582 120.11V120.388H122.319V120.11V119.833H94.1582V120.11ZM94.1582 127.683H94.4355V120.11H94.1582H93.8809V127.683H94.1582Z",
    fill: "#EAEEED",
    style: (_ref392 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref392, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref392, "fillOpacity", 1), _ref392),
    mask: "url(#path-625-inside-230_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 123.896H116.891",
    stroke: "#CCD5D3",
    style: (_ref393 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref393, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref393, "strokeOpacity", 1), _ref393),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask231 || (_mask231 = /*#__PURE__*/React.createElement("mask", {
    id: "path-628-inside-231_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 120.11H150.48V127.683H122.319V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 120.11H150.48V127.683H122.319V120.11Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 120.11V119.833H122.042V120.11H122.319ZM122.319 120.11V120.388H150.48V120.11V119.833H122.319V120.11ZM122.319 127.683H122.597V120.11H122.319H122.042V127.683H122.319Z",
    fill: "#EAEEED",
    style: (_ref394 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref394, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref394, "fillOpacity", 1), _ref394),
    mask: "url(#path-628-inside-231_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 123.896H145.052",
    stroke: "#CCD5D3",
    style: (_ref395 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref395, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref395, "strokeOpacity", 1), _ref395),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask232 || (_mask232 = /*#__PURE__*/React.createElement("mask", {
    id: "path-631-inside-232_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 120.11H178.641V127.683H150.48V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 120.11H178.641V127.683H150.48V120.11Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 120.11V119.833H150.203V120.11H150.48ZM150.48 120.11V120.388H178.641V120.11V119.833H150.48V120.11ZM150.48 127.683H150.758V120.11H150.48H150.203V127.683H150.48Z",
    fill: "#EAEEED",
    style: (_ref396 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref396, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref396, "fillOpacity", 1), _ref396),
    mask: "url(#path-631-inside-232_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 123.896H173.213",
    stroke: "#CCD5D3",
    style: (_ref397 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref397, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref397, "strokeOpacity", 1), _ref397),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask233 || (_mask233 = /*#__PURE__*/React.createElement("mask", {
    id: "path-634-inside-233_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 120.11H206.801V127.683H178.641V120.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 120.11H206.801V127.683H178.641V120.11Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 120.11V119.833H178.363V120.11H178.641ZM178.641 120.11V120.388H206.801V120.11V119.833H178.641V120.11ZM178.641 127.683H178.918V120.11H178.641H178.363V127.683H178.641Z",
    fill: "#EAEEED",
    style: (_ref398 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref398, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref398, "fillOpacity", 1), _ref398),
    mask: "url(#path-634-inside-233_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 123.896H201.373",
    stroke: "#CCD5D3",
    style: (_ref399 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref399, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref399, "strokeOpacity", 1), _ref399),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 127.683)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask234 || (_mask234 = /*#__PURE__*/React.createElement("mask", {
    id: "path-637-inside-234_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 127.683H37.8368V135.255H29.5166V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 127.683H37.8368V135.255H29.5166V127.683Z",
    fill: "#FAFAFA",
    style: (_ref400 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref400, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref400, "fillOpacity", 1), _ref400)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 127.683V127.96H37.8368V127.683V127.406H29.5166V127.683Z",
    fill: "url(#paint34_linear_17113_221003)",
    style: {},
    mask: "url(#path-637-inside-234_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6687 132.723C33.52 132.723 33.3847 132.696 33.2627 132.643C33.1429 132.587 33.0475 132.505 32.9765 132.397C32.9055 132.288 32.8677 132.153 32.8633 131.991H33.1462C33.1484 132.079 33.1695 132.161 33.2094 132.237C33.2516 132.31 33.3115 132.369 33.3891 132.413C33.4668 132.458 33.56 132.48 33.6687 132.48C33.7774 132.48 33.8684 132.459 33.9416 132.417C34.0148 132.374 34.0703 132.319 34.108 132.25C34.1457 132.179 34.1646 132.1 34.1646 132.014C34.1646 131.905 34.138 131.818 34.0847 131.751C34.0337 131.682 33.9638 131.632 33.875 131.601C33.7885 131.568 33.6931 131.551 33.5888 131.551H33.4158V131.315H33.5888C33.7419 131.315 33.8617 131.28 33.9483 131.209C34.0348 131.138 34.0781 131.04 34.0781 130.916C34.0781 130.814 34.0437 130.728 33.9749 130.659C33.9083 130.591 33.8063 130.556 33.6687 130.556C33.5378 130.556 33.4335 130.594 33.3559 130.669C33.2782 130.745 33.2338 130.841 33.2227 130.959H32.9398C32.9465 130.832 32.9809 130.72 33.043 130.623C33.1051 130.525 33.1895 130.45 33.296 130.396C33.4024 130.341 33.5278 130.313 33.672 130.313C33.8229 130.313 33.9494 130.34 34.0514 130.393C34.1535 130.446 34.23 130.517 34.2811 130.606C34.3343 130.695 34.3609 130.793 34.3609 130.899C34.3609 130.979 34.3465 131.054 34.3177 131.125C34.2888 131.194 34.2456 131.255 34.1879 131.308C34.1302 131.362 34.057 131.399 33.9682 131.422C34.0592 131.439 34.1402 131.474 34.2112 131.525C34.2844 131.576 34.3421 131.642 34.3842 131.724C34.4264 131.806 34.4475 131.903 34.4475 132.014C34.4475 132.14 34.4175 132.258 34.3576 132.367C34.2999 132.473 34.2134 132.56 34.098 132.626C33.9826 132.691 33.8395 132.723 33.6687 132.723Z",
    fill: "#7F7F7D",
    style: (_ref401 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref401, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref401, "fillOpacity", 1), _ref401)
  }), _mask235 || (_mask235 = /*#__PURE__*/React.createElement("mask", {
    id: "path-640-inside-235_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 127.683H65.9977V135.255H37.8369V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 127.683H65.9977V135.255H37.8369V127.683Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 127.683V127.406H37.5596V127.683H37.8369ZM37.8369 127.683V127.96H65.9977V127.683V127.406H37.8369V127.683ZM37.8369 135.255H38.1143V127.683H37.8369H37.5596V135.255H37.8369Z",
    fill: "#EAEEED",
    style: (_ref402 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref402, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref402, "fillOpacity", 1), _ref402),
    mask: "url(#path-640-inside-235_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 131.469H60.5696",
    stroke: "#CCD5D3",
    style: (_ref403 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref403, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref403, "strokeOpacity", 1), _ref403),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask236 || (_mask236 = /*#__PURE__*/React.createElement("mask", {
    id: "path-643-inside-236_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 127.683H94.1588V135.255H65.998V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 127.683H94.1588V135.255H65.998V127.683Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 127.683V127.406H65.7207V127.683H65.998ZM65.998 127.683V127.96H94.1588V127.683V127.406H65.998V127.683ZM65.998 135.255H66.2754V127.683H65.998H65.7207V135.255H65.998Z",
    fill: "#EAEEED",
    style: (_ref404 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref404, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref404, "fillOpacity", 1), _ref404),
    mask: "url(#path-643-inside-236_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 131.469H88.7308",
    stroke: "#CCD5D3",
    style: (_ref405 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref405, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref405, "strokeOpacity", 1), _ref405),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask237 || (_mask237 = /*#__PURE__*/React.createElement("mask", {
    id: "path-646-inside-237_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 127.683H122.319V135.255H94.1582V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 127.683H122.319V135.255H94.1582V127.683Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 127.683V127.406H93.8809V127.683H94.1582ZM94.1582 127.683V127.96H122.319V127.683V127.406H94.1582V127.683ZM94.1582 135.255H94.4355V127.683H94.1582H93.8809V135.255H94.1582Z",
    fill: "#EAEEED",
    style: (_ref406 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref406, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref406, "fillOpacity", 1), _ref406),
    mask: "url(#path-646-inside-237_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 131.469H116.891",
    stroke: "#CCD5D3",
    style: (_ref407 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref407, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref407, "strokeOpacity", 1), _ref407),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask238 || (_mask238 = /*#__PURE__*/React.createElement("mask", {
    id: "path-649-inside-238_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 127.683H150.48V135.255H122.319V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 127.683H150.48V135.255H122.319V127.683Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 127.683V127.406H122.042V127.683H122.319ZM122.319 127.683V127.96H150.48V127.683V127.406H122.319V127.683ZM122.319 135.255H122.597V127.683H122.319H122.042V135.255H122.319Z",
    fill: "#EAEEED",
    style: (_ref408 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref408, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref408, "fillOpacity", 1), _ref408),
    mask: "url(#path-649-inside-238_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 131.469H145.052",
    stroke: "#CCD5D3",
    style: (_ref409 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref409, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref409, "strokeOpacity", 1), _ref409),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask239 || (_mask239 = /*#__PURE__*/React.createElement("mask", {
    id: "path-652-inside-239_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 127.683H178.641V135.255H150.48V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 127.683H178.641V135.255H150.48V127.683Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 127.683V127.406H150.203V127.683H150.48ZM150.48 127.683V127.96H178.641V127.683V127.406H150.48V127.683ZM150.48 135.255H150.758V127.683H150.48H150.203V135.255H150.48Z",
    fill: "#EAEEED",
    style: (_ref410 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref410, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref410, "fillOpacity", 1), _ref410),
    mask: "url(#path-652-inside-239_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 131.469H173.213",
    stroke: "#CCD5D3",
    style: (_ref411 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref411, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref411, "strokeOpacity", 1), _ref411),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask240 || (_mask240 = /*#__PURE__*/React.createElement("mask", {
    id: "path-655-inside-240_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 127.683H206.801V135.255H178.641V127.683Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 127.683H206.801V135.255H178.641V127.683Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 127.683V127.406H178.363V127.683H178.641ZM178.641 127.683V127.96H206.801V127.683V127.406H178.641V127.683ZM178.641 135.255H178.918V127.683H178.641H178.363V135.255H178.641Z",
    fill: "#EAEEED",
    style: (_ref412 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref412, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref412, "fillOpacity", 1), _ref412),
    mask: "url(#path-655-inside-240_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 131.469H201.373",
    stroke: "#CCD5D3",
    style: (_ref413 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref413, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref413, "strokeOpacity", 1), _ref413),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 135.255)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask241 || (_mask241 = /*#__PURE__*/React.createElement("mask", {
    id: "path-658-inside-241_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 135.255H37.8368V142.828H29.5166V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 135.255H37.8368V142.828H29.5166V135.255Z",
    fill: "#FAFAFA",
    style: (_ref414 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref414, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref414, "fillOpacity", 1), _ref414)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 135.255V135.533H37.8368V135.255V134.978H29.5166V135.255Z",
    fill: "url(#paint35_linear_17113_221003)",
    style: {},
    mask: "url(#path-658-inside-241_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9706 140.255V139.756H32.7891V139.54L33.9206 137.926H34.2468V139.51H34.5929V139.756H34.2468V140.255H33.9706ZM33.0986 139.51H33.9839V138.235L33.0986 139.51Z",
    fill: "#7F7F7D",
    style: (_ref415 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref415, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref415, "fillOpacity", 1), _ref415)
  }), _mask242 || (_mask242 = /*#__PURE__*/React.createElement("mask", {
    id: "path-661-inside-242_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 135.255H65.9977V142.828H37.8369V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 135.255H65.9977V142.828H37.8369V135.255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 135.255V134.978H37.5596V135.255H37.8369ZM37.8369 135.255V135.533H65.9977V135.255V134.978H37.8369V135.255ZM37.8369 142.828H38.1143V135.255H37.8369H37.5596V142.828H37.8369Z",
    fill: "#EAEEED",
    style: (_ref416 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref416, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref416, "fillOpacity", 1), _ref416),
    mask: "url(#path-661-inside-242_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 139.042H60.5696",
    stroke: "#CCD5D3",
    style: (_ref417 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref417, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref417, "strokeOpacity", 1), _ref417),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask243 || (_mask243 = /*#__PURE__*/React.createElement("mask", {
    id: "path-664-inside-243_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 135.255H94.1588V142.828H65.998V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 135.255H94.1588V142.828H65.998V135.255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 135.255V134.978H65.7207V135.255H65.998ZM65.998 135.255V135.533H94.1588V135.255V134.978H65.998V135.255ZM65.998 142.828H66.2754V135.255H65.998H65.7207V142.828H65.998Z",
    fill: "#EAEEED",
    style: (_ref418 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref418, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref418, "fillOpacity", 1), _ref418),
    mask: "url(#path-664-inside-243_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 139.042H88.7308",
    stroke: "#CCD5D3",
    style: (_ref419 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref419, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref419, "strokeOpacity", 1), _ref419),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask244 || (_mask244 = /*#__PURE__*/React.createElement("mask", {
    id: "path-667-inside-244_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 135.255H122.319V142.828H94.1582V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 135.255H122.319V142.828H94.1582V135.255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 135.255V134.978H93.8809V135.255H94.1582ZM94.1582 135.255V135.533H122.319V135.255V134.978H94.1582V135.255ZM94.1582 142.828H94.4355V135.255H94.1582H93.8809V142.828H94.1582Z",
    fill: "#EAEEED",
    style: (_ref420 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref420, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref420, "fillOpacity", 1), _ref420),
    mask: "url(#path-667-inside-244_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 139.042H116.891",
    stroke: "#CCD5D3",
    style: (_ref421 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref421, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref421, "strokeOpacity", 1), _ref421),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask245 || (_mask245 = /*#__PURE__*/React.createElement("mask", {
    id: "path-670-inside-245_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 135.255H150.48V142.828H122.319V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 135.255H150.48V142.828H122.319V135.255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 135.255V134.978H122.042V135.255H122.319ZM122.319 135.255V135.533H150.48V135.255V134.978H122.319V135.255ZM122.319 142.828H122.597V135.255H122.319H122.042V142.828H122.319Z",
    fill: "#EAEEED",
    style: (_ref422 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref422, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref422, "fillOpacity", 1), _ref422),
    mask: "url(#path-670-inside-245_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 139.042H145.052",
    stroke: "#CCD5D3",
    style: (_ref423 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref423, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref423, "strokeOpacity", 1), _ref423),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask246 || (_mask246 = /*#__PURE__*/React.createElement("mask", {
    id: "path-673-inside-246_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 135.255H178.641V142.828H150.48V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 135.255H178.641V142.828H150.48V135.255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 135.255V134.978H150.203V135.255H150.48ZM150.48 135.255V135.533H178.641V135.255V134.978H150.48V135.255ZM150.48 142.828H150.758V135.255H150.48H150.203V142.828H150.48Z",
    fill: "#EAEEED",
    style: (_ref424 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref424, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref424, "fillOpacity", 1), _ref424),
    mask: "url(#path-673-inside-246_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 139.042H173.213",
    stroke: "#CCD5D3",
    style: (_ref425 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref425, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref425, "strokeOpacity", 1), _ref425),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask247 || (_mask247 = /*#__PURE__*/React.createElement("mask", {
    id: "path-676-inside-247_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 135.255H206.801V142.828H178.641V135.255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 135.255H206.801V142.828H178.641V135.255Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 135.255V134.978H178.363V135.255H178.641ZM178.641 135.255V135.533H206.801V135.255V134.978H178.641V135.255ZM178.641 142.828H178.918V135.255H178.641H178.363V142.828H178.641Z",
    fill: "#EAEEED",
    style: (_ref426 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref426, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref426, "fillOpacity", 1), _ref426),
    mask: "url(#path-676-inside-247_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 139.042H201.373",
    stroke: "#CCD5D3",
    style: (_ref427 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref427, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref427, "strokeOpacity", 1), _ref427),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 142.828)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask248 || (_mask248 = /*#__PURE__*/React.createElement("mask", {
    id: "path-679-inside-248_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 142.828H37.8368V150.401H29.5166V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 142.828H37.8368V150.401H29.5166V142.828Z",
    fill: "#FAFAFA",
    style: (_ref428 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref428, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref428, "fillOpacity", 1), _ref428)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 142.828V143.105H37.8368V142.828V142.551H29.5166V142.828Z",
    fill: "url(#paint36_linear_17113_221003)",
    style: {},
    mask: "url(#path-679-inside-248_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6961 147.868C33.5364 147.868 33.3977 147.839 33.2801 147.782C33.1647 147.724 33.0726 147.645 33.0039 147.545C32.9373 147.445 32.8951 147.333 32.8774 147.209H33.1503C33.1769 147.333 33.2379 147.434 33.3333 147.512C33.4287 147.59 33.5508 147.628 33.6994 147.628C33.8104 147.628 33.9047 147.603 33.9823 147.552C34.0622 147.501 34.1232 147.431 34.1654 147.342C34.2097 147.253 34.2319 147.155 34.2319 147.046C34.2319 146.933 34.2097 146.833 34.1654 146.746C34.121 146.66 34.06 146.593 33.9823 146.547C33.9047 146.498 33.8137 146.474 33.7094 146.474C33.5829 146.474 33.4753 146.501 33.3866 146.557C33.2978 146.612 33.2313 146.683 33.1869 146.77H32.9173L33.1104 145.498H34.3418V145.741H33.3267L33.1969 146.457C33.2524 146.393 33.3256 146.34 33.4165 146.301C33.5097 146.258 33.6173 146.237 33.7394 146.237C33.8547 146.237 33.959 146.257 34.0522 146.297C34.1454 146.337 34.2253 146.394 34.2918 146.467C34.3584 146.54 34.4094 146.626 34.4449 146.723C34.4826 146.821 34.5015 146.927 34.5015 147.043C34.5015 147.156 34.4826 147.262 34.4449 147.362C34.4094 147.46 34.3573 147.547 34.2885 147.625C34.2197 147.701 34.1354 147.76 34.0356 147.805C33.9357 147.847 33.8226 147.868 33.6961 147.868Z",
    fill: "#7F7F7D",
    style: (_ref429 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref429, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref429, "fillOpacity", 1), _ref429)
  }), _mask249 || (_mask249 = /*#__PURE__*/React.createElement("mask", {
    id: "path-682-inside-249_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 142.828H65.9977V150.401H37.8369V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 142.828H65.9977V150.401H37.8369V142.828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 142.828V142.551H37.5596V142.828H37.8369ZM37.8369 142.828V143.105H65.9977V142.828V142.551H37.8369V142.828ZM37.8369 150.401H38.1143V142.828H37.8369H37.5596V150.401H37.8369Z",
    fill: "#EAEEED",
    style: (_ref430 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref430, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref430, "fillOpacity", 1), _ref430),
    mask: "url(#path-682-inside-249_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 146.614H60.5696",
    stroke: "#CCD5D3",
    style: (_ref431 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref431, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref431, "strokeOpacity", 1), _ref431),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask250 || (_mask250 = /*#__PURE__*/React.createElement("mask", {
    id: "path-685-inside-250_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 142.828H94.1588V150.401H65.998V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 142.828H94.1588V150.401H65.998V142.828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 142.828V142.551H65.7207V142.828H65.998ZM65.998 142.828V143.105H94.1588V142.828V142.551H65.998V142.828ZM65.998 150.401H66.2754V142.828H65.998H65.7207V150.401H65.998Z",
    fill: "#EAEEED",
    style: (_ref432 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref432, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref432, "fillOpacity", 1), _ref432),
    mask: "url(#path-685-inside-250_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 146.614H88.7308",
    stroke: "#CCD5D3",
    style: (_ref433 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref433, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref433, "strokeOpacity", 1), _ref433),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask251 || (_mask251 = /*#__PURE__*/React.createElement("mask", {
    id: "path-688-inside-251_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 142.828H122.319V150.401H94.1582V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 142.828H122.319V150.401H94.1582V142.828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 142.828V142.551H93.8809V142.828H94.1582ZM94.1582 142.828V143.105H122.319V142.828V142.551H94.1582V142.828ZM94.1582 150.401H94.4355V142.828H94.1582H93.8809V150.401H94.1582Z",
    fill: "#EAEEED",
    style: (_ref434 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref434, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref434, "fillOpacity", 1), _ref434),
    mask: "url(#path-688-inside-251_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 146.614H116.891",
    stroke: "#CCD5D3",
    style: (_ref435 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref435, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref435, "strokeOpacity", 1), _ref435),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask252 || (_mask252 = /*#__PURE__*/React.createElement("mask", {
    id: "path-691-inside-252_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 142.828H150.48V150.401H122.319V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 142.828H150.48V150.401H122.319V142.828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 142.828V142.551H122.042V142.828H122.319ZM122.319 142.828V143.105H150.48V142.828V142.551H122.319V142.828ZM122.319 150.401H122.597V142.828H122.319H122.042V150.401H122.319Z",
    fill: "#EAEEED",
    style: (_ref436 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref436, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref436, "fillOpacity", 1), _ref436),
    mask: "url(#path-691-inside-252_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 146.614H145.052",
    stroke: "#CCD5D3",
    style: (_ref437 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref437, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref437, "strokeOpacity", 1), _ref437),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask253 || (_mask253 = /*#__PURE__*/React.createElement("mask", {
    id: "path-694-inside-253_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 142.828H178.641V150.401H150.48V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 142.828H178.641V150.401H150.48V142.828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 142.828V142.551H150.203V142.828H150.48ZM150.48 142.828V143.105H178.641V142.828V142.551H150.48V142.828ZM150.48 150.401H150.758V142.828H150.48H150.203V150.401H150.48Z",
    fill: "#EAEEED",
    style: (_ref438 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref438, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref438, "fillOpacity", 1), _ref438),
    mask: "url(#path-694-inside-253_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 146.614H173.213",
    stroke: "#CCD5D3",
    style: (_ref439 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref439, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref439, "strokeOpacity", 1), _ref439),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask254 || (_mask254 = /*#__PURE__*/React.createElement("mask", {
    id: "path-697-inside-254_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 142.828H206.801V150.401H178.641V142.828Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 142.828H206.801V150.401H178.641V142.828Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 142.828V142.551H178.363V142.828H178.641ZM178.641 142.828V143.105H206.801V142.828V142.551H178.641V142.828ZM178.641 150.401H178.918V142.828H178.641H178.363V150.401H178.641Z",
    fill: "#EAEEED",
    style: (_ref440 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref440, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref440, "fillOpacity", 1), _ref440),
    mask: "url(#path-697-inside-254_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 146.614H201.373",
    stroke: "#CCD5D3",
    style: (_ref441 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref441, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref441, "strokeOpacity", 1), _ref441),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 150.401)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask255 || (_mask255 = /*#__PURE__*/React.createElement("mask", {
    id: "path-700-inside-255_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 150.401H37.8368V157.973H29.5166V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 150.401H37.8368V157.973H29.5166V150.401Z",
    fill: "#FAFAFA",
    style: (_ref442 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref442, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref442, "fillOpacity", 1), _ref442)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 150.401V150.678H37.8368V150.401V150.123H29.5166V150.401Z",
    fill: "url(#paint37_linear_17113_221003)",
    style: {},
    mask: "url(#path-700-inside-255_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7168 155.441C33.5481 155.441 33.4062 155.41 33.2908 155.348C33.1754 155.283 33.0833 155.199 33.0145 155.095C32.9458 154.988 32.8947 154.868 32.8615 154.735C32.8304 154.602 32.8149 154.467 32.8149 154.329C32.8149 154.072 32.8504 153.847 32.9214 153.654C32.9924 153.458 33.0944 153.306 33.2275 153.198C33.3629 153.087 33.5249 153.031 33.7134 153.031C33.8599 153.031 33.9852 153.06 34.0895 153.118C34.196 153.173 34.2803 153.249 34.3425 153.344C34.4046 153.439 34.4423 153.546 34.4556 153.663H34.196C34.1738 153.539 34.1195 153.444 34.0329 153.377C33.9486 153.308 33.841 153.274 33.7101 153.274C33.5947 153.274 33.4905 153.311 33.3973 153.384C33.3041 153.455 33.2298 153.565 33.1743 153.713C33.121 153.86 33.09 154.047 33.0811 154.276C33.0811 154.278 33.0811 154.281 33.0811 154.286C33.0811 154.29 33.0811 154.295 33.0811 154.299C33.1166 154.23 33.1654 154.166 33.2275 154.106C33.2919 154.046 33.3684 153.999 33.4572 153.963C33.5459 153.928 33.6447 153.91 33.7534 153.91C33.8843 153.91 34.0074 153.941 34.1228 154.003C34.2382 154.065 34.3314 154.153 34.4024 154.266C34.4756 154.377 34.5122 154.508 34.5122 154.659C34.5122 154.789 34.48 154.915 34.4157 155.035C34.3535 155.154 34.2626 155.252 34.1428 155.328C34.023 155.403 33.881 155.441 33.7168 155.441ZM33.6968 155.194C33.7989 155.194 33.8898 155.172 33.9697 155.128C34.0518 155.081 34.115 155.019 34.1594 154.941C34.206 154.862 34.2293 154.772 34.2293 154.672C34.2293 154.568 34.206 154.477 34.1594 154.399C34.115 154.321 34.0518 154.261 33.9697 154.219C33.8898 154.175 33.7989 154.153 33.6968 154.153C33.5947 154.153 33.5027 154.176 33.4206 154.223C33.3385 154.269 33.273 154.332 33.2242 154.412C33.1776 154.49 33.1543 154.578 33.1543 154.675C33.1543 154.775 33.1776 154.865 33.2242 154.945C33.273 155.022 33.3385 155.083 33.4206 155.128C33.5027 155.172 33.5947 155.194 33.6968 155.194Z",
    fill: "#7F7F7D",
    style: (_ref443 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref443, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref443, "fillOpacity", 1), _ref443)
  }), _mask256 || (_mask256 = /*#__PURE__*/React.createElement("mask", {
    id: "path-703-inside-256_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 150.401H65.9977V157.973H37.8369V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 150.401H65.9977V157.973H37.8369V150.401Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 150.401V150.123H37.5596V150.401H37.8369ZM37.8369 150.401V150.678H65.9977V150.401V150.123H37.8369V150.401ZM37.8369 157.973H38.1143V150.401H37.8369H37.5596V157.973H37.8369Z",
    fill: "#EAEEED",
    style: (_ref444 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref444, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref444, "fillOpacity", 1), _ref444),
    mask: "url(#path-703-inside-256_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 154.187H60.5696",
    stroke: "#CCD5D3",
    style: (_ref445 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref445, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref445, "strokeOpacity", 1), _ref445),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask257 || (_mask257 = /*#__PURE__*/React.createElement("mask", {
    id: "path-706-inside-257_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 150.401H94.1588V157.973H65.998V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 150.401H94.1588V157.973H65.998V150.401Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 150.401V150.123H65.7207V150.401H65.998ZM65.998 150.401V150.678H94.1588V150.401V150.123H65.998V150.401ZM65.998 157.973H66.2754V150.401H65.998H65.7207V157.973H65.998Z",
    fill: "#EAEEED",
    style: (_ref446 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref446, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref446, "fillOpacity", 1), _ref446),
    mask: "url(#path-706-inside-257_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 154.187H88.7308",
    stroke: "#CCD5D3",
    style: (_ref447 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref447, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref447, "strokeOpacity", 1), _ref447),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask258 || (_mask258 = /*#__PURE__*/React.createElement("mask", {
    id: "path-709-inside-258_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 150.401H122.319V157.973H94.1582V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 150.401H122.319V157.973H94.1582V150.401Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 150.401V150.123H93.8809V150.401H94.1582ZM94.1582 150.401V150.678H122.319V150.401V150.123H94.1582V150.401ZM94.1582 157.973H94.4355V150.401H94.1582H93.8809V157.973H94.1582Z",
    fill: "#EAEEED",
    style: (_ref448 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref448, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref448, "fillOpacity", 1), _ref448),
    mask: "url(#path-709-inside-258_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 154.187H116.891",
    stroke: "#CCD5D3",
    style: (_ref449 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref449, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref449, "strokeOpacity", 1), _ref449),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask259 || (_mask259 = /*#__PURE__*/React.createElement("mask", {
    id: "path-712-inside-259_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 150.401H150.48V157.973H122.319V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 150.401H150.48V157.973H122.319V150.401Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 150.401V150.123H122.042V150.401H122.319ZM122.319 150.401V150.678H150.48V150.401V150.123H122.319V150.401ZM122.319 157.973H122.597V150.401H122.319H122.042V157.973H122.319Z",
    fill: "#EAEEED",
    style: (_ref450 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref450, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref450, "fillOpacity", 1), _ref450),
    mask: "url(#path-712-inside-259_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 154.187H145.052",
    stroke: "#CCD5D3",
    style: (_ref451 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref451, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref451, "strokeOpacity", 1), _ref451),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask260 || (_mask260 = /*#__PURE__*/React.createElement("mask", {
    id: "path-715-inside-260_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 150.401H178.641V157.973H150.48V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 150.401H178.641V157.973H150.48V150.401Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 150.401V150.123H150.203V150.401H150.48ZM150.48 150.401V150.678H178.641V150.401V150.123H150.48V150.401ZM150.48 157.973H150.758V150.401H150.48H150.203V157.973H150.48Z",
    fill: "#EAEEED",
    style: (_ref452 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref452, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref452, "fillOpacity", 1), _ref452),
    mask: "url(#path-715-inside-260_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 154.187H173.213",
    stroke: "#CCD5D3",
    style: (_ref453 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref453, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref453, "strokeOpacity", 1), _ref453),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask261 || (_mask261 = /*#__PURE__*/React.createElement("mask", {
    id: "path-718-inside-261_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 150.401H206.801V157.973H178.641V150.401Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 150.401H206.801V157.973H178.641V150.401Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 150.401V150.123H178.363V150.401H178.641ZM178.641 150.401V150.678H206.801V150.401V150.123H178.641V150.401ZM178.641 157.973H178.918V150.401H178.641H178.363V157.973H178.641Z",
    fill: "#EAEEED",
    style: (_ref454 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref454, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref454, "fillOpacity", 1), _ref454),
    mask: "url(#path-718-inside-261_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 154.187H201.373",
    stroke: "#CCD5D3",
    style: (_ref455 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref455, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref455, "strokeOpacity", 1), _ref455),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 157.973)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask262 || (_mask262 = /*#__PURE__*/React.createElement("mask", {
    id: "path-721-inside-262_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 157.973H37.8368V165.546H29.5166V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 157.973H37.8368V165.546H29.5166V157.973Z",
    fill: "#FAFAFA",
    style: (_ref456 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref456, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref456, "fillOpacity", 1), _ref456)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 157.973V158.251H37.8368V157.973V157.696H29.5166V157.973Z",
    fill: "url(#paint38_linear_17113_221003)",
    style: {},
    mask: "url(#path-721-inside-262_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2471 162.973L34.1557 160.883H32.8777V160.644H34.4419V160.853L33.5433 162.973H33.2471Z",
    fill: "#7F7F7D",
    style: (_ref457 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref457, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref457, "fillOpacity", 1), _ref457)
  }), _mask263 || (_mask263 = /*#__PURE__*/React.createElement("mask", {
    id: "path-724-inside-263_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 157.973H65.9977V165.546H37.8369V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 157.973H65.9977V165.546H37.8369V157.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 157.973V157.696H37.5596V157.973H37.8369ZM37.8369 157.973V158.251H65.9977V157.973V157.696H37.8369V157.973ZM37.8369 165.546H38.1143V157.973H37.8369H37.5596V165.546H37.8369Z",
    fill: "#EAEEED",
    style: (_ref458 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref458, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref458, "fillOpacity", 1), _ref458),
    mask: "url(#path-724-inside-263_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 161.76H60.5696",
    stroke: "#CCD5D3",
    style: (_ref459 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref459, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref459, "strokeOpacity", 1), _ref459),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask264 || (_mask264 = /*#__PURE__*/React.createElement("mask", {
    id: "path-727-inside-264_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 157.973H94.1588V165.546H65.998V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 157.973H94.1588V165.546H65.998V157.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 157.973V157.696H65.7207V157.973H65.998ZM65.998 157.973V158.251H94.1588V157.973V157.696H65.998V157.973ZM65.998 165.546H66.2754V157.973H65.998H65.7207V165.546H65.998Z",
    fill: "#EAEEED",
    style: (_ref460 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref460, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref460, "fillOpacity", 1), _ref460),
    mask: "url(#path-727-inside-264_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 161.76H88.7308",
    stroke: "#CCD5D3",
    style: (_ref461 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref461, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref461, "strokeOpacity", 1), _ref461),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask265 || (_mask265 = /*#__PURE__*/React.createElement("mask", {
    id: "path-730-inside-265_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 157.973H122.319V165.546H94.1582V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 157.973H122.319V165.546H94.1582V157.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 157.973V157.696H93.8809V157.973H94.1582ZM94.1582 157.973V158.251H122.319V157.973V157.696H94.1582V157.973ZM94.1582 165.546H94.4355V157.973H94.1582H93.8809V165.546H94.1582Z",
    fill: "#EAEEED",
    style: (_ref462 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref462, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref462, "fillOpacity", 1), _ref462),
    mask: "url(#path-730-inside-265_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 161.76H116.891",
    stroke: "#CCD5D3",
    style: (_ref463 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref463, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref463, "strokeOpacity", 1), _ref463),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask266 || (_mask266 = /*#__PURE__*/React.createElement("mask", {
    id: "path-733-inside-266_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 157.973H150.48V165.546H122.319V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 157.973H150.48V165.546H122.319V157.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 157.973V157.696H122.042V157.973H122.319ZM122.319 157.973V158.251H150.48V157.973V157.696H122.319V157.973ZM122.319 165.546H122.597V157.973H122.319H122.042V165.546H122.319Z",
    fill: "#EAEEED",
    style: (_ref464 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref464, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref464, "fillOpacity", 1), _ref464),
    mask: "url(#path-733-inside-266_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 161.76H145.052",
    stroke: "#CCD5D3",
    style: (_ref465 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref465, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref465, "strokeOpacity", 1), _ref465),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask267 || (_mask267 = /*#__PURE__*/React.createElement("mask", {
    id: "path-736-inside-267_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 157.973H178.641V165.546H150.48V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 157.973H178.641V165.546H150.48V157.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 157.973V157.696H150.203V157.973H150.48ZM150.48 157.973V158.251H178.641V157.973V157.696H150.48V157.973ZM150.48 165.546H150.758V157.973H150.48H150.203V165.546H150.48Z",
    fill: "#EAEEED",
    style: (_ref466 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref466, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref466, "fillOpacity", 1), _ref466),
    mask: "url(#path-736-inside-267_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 161.76H173.213",
    stroke: "#CCD5D3",
    style: (_ref467 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref467, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref467, "strokeOpacity", 1), _ref467),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask268 || (_mask268 = /*#__PURE__*/React.createElement("mask", {
    id: "path-739-inside-268_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 157.973H206.801V165.546H178.641V157.973Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 157.973H206.801V165.546H178.641V157.973Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 157.973V157.696H178.363V157.973H178.641ZM178.641 157.973V158.251H206.801V157.973V157.696H178.641V157.973ZM178.641 165.546H178.918V157.973H178.641H178.363V165.546H178.641Z",
    fill: "#EAEEED",
    style: (_ref468 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref468, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref468, "fillOpacity", 1), _ref468),
    mask: "url(#path-739-inside-268_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 161.76H201.373",
    stroke: "#CCD5D3",
    style: (_ref469 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref469, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref469, "strokeOpacity", 1), _ref469),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 165.546)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask269 || (_mask269 = /*#__PURE__*/React.createElement("mask", {
    id: "path-742-inside-269_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 165.546H37.8368V173.119H29.5166V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 165.546H37.8368V173.119H29.5166V165.546Z",
    fill: "#FAFAFA",
    style: (_ref470 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref470, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref470, "fillOpacity", 1), _ref470)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 165.546V165.823H37.8368V165.546V165.269H29.5166V165.546Z",
    fill: "url(#paint39_linear_17113_221003)",
    style: {},
    mask: "url(#path-742-inside-269_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6761 170.586C33.5252 170.586 33.3898 170.558 33.27 170.503C33.1502 170.445 33.0548 170.366 32.9838 170.266C32.9128 170.164 32.8773 170.047 32.8773 169.914C32.8773 169.818 32.8962 169.729 32.9339 169.647C32.9716 169.565 33.0237 169.494 33.0903 169.434C33.1591 169.372 33.2379 169.329 33.3266 169.305C33.2024 169.26 33.1058 169.191 33.0371 169.098C32.9705 169.005 32.9372 168.904 32.9372 168.795C32.9372 168.68 32.9672 168.576 33.0271 168.483C33.087 168.389 33.1713 168.315 33.28 168.26C33.3909 168.204 33.523 168.176 33.6761 168.176C33.8314 168.176 33.9634 168.204 34.0721 168.26C34.183 168.315 34.2673 168.389 34.325 168.483C34.3849 168.576 34.4149 168.68 34.4149 168.795C34.4149 168.904 34.3805 169.005 34.3117 169.098C34.2452 169.191 34.1498 169.26 34.0255 169.305C34.1165 169.329 34.1952 169.372 34.2618 169.434C34.3306 169.494 34.3827 169.565 34.4182 169.647C34.4559 169.729 34.4748 169.818 34.4748 169.914C34.4748 170.047 34.4393 170.164 34.3683 170.266C34.2995 170.366 34.2041 170.445 34.0821 170.503C33.9623 170.558 33.8269 170.586 33.6761 170.586ZM33.6761 170.34C33.8513 170.34 33.9811 170.3 34.0654 170.22C34.152 170.138 34.1952 170.03 34.1952 169.897C34.1952 169.746 34.1475 169.632 34.0521 169.554C33.9589 169.477 33.8336 169.438 33.6761 169.438C33.5185 169.438 33.3921 169.477 33.2967 169.554C33.2035 169.632 33.1569 169.746 33.1569 169.897C33.1569 170.03 33.2001 170.138 33.2867 170.22C33.3732 170.3 33.503 170.34 33.6761 170.34ZM33.6761 169.205C33.8158 169.205 33.9268 169.168 34.0089 169.095C34.091 169.022 34.132 168.927 34.132 168.812C34.132 168.681 34.091 168.582 34.0089 168.516C33.929 168.449 33.8181 168.416 33.6761 168.416C33.5363 168.416 33.4253 168.449 33.3432 168.516C33.2634 168.582 33.2234 168.681 33.2234 168.812C33.2234 168.927 33.2634 169.022 33.3432 169.095C33.4253 169.168 33.5363 169.205 33.6761 169.205Z",
    fill: "#7F7F7D",
    style: (_ref471 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref471, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref471, "fillOpacity", 1), _ref471)
  }), _mask270 || (_mask270 = /*#__PURE__*/React.createElement("mask", {
    id: "path-745-inside-270_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 165.546H65.9977V173.119H37.8369V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 165.546H65.9977V173.119H37.8369V165.546Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 165.546V165.269H37.5596V165.546H37.8369ZM37.8369 165.546V165.823H65.9977V165.546V165.269H37.8369V165.546ZM37.8369 173.119H38.1143V165.546H37.8369H37.5596V173.119H37.8369Z",
    fill: "#EAEEED",
    style: (_ref472 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref472, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref472, "fillOpacity", 1), _ref472),
    mask: "url(#path-745-inside-270_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 169.332H60.5696",
    stroke: "#CCD5D3",
    style: (_ref473 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref473, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref473, "strokeOpacity", 1), _ref473),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask271 || (_mask271 = /*#__PURE__*/React.createElement("mask", {
    id: "path-748-inside-271_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 165.546H94.1588V173.119H65.998V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 165.546H94.1588V173.119H65.998V165.546Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 165.546V165.269H65.7207V165.546H65.998ZM65.998 165.546V165.823H94.1588V165.546V165.269H65.998V165.546ZM65.998 173.119H66.2754V165.546H65.998H65.7207V173.119H65.998Z",
    fill: "#EAEEED",
    style: (_ref474 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref474, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref474, "fillOpacity", 1), _ref474),
    mask: "url(#path-748-inside-271_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 169.332H88.7308",
    stroke: "#CCD5D3",
    style: (_ref475 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref475, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref475, "strokeOpacity", 1), _ref475),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask272 || (_mask272 = /*#__PURE__*/React.createElement("mask", {
    id: "path-751-inside-272_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 165.546H122.319V173.119H94.1582V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 165.546H122.319V173.119H94.1582V165.546Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 165.546V165.269H93.8809V165.546H94.1582ZM94.1582 165.546V165.823H122.319V165.546V165.269H94.1582V165.546ZM94.1582 173.119H94.4355V165.546H94.1582H93.8809V173.119H94.1582Z",
    fill: "#EAEEED",
    style: (_ref476 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref476, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref476, "fillOpacity", 1), _ref476),
    mask: "url(#path-751-inside-272_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 169.332H116.891",
    stroke: "#CCD5D3",
    style: (_ref477 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref477, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref477, "strokeOpacity", 1), _ref477),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask273 || (_mask273 = /*#__PURE__*/React.createElement("mask", {
    id: "path-754-inside-273_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 165.546H150.48V173.119H122.319V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 165.546H150.48V173.119H122.319V165.546Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 165.546V165.269H122.042V165.546H122.319ZM122.319 165.546V165.823H150.48V165.546V165.269H122.319V165.546ZM122.319 173.119H122.597V165.546H122.319H122.042V173.119H122.319Z",
    fill: "#EAEEED",
    style: (_ref478 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref478, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref478, "fillOpacity", 1), _ref478),
    mask: "url(#path-754-inside-273_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 169.332H145.052",
    stroke: "#CCD5D3",
    style: (_ref479 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref479, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref479, "strokeOpacity", 1), _ref479),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask274 || (_mask274 = /*#__PURE__*/React.createElement("mask", {
    id: "path-757-inside-274_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 165.546H178.641V173.119H150.48V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 165.546H178.641V173.119H150.48V165.546Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 165.546V165.269H150.203V165.546H150.48ZM150.48 165.546V165.823H178.641V165.546V165.269H150.48V165.546ZM150.48 173.119H150.758V165.546H150.48H150.203V173.119H150.48Z",
    fill: "#EAEEED",
    style: (_ref480 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref480, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref480, "fillOpacity", 1), _ref480),
    mask: "url(#path-757-inside-274_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 169.332H173.213",
    stroke: "#CCD5D3",
    style: (_ref481 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref481, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref481, "strokeOpacity", 1), _ref481),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask275 || (_mask275 = /*#__PURE__*/React.createElement("mask", {
    id: "path-760-inside-275_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 165.546H206.801V173.119H178.641V165.546Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 165.546H206.801V173.119H178.641V165.546Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 165.546V165.269H178.363V165.546H178.641ZM178.641 165.546V165.823H206.801V165.546V165.269H178.641V165.546ZM178.641 173.119H178.918V165.546H178.641H178.363V173.119H178.641Z",
    fill: "#EAEEED",
    style: (_ref482 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref482, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref482, "fillOpacity", 1), _ref482),
    mask: "url(#path-760-inside-275_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 169.332H201.373",
    stroke: "#CCD5D3",
    style: (_ref483 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref483, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref483, "strokeOpacity", 1), _ref483),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 173.119)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask276 || (_mask276 = /*#__PURE__*/React.createElement("mask", {
    id: "path-763-inside-276_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 173.119H37.8368V180.691H29.5166V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 173.119H37.8368V180.691H29.5166V173.119Z",
    fill: "#FAFAFA",
    style: (_ref484 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref484, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref484, "fillOpacity", 1), _ref484)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 173.119V173.396H37.8368V173.119V172.841H29.5166V173.119Z",
    fill: "url(#paint40_linear_17113_221003)",
    style: {},
    mask: "url(#path-763-inside-276_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6402 178.159C33.4938 178.159 33.3684 178.131 33.2642 178.075C33.1599 178.018 33.0767 177.941 33.0145 177.846C32.9546 177.748 32.918 177.642 32.9047 177.526H33.1643C33.1865 177.65 33.2397 177.747 33.3241 177.816C33.4084 177.882 33.5149 177.916 33.6436 177.916C33.7611 177.916 33.8654 177.88 33.9564 177.809C34.0474 177.738 34.1206 177.63 34.176 177.486C34.2337 177.34 34.2659 177.155 34.2726 176.93C34.2726 176.924 34.2726 176.917 34.2726 176.91C34.2726 176.904 34.2726 176.897 34.2726 176.891C34.2393 176.959 34.1905 177.024 34.1261 177.084C34.0618 177.143 33.9852 177.191 33.8965 177.227C33.81 177.262 33.7123 177.28 33.6036 177.28C33.4727 177.28 33.3485 177.249 33.2309 177.187C33.1155 177.125 33.0212 177.038 32.948 176.927C32.877 176.814 32.8415 176.682 32.8415 176.531C32.8415 176.4 32.8737 176.275 32.938 176.155C33.0023 176.035 33.0944 175.938 33.2142 175.862C33.334 175.787 33.476 175.749 33.6402 175.749C33.8066 175.749 33.9475 175.781 34.0629 175.846C34.1783 175.908 34.2703 175.992 34.3391 176.098C34.4101 176.203 34.4612 176.321 34.4922 176.455C34.5233 176.588 34.5388 176.723 34.5388 176.861C34.5388 177.116 34.5033 177.341 34.4323 177.536C34.3635 177.731 34.2615 177.885 34.1261 177.995C33.993 178.104 33.831 178.159 33.6402 178.159ZM33.6602 177.037C33.7623 177.037 33.8543 177.014 33.9364 176.967C34.0185 176.92 34.0829 176.857 34.1295 176.777C34.1783 176.697 34.2027 176.61 34.2027 176.514C34.2027 176.412 34.1783 176.323 34.1295 176.245C34.0829 176.167 34.0185 176.106 33.9364 176.062C33.8543 176.017 33.7623 175.995 33.6602 175.995C33.5581 175.995 33.4661 176.019 33.384 176.065C33.3041 176.11 33.2409 176.171 33.1943 176.248C33.1477 176.326 33.1244 176.416 33.1244 176.518C33.1244 176.622 33.1477 176.713 33.1943 176.791C33.2409 176.868 33.3041 176.929 33.384 176.974C33.4661 177.016 33.5581 177.037 33.6602 177.037Z",
    fill: "#7F7F7D",
    style: (_ref485 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref485, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref485, "fillOpacity", 1), _ref485)
  }), _mask277 || (_mask277 = /*#__PURE__*/React.createElement("mask", {
    id: "path-766-inside-277_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 173.119H65.9977V180.691H37.8369V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 173.119H65.9977V180.691H37.8369V173.119Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 173.119V172.841H37.5596V173.119H37.8369ZM37.8369 173.119V173.396H65.9977V173.119V172.841H37.8369V173.119ZM37.8369 180.691H38.1143V173.119H37.8369H37.5596V180.691H37.8369Z",
    fill: "#EAEEED",
    style: (_ref486 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref486, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref486, "fillOpacity", 1), _ref486),
    mask: "url(#path-766-inside-277_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 176.905H60.5696",
    stroke: "#CCD5D3",
    style: (_ref487 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref487, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref487, "strokeOpacity", 1), _ref487),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask278 || (_mask278 = /*#__PURE__*/React.createElement("mask", {
    id: "path-769-inside-278_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 173.119H94.1588V180.691H65.998V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 173.119H94.1588V180.691H65.998V173.119Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 173.119V172.841H65.7207V173.119H65.998ZM65.998 173.119V173.396H94.1588V173.119V172.841H65.998V173.119ZM65.998 180.691H66.2754V173.119H65.998H65.7207V180.691H65.998Z",
    fill: "#EAEEED",
    style: (_ref488 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref488, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref488, "fillOpacity", 1), _ref488),
    mask: "url(#path-769-inside-278_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 176.905H88.7308",
    stroke: "#CCD5D3",
    style: (_ref489 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref489, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref489, "strokeOpacity", 1), _ref489),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask279 || (_mask279 = /*#__PURE__*/React.createElement("mask", {
    id: "path-772-inside-279_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 173.119H122.319V180.691H94.1582V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 173.119H122.319V180.691H94.1582V173.119Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 173.119V172.841H93.8809V173.119H94.1582ZM94.1582 173.119V173.396H122.319V173.119V172.841H94.1582V173.119ZM94.1582 180.691H94.4355V173.119H94.1582H93.8809V180.691H94.1582Z",
    fill: "#EAEEED",
    style: (_ref490 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref490, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref490, "fillOpacity", 1), _ref490),
    mask: "url(#path-772-inside-279_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 176.905H116.891",
    stroke: "#CCD5D3",
    style: (_ref491 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref491, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref491, "strokeOpacity", 1), _ref491),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask280 || (_mask280 = /*#__PURE__*/React.createElement("mask", {
    id: "path-775-inside-280_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 173.119H150.48V180.691H122.319V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 173.119H150.48V180.691H122.319V173.119Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 173.119V172.841H122.042V173.119H122.319ZM122.319 173.119V173.396H150.48V173.119V172.841H122.319V173.119ZM122.319 180.691H122.597V173.119H122.319H122.042V180.691H122.319Z",
    fill: "#EAEEED",
    style: (_ref492 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref492, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref492, "fillOpacity", 1), _ref492),
    mask: "url(#path-775-inside-280_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 176.905H145.052",
    stroke: "#CCD5D3",
    style: (_ref493 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref493, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref493, "strokeOpacity", 1), _ref493),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask281 || (_mask281 = /*#__PURE__*/React.createElement("mask", {
    id: "path-778-inside-281_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 173.119H178.641V180.691H150.48V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 173.119H178.641V180.691H150.48V173.119Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 173.119V172.841H150.203V173.119H150.48ZM150.48 173.119V173.396H178.641V173.119V172.841H150.48V173.119ZM150.48 180.691H150.758V173.119H150.48H150.203V180.691H150.48Z",
    fill: "#EAEEED",
    style: (_ref494 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref494, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref494, "fillOpacity", 1), _ref494),
    mask: "url(#path-778-inside-281_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 176.905H173.213",
    stroke: "#CCD5D3",
    style: (_ref495 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref495, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref495, "strokeOpacity", 1), _ref495),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask282 || (_mask282 = /*#__PURE__*/React.createElement("mask", {
    id: "path-781-inside-282_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 173.119H206.801V180.691H178.641V173.119Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 173.119H206.801V180.691H178.641V173.119Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 173.119V172.841H178.363V173.119H178.641ZM178.641 173.119V173.396H206.801V173.119V172.841H178.641V173.119ZM178.641 180.691H178.918V173.119H178.641H178.363V180.691H178.641Z",
    fill: "#EAEEED",
    style: (_ref496 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref496, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref496, "fillOpacity", 1), _ref496),
    mask: "url(#path-781-inside-282_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 176.905H201.373",
    stroke: "#CCD5D3",
    style: (_ref497 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref497, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref497, "strokeOpacity", 1), _ref497),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 180.691)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask283 || (_mask283 = /*#__PURE__*/React.createElement("mask", {
    id: "path-784-inside-283_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 180.691H37.8368V188.264H29.5166V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 180.691H37.8368V188.264H29.5166V180.691Z",
    fill: "#FAFAFA",
    style: (_ref498 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref498, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref498, "fillOpacity", 1), _ref498)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 180.691V180.969H37.8368V180.691V180.414H29.5166V180.691Z",
    fill: "url(#paint41_linear_17113_221003)",
    style: {},
    mask: "url(#path-784-inside-283_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5267 185.691V183.674L32.1273 183.774V183.575L32.6199 183.362H32.8096V185.691H32.5267ZM34.1991 185.731C33.995 185.731 33.8186 185.681 33.6699 185.581C33.5235 185.479 33.4115 185.338 33.3338 185.159C33.2562 184.977 33.2173 184.766 33.2173 184.526C33.2173 184.287 33.2562 184.077 33.3338 183.897C33.4115 183.715 33.5235 183.575 33.6699 183.475C33.8186 183.373 33.995 183.322 34.1991 183.322C34.4032 183.322 34.5774 183.373 34.7216 183.475C34.8681 183.575 34.9801 183.715 35.0578 183.897C35.1354 184.077 35.1742 184.287 35.1742 184.526C35.1742 184.766 35.1354 184.977 35.0578 185.159C34.9801 185.338 34.8681 185.479 34.7216 185.581C34.5774 185.681 34.4032 185.731 34.1991 185.731ZM34.1958 185.485C34.3289 185.485 34.4476 185.447 34.5519 185.372C34.6562 185.294 34.7383 185.184 34.7982 185.042C34.8581 184.898 34.888 184.726 34.888 184.526C34.888 184.327 34.8581 184.156 34.7982 184.014C34.7383 183.87 34.6562 183.76 34.5519 183.684C34.4476 183.609 34.3289 183.571 34.1958 183.571C34.0627 183.571 33.9428 183.609 33.8364 183.684C33.7321 183.76 33.65 183.87 33.5901 184.014C33.5324 184.156 33.5035 184.327 33.5035 184.526C33.5035 184.726 33.5324 184.898 33.5901 185.042C33.65 185.184 33.7321 185.294 33.8364 185.372C33.9428 185.447 34.0627 185.485 34.1958 185.485Z",
    fill: "#7F7F7D",
    style: (_ref499 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref499, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref499, "fillOpacity", 1), _ref499)
  }), _mask284 || (_mask284 = /*#__PURE__*/React.createElement("mask", {
    id: "path-787-inside-284_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 180.691H65.9977V188.264H37.8369V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 180.691H65.9977V188.264H37.8369V180.691Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 180.691V180.414H37.5596V180.691H37.8369ZM37.8369 180.691V180.969H65.9977V180.691V180.414H37.8369V180.691ZM37.8369 188.264H38.1143V180.691H37.8369H37.5596V188.264H37.8369Z",
    fill: "#EAEEED",
    style: (_ref500 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref500, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref500, "fillOpacity", 1), _ref500),
    mask: "url(#path-787-inside-284_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 184.478H60.5696",
    stroke: "#CCD5D3",
    style: (_ref501 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref501, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref501, "strokeOpacity", 1), _ref501),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask285 || (_mask285 = /*#__PURE__*/React.createElement("mask", {
    id: "path-790-inside-285_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 180.691H94.1588V188.264H65.998V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 180.691H94.1588V188.264H65.998V180.691Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 180.691V180.414H65.7207V180.691H65.998ZM65.998 180.691V180.969H94.1588V180.691V180.414H65.998V180.691ZM65.998 188.264H66.2754V180.691H65.998H65.7207V188.264H65.998Z",
    fill: "#EAEEED",
    style: (_ref502 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref502, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref502, "fillOpacity", 1), _ref502),
    mask: "url(#path-790-inside-285_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 184.478H88.7308",
    stroke: "#CCD5D3",
    style: (_ref503 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref503, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref503, "strokeOpacity", 1), _ref503),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask286 || (_mask286 = /*#__PURE__*/React.createElement("mask", {
    id: "path-793-inside-286_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 180.691H122.319V188.264H94.1582V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 180.691H122.319V188.264H94.1582V180.691Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 180.691V180.414H93.8809V180.691H94.1582ZM94.1582 180.691V180.969H122.319V180.691V180.414H94.1582V180.691ZM94.1582 188.264H94.4355V180.691H94.1582H93.8809V188.264H94.1582Z",
    fill: "#EAEEED",
    style: (_ref504 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref504, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref504, "fillOpacity", 1), _ref504),
    mask: "url(#path-793-inside-286_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 184.478H116.891",
    stroke: "#CCD5D3",
    style: (_ref505 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref505, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref505, "strokeOpacity", 1), _ref505),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask287 || (_mask287 = /*#__PURE__*/React.createElement("mask", {
    id: "path-796-inside-287_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 180.691H150.48V188.264H122.319V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 180.691H150.48V188.264H122.319V180.691Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 180.691V180.414H122.042V180.691H122.319ZM122.319 180.691V180.969H150.48V180.691V180.414H122.319V180.691ZM122.319 188.264H122.597V180.691H122.319H122.042V188.264H122.319Z",
    fill: "#EAEEED",
    style: (_ref506 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref506, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref506, "fillOpacity", 1), _ref506),
    mask: "url(#path-796-inside-287_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 184.478H145.052",
    stroke: "#CCD5D3",
    style: (_ref507 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref507, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref507, "strokeOpacity", 1), _ref507),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask288 || (_mask288 = /*#__PURE__*/React.createElement("mask", {
    id: "path-799-inside-288_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 180.691H178.641V188.264H150.48V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 180.691H178.641V188.264H150.48V180.691Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 180.691V180.414H150.203V180.691H150.48ZM150.48 180.691V180.969H178.641V180.691V180.414H150.48V180.691ZM150.48 188.264H150.758V180.691H150.48H150.203V188.264H150.48Z",
    fill: "#EAEEED",
    style: (_ref508 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref508, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref508, "fillOpacity", 1), _ref508),
    mask: "url(#path-799-inside-288_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 184.478H173.213",
    stroke: "#CCD5D3",
    style: (_ref509 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref509, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref509, "strokeOpacity", 1), _ref509),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask289 || (_mask289 = /*#__PURE__*/React.createElement("mask", {
    id: "path-802-inside-289_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 180.691H206.801V188.264H178.641V180.691Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 180.691H206.801V188.264H178.641V180.691Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 180.691V180.414H178.363V180.691H178.641ZM178.641 180.691V180.969H206.801V180.691V180.414H178.641V180.691ZM178.641 188.264H178.918V180.691H178.641H178.363V188.264H178.641Z",
    fill: "#EAEEED",
    style: (_ref510 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref510, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref510, "fillOpacity", 1), _ref510),
    mask: "url(#path-802-inside-289_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 184.478H201.373",
    stroke: "#CCD5D3",
    style: (_ref511 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref511, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref511, "strokeOpacity", 1), _ref511),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 188.264)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask290 || (_mask290 = /*#__PURE__*/React.createElement("mask", {
    id: "path-805-inside-290_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 188.264H37.8368V195.836H29.5166V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 188.264H37.8368V195.836H29.5166V188.264Z",
    fill: "#FAFAFA",
    style: (_ref512 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref512, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref512, "fillOpacity", 1), _ref512)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 188.264V188.541H37.8368V188.264V187.986H29.5166V188.264Z",
    fill: "url(#paint42_linear_17113_221003)",
    style: {},
    mask: "url(#path-805-inside-290_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1458 193.264V191.247L32.7464 191.347V191.147L33.239 190.934H33.4287V193.264H33.1458ZM34.1826 193.264V191.247L33.7832 191.347V191.147L34.2758 190.934H34.4655V193.264H34.1826Z",
    fill: "#7F7F7D",
    style: (_ref513 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref513, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref513, "fillOpacity", 1), _ref513)
  }), _mask291 || (_mask291 = /*#__PURE__*/React.createElement("mask", {
    id: "path-808-inside-291_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 188.264H65.9977V195.836H37.8369V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 188.264H65.9977V195.836H37.8369V188.264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 188.264V187.986H37.5596V188.264H37.8369ZM37.8369 188.264V188.541H65.9977V188.264V187.986H37.8369V188.264ZM37.8369 195.836H38.1143V188.264H37.8369H37.5596V195.836H37.8369Z",
    fill: "#EAEEED",
    style: (_ref514 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref514, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref514, "fillOpacity", 1), _ref514),
    mask: "url(#path-808-inside-291_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.2646 192.05H60.5696",
    stroke: "#CCD5D3",
    style: (_ref515 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref515, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref515, "strokeOpacity", 1), _ref515),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask292 || (_mask292 = /*#__PURE__*/React.createElement("mask", {
    id: "path-811-inside-292_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 188.264H94.1588V195.836H65.998V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 188.264H94.1588V195.836H65.998V188.264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 188.264V187.986H65.7207V188.264H65.998ZM65.998 188.264V188.541H94.1588V188.264V187.986H65.998V188.264ZM65.998 195.836H66.2754V188.264H65.998H65.7207V195.836H65.998Z",
    fill: "#EAEEED",
    style: (_ref516 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref516, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref516, "fillOpacity", 1), _ref516),
    mask: "url(#path-811-inside-292_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.4258 192.05H88.7308",
    stroke: "#CCD5D3",
    style: (_ref517 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref517, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref517, "strokeOpacity", 1), _ref517),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask293 || (_mask293 = /*#__PURE__*/React.createElement("mask", {
    id: "path-814-inside-293_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 188.264H122.319V195.836H94.1582V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 188.264H122.319V195.836H94.1582V188.264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 188.264V187.986H93.8809V188.264H94.1582ZM94.1582 188.264V188.541H122.319V188.264V187.986H94.1582V188.264ZM94.1582 195.836H94.4355V188.264H94.1582H93.8809V195.836H94.1582Z",
    fill: "#EAEEED",
    style: (_ref518 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref518, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref518, "fillOpacity", 1), _ref518),
    mask: "url(#path-814-inside-293_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M99.5859 192.05H116.891",
    stroke: "#CCD5D3",
    style: (_ref519 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref519, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref519, "strokeOpacity", 1), _ref519),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask294 || (_mask294 = /*#__PURE__*/React.createElement("mask", {
    id: "path-817-inside-294_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 188.264H150.48V195.836H122.319V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 188.264H150.48V195.836H122.319V188.264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 188.264V187.986H122.042V188.264H122.319ZM122.319 188.264V188.541H150.48V188.264V187.986H122.319V188.264ZM122.319 195.836H122.597V188.264H122.319H122.042V195.836H122.319Z",
    fill: "#EAEEED",
    style: (_ref520 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref520, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref520, "fillOpacity", 1), _ref520),
    mask: "url(#path-817-inside-294_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.747 192.05H145.052",
    stroke: "#CCD5D3",
    style: (_ref521 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref521, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref521, "strokeOpacity", 1), _ref521),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask295 || (_mask295 = /*#__PURE__*/React.createElement("mask", {
    id: "path-820-inside-295_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 188.264H178.641V195.836H150.48V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 188.264H178.641V195.836H150.48V188.264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 188.264V187.986H150.203V188.264H150.48ZM150.48 188.264V188.541H178.641V188.264V187.986H150.48V188.264ZM150.48 195.836H150.758V188.264H150.48H150.203V195.836H150.48Z",
    fill: "#EAEEED",
    style: (_ref522 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref522, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref522, "fillOpacity", 1), _ref522),
    mask: "url(#path-820-inside-295_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.908 192.05H173.213",
    stroke: "#CCD5D3",
    style: (_ref523 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref523, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref523, "strokeOpacity", 1), _ref523),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  }), _mask296 || (_mask296 = /*#__PURE__*/React.createElement("mask", {
    id: "path-823-inside-296_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 188.264H206.801V195.836H178.641V188.264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 188.264H206.801V195.836H178.641V188.264Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 188.264V187.986H178.363V188.264H178.641ZM178.641 188.264V188.541H206.801V188.264V187.986H178.641V188.264ZM178.641 195.836H178.918V188.264H178.641H178.363V195.836H178.641Z",
    fill: "#EAEEED",
    style: (_ref524 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref524, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref524, "fillOpacity", 1), _ref524),
    mask: "url(#path-823-inside-296_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M184.068 192.05H201.373",
    stroke: "#CCD5D3",
    style: (_ref525 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref525, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref525, "strokeOpacity", 1), _ref525),
    strokeWidth: 1.66405,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    transform: "translate(29.5166 195.836)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask297 || (_mask297 = /*#__PURE__*/React.createElement("mask", {
    id: "path-826-inside-297_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 195.836H37.8368V203.409H29.5166V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 195.836H37.8368V203.409H29.5166V195.836Z",
    fill: "#FAFAFA",
    style: (_ref526 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref526, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref526, "fillOpacity", 1), _ref526)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 195.836V196.114H37.8368V195.836V195.559H29.5166V195.836Z",
    fill: "url(#paint43_linear_17113_221003)",
    style: {},
    mask: "url(#path-826-inside-297_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7054 200.836V198.82L32.3061 198.919V198.72L32.7986 198.507H32.9883V200.836H32.7054ZM33.4493 200.836V200.64C33.6069 200.516 33.7566 200.39 33.8986 200.264C34.0428 200.138 34.1704 200.012 34.2814 199.888C34.3923 199.761 34.4788 199.638 34.5409 199.519C34.6053 199.399 34.6375 199.283 34.6375 199.172C34.6375 199.09 34.623 199.015 34.5942 198.946C34.5654 198.875 34.5188 198.817 34.4544 198.773C34.3923 198.729 34.308 198.706 34.2015 198.706C34.0972 198.706 34.0107 198.73 33.9419 198.776C33.8731 198.821 33.821 198.881 33.7855 198.956C33.7522 199.029 33.7355 199.11 33.7355 199.199H33.466C33.4682 199.046 33.5004 198.915 33.5625 198.806C33.6268 198.695 33.7145 198.611 33.8254 198.553C33.9363 198.496 34.0628 198.467 34.2048 198.467C34.3446 198.467 34.4677 198.493 34.5742 198.547C34.6807 198.598 34.7639 198.674 34.8238 198.776C34.886 198.878 34.917 199.007 34.917 199.162C34.917 199.271 34.8937 199.38 34.8471 199.489C34.8028 199.597 34.7428 199.704 34.6674 199.808C34.592 199.91 34.5077 200.009 34.4145 200.104C34.3235 200.2 34.2292 200.29 34.1316 200.374C34.0362 200.458 33.9463 200.535 33.862 200.603H34.9969V200.836H33.4493Z",
    fill: "#7F7F7D",
    style: (_ref527 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref527, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref527, "fillOpacity", 1), _ref527)
  }), _mask298 || (_mask298 = /*#__PURE__*/React.createElement("mask", {
    id: "path-829-inside-298_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 195.836H65.9977V203.409H37.8369V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 195.836H65.9977V203.409H37.8369V195.836Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8369 195.836V195.559H37.5596V195.836H37.8369ZM37.8369 195.836V196.114H65.9977V195.836V195.559H37.8369V195.836ZM37.8369 203.409H38.1143V195.836H37.8369H37.5596V203.409H37.8369Z",
    fill: "#EAEEED",
    style: (_ref528 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref528, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref528, "fillOpacity", 1), _ref528),
    mask: "url(#path-829-inside-298_17113_221003)"
  }), _mask299 || (_mask299 = /*#__PURE__*/React.createElement("mask", {
    id: "path-831-inside-299_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.998 195.836H94.1588V203.409H65.998V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 195.836H94.1588V203.409H65.998V195.836Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.998 195.836V195.559H65.7207V195.836H65.998ZM65.998 195.836V196.114H94.1588V195.836V195.559H65.998V195.836ZM65.998 203.409H66.2754V195.836H65.998H65.7207V203.409H65.998Z",
    fill: "#EAEEED",
    style: (_ref529 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref529, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref529, "fillOpacity", 1), _ref529),
    mask: "url(#path-831-inside-299_17113_221003)"
  }), _mask300 || (_mask300 = /*#__PURE__*/React.createElement("mask", {
    id: "path-833-inside-300_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 195.836H122.319V203.409H94.1582V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 195.836H122.319V203.409H94.1582V195.836Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1582 195.836V195.559H93.8809V195.836H94.1582ZM94.1582 195.836V196.114H122.319V195.836V195.559H94.1582V195.836ZM94.1582 203.409H94.4355V195.836H94.1582H93.8809V203.409H94.1582Z",
    fill: "#EAEEED",
    style: (_ref530 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref530, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref530, "fillOpacity", 1), _ref530),
    mask: "url(#path-833-inside-300_17113_221003)"
  }), _mask301 || (_mask301 = /*#__PURE__*/React.createElement("mask", {
    id: "path-835-inside-301_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.319 195.836H150.48V203.409H122.319V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 195.836H150.48V203.409H122.319V195.836Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.319 195.836V195.559H122.042V195.836H122.319ZM122.319 195.836V196.114H150.48V195.836V195.559H122.319V195.836ZM122.319 203.409H122.597V195.836H122.319H122.042V203.409H122.319Z",
    fill: "#EAEEED",
    style: (_ref531 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref531, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref531, "fillOpacity", 1), _ref531),
    mask: "url(#path-835-inside-301_17113_221003)"
  }), _mask302 || (_mask302 = /*#__PURE__*/React.createElement("mask", {
    id: "path-837-inside-302_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.48 195.836H178.641V203.409H150.48V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 195.836H178.641V203.409H150.48V195.836Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 195.836V195.559H150.203V195.836H150.48ZM150.48 195.836V196.114H178.641V195.836V195.559H150.48V195.836ZM150.48 203.409H150.758V195.836H150.48H150.203V203.409H150.48Z",
    fill: "#EAEEED",
    style: (_ref532 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref532, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref532, "fillOpacity", 1), _ref532),
    mask: "url(#path-837-inside-302_17113_221003)"
  }), _mask303 || (_mask303 = /*#__PURE__*/React.createElement("mask", {
    id: "path-839-inside-303_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.641 195.836H206.801V203.409H178.641V195.836Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 195.836H206.801V203.409H178.641V195.836Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.641 195.836V195.559H178.363V195.836H178.641ZM178.641 195.836V196.114H206.801V195.836V195.559H178.641V195.836ZM178.641 203.409H178.918V195.836H178.641H178.363V203.409H178.641Z",
    fill: "#EAEEED",
    style: (_ref533 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref533, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref533, "fillOpacity", 1), _ref533),
    mask: "url(#path-839-inside-303_17113_221003)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 29.4473,
    y: 93.0544,
    width: 374.549,
    height: 208.145,
    rx: 2.28806,
    stroke: "#EAEEED",
    style: (_ref534 = {
      stroke: "#EAEEED"
    }, _defineProperty(_ref534, "stroke", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref534, "strokeOpacity", 1), _ref534),
    strokeWidth: 0.138671,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.3496 93.3328H191.677C195.335 93.333 198.301 96.2986 198.301 99.9568V196.344C198.301 200.003 195.335 202.968 191.677 202.969H36.3496C32.6912 202.968 29.7256 200.003 29.7256 196.344V99.9568C29.7258 96.2985 32.6914 93.333 36.3496 93.3328Z",
    stroke: "#C2E6D1",
    style: (_ref535 = {
      stroke: "#C2E6D1"
    }, _defineProperty(_ref535, "stroke", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref535, "strokeOpacity", 1), _ref535),
    strokeWidth: 0.417964
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_17113_221003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.614,
    y: 115.759,
    width: 141.372,
    height: 128.597,
    rx: 6.8334,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_17113_221003)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 11.6322,
    transform: "translate(171.614 115.759)",
    fill: "#E4F2E6",
    style: (_ref536 = {
      fill: "#E4F2E6"
    }, _defineProperty(_ref536, "fill", "color(display-p3 0.8941 0.9490 0.9020)"), _defineProperty(_ref536, "fillOpacity", 1), _ref536)
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_17113_221003)"
  }, _mask304 || (_mask304 = /*#__PURE__*/React.createElement("mask", {
    id: "path-845-inside-304_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 127.391H607.821V138.377H171.614V127.391Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 127.391H607.821V138.377H171.614V127.391Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.69349,
    height: 10.986,
    transform: "translate(171.614 127.391)",
    fill: "#FAFAFA",
    style: (_ref537 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref537, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref537, "fillOpacity", 1), _ref537)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.823 137.892H172.688L180.823 128.671V137.892Z",
    fill: "#EAEEED",
    stroke: "#FAFAFA",
    style: (_ref538 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref538, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref538, "fillOpacity", 1), _defineProperty(_ref538, "stroke", "#FAFAFA"), _defineProperty(_ref538, "stroke", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref538, "strokeOpacity", 1), _ref538),
    strokeWidth: 0.969349,
    strokeLinejoin: "round"
  }), _mask305 || (_mask305 = /*#__PURE__*/React.createElement("mask", {
    id: "path-848-inside-305_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 127.391H214.116V138.377H181.308V127.391Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 127.391H214.116V138.377H181.308V127.391Z",
    fill: "#FAFAFA",
    style: (_ref539 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref539, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref539, "fillOpacity", 1), _ref539)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 138.377H181.631V127.391H181.308H180.985V138.377H181.308Z",
    fill: "url(#paint44_linear_17113_221003)",
    style: {},
    mask: "url(#path-848-inside-305_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.346 134.391L197.513 131.224H197.915L199.078 134.391H198.675L197.712 131.699L196.744 134.391H196.346ZM196.879 133.577L196.988 133.269H198.422L198.531 133.577H196.879Z",
    fill: "#7F7F7D",
    style: (_ref540 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref540, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref540, "fillOpacity", 1), _ref540)
  }), _mask306 || (_mask306 = /*#__PURE__*/React.createElement("mask", {
    id: "path-851-inside-306_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 127.391H246.925V138.377H214.116V127.391Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 127.391H246.925V138.377H214.116V127.391Z",
    fill: "#FAFAFA",
    style: (_ref541 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref541, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref541, "fillOpacity", 1), _ref541)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 138.377H214.439V127.391H214.116H213.793V138.377H214.116Z",
    fill: "url(#paint45_linear_17113_221003)",
    style: {},
    mask: "url(#path-851-inside-306_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.497 134.391V131.224H230.61C230.833 131.224 231.017 131.261 231.162 131.333C231.309 131.402 231.42 131.499 231.492 131.622C231.564 131.743 231.6 131.879 231.6 132.03C231.6 132.192 231.564 132.328 231.492 132.437C231.423 132.545 231.331 132.628 231.216 132.685C231.104 132.743 230.985 132.777 230.859 132.79L230.922 132.744C231.058 132.747 231.183 132.783 231.297 132.853C231.412 132.922 231.502 133.016 231.569 133.133C231.638 133.251 231.673 133.382 231.673 133.527C231.673 133.687 231.634 133.833 231.555 133.966C231.477 134.095 231.361 134.199 231.207 134.278C231.056 134.353 230.869 134.391 230.646 134.391H229.497ZM229.877 134.074H230.605C230.819 134.074 230.985 134.024 231.103 133.925C231.224 133.822 231.284 133.681 231.284 133.5C231.284 133.322 231.222 133.18 231.098 133.074C230.978 132.966 230.81 132.912 230.596 132.912H229.877V134.074ZM229.877 132.609H230.583C230.788 132.609 230.943 132.56 231.049 132.464C231.157 132.367 231.211 132.236 231.211 132.07C231.211 131.91 231.157 131.782 231.049 131.686C230.943 131.589 230.783 131.541 230.569 131.541H229.877V132.609Z",
    fill: "#7F7F7D",
    style: (_ref542 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref542, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref542, "fillOpacity", 1), _ref542)
  }), _mask307 || (_mask307 = /*#__PURE__*/React.createElement("mask", {
    id: "path-854-inside-307_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 127.391H279.734V138.377H246.925V127.391Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 127.391H279.734V138.377H246.925V127.391Z",
    fill: "#FAFAFA",
    style: (_ref543 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref543, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref543, "fillOpacity", 1), _ref543)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 138.377H247.248V127.391H246.925H246.602V138.377H246.925Z",
    fill: "url(#paint46_linear_17113_221003)",
    style: {},
    mask: "url(#path-854-inside-307_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.422 134.445C263.115 134.445 262.848 134.377 262.622 134.242C262.399 134.103 262.227 133.911 262.106 133.667C261.985 133.42 261.925 133.133 261.925 132.808C261.925 132.482 261.985 132.197 262.106 131.953C262.227 131.705 262.399 131.514 262.622 131.378C262.848 131.239 263.115 131.17 263.422 131.17C263.784 131.17 264.078 131.256 264.304 131.428C264.531 131.6 264.675 131.843 264.739 132.156H264.318C264.27 131.96 264.172 131.803 264.024 131.686C263.876 131.565 263.676 131.505 263.422 131.505C263.196 131.505 263 131.558 262.834 131.663C262.668 131.766 262.54 131.915 262.45 132.111C262.359 132.304 262.314 132.536 262.314 132.808C262.314 133.079 262.359 133.313 262.45 133.509C262.54 133.702 262.668 133.851 262.834 133.957C263 134.059 263.196 134.11 263.422 134.11C263.676 134.11 263.876 134.053 264.024 133.939C264.172 133.821 264.27 133.666 264.318 133.473H264.739C264.675 133.777 264.531 134.015 264.304 134.187C264.078 134.359 263.784 134.445 263.422 134.445Z",
    fill: "#7F7F7D",
    style: (_ref544 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref544, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref544, "fillOpacity", 1), _ref544)
  }), _mask308 || (_mask308 = /*#__PURE__*/React.createElement("mask", {
    id: "path-857-inside-308_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 127.391H312.543V138.377H279.734V127.391Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 127.391H312.543V138.377H279.734V127.391Z",
    fill: "#FAFAFA",
    style: (_ref545 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref545, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref545, "fillOpacity", 1), _ref545)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 138.377H280.057V127.391H279.734H279.411V138.377H279.734Z",
    fill: "url(#paint47_linear_17113_221003)",
    style: {},
    mask: "url(#path-857-inside-308_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.921 134.391V131.224H295.853C296.224 131.224 296.528 131.289 296.766 131.419C297.008 131.546 297.186 131.728 297.3 131.966C297.418 132.201 297.477 132.485 297.477 132.817C297.477 133.142 297.418 133.423 297.3 133.658C297.186 133.893 297.008 134.074 296.766 134.201C296.528 134.328 296.224 134.391 295.853 134.391H294.921ZM295.301 134.074H295.844C296.151 134.074 296.396 134.024 296.576 133.925C296.757 133.822 296.887 133.678 296.965 133.491C297.044 133.301 297.083 133.076 297.083 132.817C297.083 132.551 297.044 132.324 296.965 132.134C296.887 131.944 296.757 131.797 296.576 131.695C296.396 131.592 296.151 131.541 295.844 131.541H295.301V134.074Z",
    fill: "#7F7F7D",
    style: (_ref546 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref546, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref546, "fillOpacity", 1), _ref546)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 127.391V127.714H607.821V127.391V127.068H171.614V127.391Z",
    fill: "#EAEEED",
    style: (_ref547 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref547, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref547, "fillOpacity", 1), _ref547),
    mask: "url(#path-845-inside-304_17113_221003)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 138.377)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask309 || (_mask309 = /*#__PURE__*/React.createElement("mask", {
    id: "path-860-inside-309_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 138.377H181.308V147.199H171.614V138.377Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 138.377H181.308V147.199H171.614V138.377Z",
    fill: "#FAFAFA",
    style: (_ref548 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref548, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref548, "fillOpacity", 1), _ref548)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 138.377V138.7H181.308V138.377V138.054H171.614V138.377Z",
    fill: "url(#paint48_linear_17113_221003)",
    style: {},
    mask: "url(#path-860-inside-309_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.446 144.377V142.027L175.981 142.143V141.911L176.555 141.663H176.776V144.377H176.446Z",
    fill: "#7F7F7D",
    style: (_ref549 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref549, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref549, "fillOpacity", 1), _ref549)
  }), _mask310 || (_mask310 = /*#__PURE__*/React.createElement("mask", {
    id: "path-863-inside-310_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 138.377H214.116V147.199H181.308V138.377Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 138.377H214.116V147.199H181.308V138.377Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 138.377V138.054H180.985V138.377H181.308ZM181.308 138.377V138.7H214.116V138.377V138.054H181.308V138.377ZM181.308 147.199H181.631V138.377H181.308H180.985V147.199H181.308Z",
    fill: "#EAEEED",
    style: (_ref550 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref550, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref550, "fillOpacity", 1), _ref550),
    mask: "url(#path-863-inside-310_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 142.788H207.793",
    stroke: "#99ABA7",
    style: (_ref551 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref551, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref551, "strokeOpacity", 1), _ref551),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask311 || (_mask311 = /*#__PURE__*/React.createElement("mask", {
    id: "path-866-inside-311_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 138.377H246.925V147.199H214.116V138.377Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 138.377H246.925V147.199H214.116V138.377Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 138.377V138.054H213.793V138.377H214.116ZM214.116 138.377V138.7H246.925V138.377V138.054H214.116V138.377ZM214.116 147.199H214.439V138.377H214.116H213.793V147.199H214.116Z",
    fill: "#EAEEED",
    style: (_ref552 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref552, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref552, "fillOpacity", 1), _ref552),
    mask: "url(#path-866-inside-311_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 142.788H240.602",
    stroke: "#99ABA7",
    style: (_ref553 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref553, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref553, "strokeOpacity", 1), _ref553),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask312 || (_mask312 = /*#__PURE__*/React.createElement("mask", {
    id: "path-869-inside-312_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 138.377H279.734V147.199H246.925V138.377Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 138.377H279.734V147.199H246.925V138.377Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 138.377V138.054H246.602V138.377H246.925ZM246.925 138.377V138.7H279.734V138.377V138.054H246.925V138.377ZM246.925 147.199H247.248V138.377H246.925H246.602V147.199H246.925Z",
    fill: "#EAEEED",
    style: (_ref554 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref554, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref554, "fillOpacity", 1), _ref554),
    mask: "url(#path-869-inside-312_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 142.788H273.41",
    stroke: "#99ABA7",
    style: (_ref555 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref555, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref555, "strokeOpacity", 1), _ref555),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask313 || (_mask313 = /*#__PURE__*/React.createElement("mask", {
    id: "path-872-inside-313_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 138.377H312.543V147.199H279.734V138.377Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 138.377H312.543V147.199H279.734V138.377Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 138.377V138.054H279.411V138.377H279.734ZM279.734 138.377V138.7H312.543V138.377V138.054H279.734V138.377ZM279.734 147.199H280.057V138.377H279.734H279.411V147.199H279.734Z",
    fill: "#EAEEED",
    style: (_ref556 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref556, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref556, "fillOpacity", 1), _ref556),
    mask: "url(#path-872-inside-313_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 142.788H306.22",
    stroke: "#99ABA7",
    style: (_ref557 = {
      stroke: "#99ABA7"
    }, _defineProperty(_ref557, "stroke", "color(display-p3 0.6000 0.6706 0.6549)"), _defineProperty(_ref557, "strokeOpacity", 1), _ref557),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 147.199)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask314 || (_mask314 = /*#__PURE__*/React.createElement("mask", {
    id: "path-875-inside-314_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 147.199H181.308V156.022H171.614V147.199Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 147.199H181.308V156.022H171.614V147.199Z",
    fill: "#FAFAFA",
    style: (_ref558 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref558, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref558, "fillOpacity", 1), _ref558)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 147.199V147.522H181.308V147.199V146.876H171.614V147.199Z",
    fill: "url(#paint49_linear_17113_221003)",
    style: {},
    mask: "url(#path-875-inside-314_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.592 153.199V152.971C175.776 152.826 175.95 152.68 176.116 152.532C176.284 152.385 176.432 152.239 176.561 152.094C176.691 151.947 176.792 151.803 176.864 151.664C176.939 151.524 176.976 151.39 176.976 151.261C176.976 151.165 176.96 151.077 176.926 150.997C176.892 150.914 176.838 150.847 176.763 150.795C176.691 150.744 176.592 150.718 176.468 150.718C176.347 150.718 176.246 150.745 176.166 150.799C176.086 150.851 176.025 150.921 175.984 151.009C175.945 151.094 175.926 151.188 175.926 151.292H175.612C175.614 151.113 175.652 150.961 175.724 150.834C175.799 150.705 175.901 150.607 176.03 150.539C176.16 150.472 176.307 150.439 176.472 150.439C176.635 150.439 176.779 150.47 176.903 150.532C177.027 150.591 177.124 150.68 177.193 150.799C177.266 150.918 177.302 151.068 177.302 151.249C177.302 151.376 177.275 151.502 177.221 151.629C177.169 151.756 177.099 151.88 177.011 152.001C176.923 152.12 176.825 152.235 176.717 152.346C176.611 152.457 176.501 152.562 176.387 152.66C176.276 152.759 176.171 152.848 176.073 152.928H177.395V153.199H175.592Z",
    fill: "#7F7F7D",
    style: (_ref559 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref559, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref559, "fillOpacity", 1), _ref559)
  }), _mask315 || (_mask315 = /*#__PURE__*/React.createElement("mask", {
    id: "path-878-inside-315_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 147.199H214.116V156.022H181.308V147.199Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 147.199H214.116V156.022H181.308V147.199Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 147.199V146.876H180.985V147.199H181.308ZM181.308 147.199V147.522H214.116V147.199V146.876H181.308V147.199ZM181.308 156.022H181.631V147.199H181.308H180.985V156.022H181.308Z",
    fill: "#EAEEED",
    style: (_ref560 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref560, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref560, "fillOpacity", 1), _ref560),
    mask: "url(#path-878-inside-315_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 151.611H207.793",
    stroke: "#CCD5D3",
    style: (_ref561 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref561, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref561, "strokeOpacity", 1), _ref561),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask316 || (_mask316 = /*#__PURE__*/React.createElement("mask", {
    id: "path-881-inside-316_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 147.199H246.925V156.022H214.116V147.199Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 147.199H246.925V156.022H214.116V147.199Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 147.199V146.876H213.793V147.199H214.116ZM214.116 147.199V147.522H246.925V147.199V146.876H214.116V147.199ZM214.116 156.022H214.439V147.199H214.116H213.793V156.022H214.116Z",
    fill: "#EAEEED",
    style: (_ref562 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref562, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref562, "fillOpacity", 1), _ref562),
    mask: "url(#path-881-inside-316_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 151.611H240.602",
    stroke: "#CCD5D3",
    style: (_ref563 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref563, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref563, "strokeOpacity", 1), _ref563),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask317 || (_mask317 = /*#__PURE__*/React.createElement("mask", {
    id: "path-884-inside-317_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 147.199H279.734V156.022H246.925V147.199Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 147.199H279.734V156.022H246.925V147.199Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 147.199V146.876H246.602V147.199H246.925ZM246.925 147.199V147.522H279.734V147.199V146.876H246.925V147.199ZM246.925 156.022H247.248V147.199H246.925H246.602V156.022H246.925Z",
    fill: "#EAEEED",
    style: (_ref564 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref564, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref564, "fillOpacity", 1), _ref564),
    mask: "url(#path-884-inside-317_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 151.611H273.41",
    stroke: "#CCD5D3",
    style: (_ref565 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref565, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref565, "strokeOpacity", 1), _ref565),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask318 || (_mask318 = /*#__PURE__*/React.createElement("mask", {
    id: "path-887-inside-318_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 147.199H312.543V156.022H279.734V147.199Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 147.199H312.543V156.022H279.734V147.199Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 147.199V146.876H279.411V147.199H279.734ZM279.734 147.199V147.522H312.543V147.199V146.876H279.734V147.199ZM279.734 156.022H280.057V147.199H279.734H279.411V156.022H279.734Z",
    fill: "#EAEEED",
    style: (_ref566 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref566, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref566, "fillOpacity", 1), _ref566),
    mask: "url(#path-887-inside-318_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 151.611H306.22",
    stroke: "#CCD5D3",
    style: (_ref567 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref567, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref567, "strokeOpacity", 1), _ref567),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 156.022)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask319 || (_mask319 = /*#__PURE__*/React.createElement("mask", {
    id: "path-890-inside-319_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 156.022H181.308V164.844H171.614V156.022Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 156.022H181.308V164.844H171.614V156.022Z",
    fill: "#FAFAFA",
    style: (_ref568 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref568, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref568, "fillOpacity", 1), _ref568)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 156.022V156.345H181.308V156.022V155.699H171.614V156.022Z",
    fill: "url(#paint50_linear_17113_221003)",
    style: {},
    mask: "url(#path-890-inside-319_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.452 162.068C176.278 162.068 176.121 162.037 175.979 161.975C175.839 161.911 175.728 161.815 175.645 161.688C175.562 161.562 175.518 161.404 175.513 161.215H175.843C175.845 161.319 175.87 161.414 175.917 161.502C175.966 161.588 176.035 161.656 176.126 161.708C176.216 161.759 176.325 161.785 176.452 161.785C176.578 161.785 176.684 161.761 176.77 161.712C176.855 161.662 176.92 161.598 176.963 161.518C177.007 161.435 177.029 161.343 177.029 161.242C177.029 161.116 176.998 161.014 176.936 160.936C176.877 160.856 176.795 160.798 176.692 160.762C176.591 160.723 176.48 160.703 176.359 160.703H176.157V160.428H176.359C176.537 160.428 176.677 160.387 176.777 160.304C176.878 160.221 176.929 160.108 176.929 159.963C176.929 159.844 176.889 159.744 176.808 159.664C176.731 159.584 176.612 159.544 176.452 159.544C176.299 159.544 176.178 159.588 176.087 159.676C175.997 159.764 175.945 159.876 175.932 160.013H175.603C175.61 159.866 175.65 159.735 175.723 159.622C175.795 159.508 175.893 159.42 176.017 159.358C176.141 159.293 176.288 159.261 176.456 159.261C176.631 159.261 176.779 159.292 176.898 159.354C177.016 159.416 177.106 159.499 177.165 159.602C177.227 159.706 177.258 159.819 177.258 159.944C177.258 160.037 177.241 160.124 177.208 160.207C177.174 160.287 177.124 160.358 177.057 160.42C176.989 160.482 176.904 160.526 176.801 160.552C176.907 160.573 177.001 160.613 177.084 160.672C177.169 160.732 177.236 160.809 177.285 160.905C177.334 161.001 177.359 161.113 177.359 161.242C177.359 161.39 177.324 161.527 177.254 161.653C177.187 161.778 177.086 161.878 176.952 161.956C176.817 162.031 176.651 162.068 176.452 162.068Z",
    fill: "#7F7F7D",
    style: (_ref569 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref569, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref569, "fillOpacity", 1), _ref569)
  }), _mask320 || (_mask320 = /*#__PURE__*/React.createElement("mask", {
    id: "path-893-inside-320_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 156.022H214.116V164.844H181.308V156.022Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 156.022H214.116V164.844H181.308V156.022Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 156.022V155.699H180.985V156.022H181.308ZM181.308 156.022V156.345H214.116V156.022V155.699H181.308V156.022ZM181.308 164.844H181.631V156.022H181.308H180.985V164.844H181.308Z",
    fill: "#EAEEED",
    style: (_ref570 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref570, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref570, "fillOpacity", 1), _ref570),
    mask: "url(#path-893-inside-320_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 160.433H207.793",
    stroke: "#CCD5D3",
    style: (_ref571 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref571, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref571, "strokeOpacity", 1), _ref571),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask321 || (_mask321 = /*#__PURE__*/React.createElement("mask", {
    id: "path-896-inside-321_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 156.022H246.925V164.844H214.116V156.022Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 156.022H246.925V164.844H214.116V156.022Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 156.022V155.699H213.793V156.022H214.116ZM214.116 156.022V156.345H246.925V156.022V155.699H214.116V156.022ZM214.116 164.844H214.439V156.022H214.116H213.793V164.844H214.116Z",
    fill: "#EAEEED",
    style: (_ref572 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref572, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref572, "fillOpacity", 1), _ref572),
    mask: "url(#path-896-inside-321_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 160.433H240.602",
    stroke: "#CCD5D3",
    style: (_ref573 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref573, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref573, "strokeOpacity", 1), _ref573),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask322 || (_mask322 = /*#__PURE__*/React.createElement("mask", {
    id: "path-899-inside-322_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 156.022H279.734V164.844H246.925V156.022Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 156.022H279.734V164.844H246.925V156.022Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 156.022V155.699H246.602V156.022H246.925ZM246.925 156.022V156.345H279.734V156.022V155.699H246.925V156.022ZM246.925 164.844H247.248V156.022H246.925H246.602V164.844H246.925Z",
    fill: "#EAEEED",
    style: (_ref574 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref574, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref574, "fillOpacity", 1), _ref574),
    mask: "url(#path-899-inside-322_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 160.433H273.41",
    stroke: "#CCD5D3",
    style: (_ref575 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref575, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref575, "strokeOpacity", 1), _ref575),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask323 || (_mask323 = /*#__PURE__*/React.createElement("mask", {
    id: "path-902-inside-323_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 156.022H312.543V164.844H279.734V156.022Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 156.022H312.543V164.844H279.734V156.022Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 156.022V155.699H279.411V156.022H279.734ZM279.734 156.022V156.345H312.543V156.022V155.699H279.734V156.022ZM279.734 164.844H280.057V156.022H279.734H279.411V164.844H279.734Z",
    fill: "#EAEEED",
    style: (_ref576 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref576, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref576, "fillOpacity", 1), _ref576),
    mask: "url(#path-902-inside-323_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 160.433H306.22",
    stroke: "#CCD5D3",
    style: (_ref577 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref577, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref577, "strokeOpacity", 1), _ref577),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 164.844)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask324 || (_mask324 = /*#__PURE__*/React.createElement("mask", {
    id: "path-905-inside-324_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 164.844H181.308V173.667H171.614V164.844Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 164.844H181.308V173.667H171.614V164.844Z",
    fill: "#FAFAFA",
    style: (_ref578 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref578, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref578, "fillOpacity", 1), _ref578)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 164.844V165.167H181.308V164.844V164.521H171.614V164.844Z",
    fill: "url(#paint51_linear_17113_221003)",
    style: {},
    mask: "url(#path-905-inside-324_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.803 170.844V170.263H175.427V170.011L176.745 168.13H177.125V169.976H177.528V170.263H177.125V170.844H176.803ZM175.787 169.976H176.819V168.491L175.787 169.976Z",
    fill: "#7F7F7D",
    style: (_ref579 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref579, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref579, "fillOpacity", 1), _ref579)
  }), _mask325 || (_mask325 = /*#__PURE__*/React.createElement("mask", {
    id: "path-908-inside-325_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 164.844H214.116V173.667H181.308V164.844Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 164.844H214.116V173.667H181.308V164.844Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 164.844V164.521H180.985V164.844H181.308ZM181.308 164.844V165.167H214.116V164.844V164.521H181.308V164.844ZM181.308 173.667H181.631V164.844H181.308H180.985V173.667H181.308Z",
    fill: "#EAEEED",
    style: (_ref580 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref580, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref580, "fillOpacity", 1), _ref580),
    mask: "url(#path-908-inside-325_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 169.255H207.793",
    stroke: "#CCD5D3",
    style: (_ref581 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref581, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref581, "strokeOpacity", 1), _ref581),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask326 || (_mask326 = /*#__PURE__*/React.createElement("mask", {
    id: "path-911-inside-326_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 164.844H246.925V173.667H214.116V164.844Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 164.844H246.925V173.667H214.116V164.844Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 164.844V164.521H213.793V164.844H214.116ZM214.116 164.844V165.167H246.925V164.844V164.521H214.116V164.844ZM214.116 173.667H214.439V164.844H214.116H213.793V173.667H214.116Z",
    fill: "#EAEEED",
    style: (_ref582 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref582, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref582, "fillOpacity", 1), _ref582),
    mask: "url(#path-911-inside-326_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 169.255H240.602",
    stroke: "#CCD5D3",
    style: (_ref583 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref583, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref583, "strokeOpacity", 1), _ref583),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask327 || (_mask327 = /*#__PURE__*/React.createElement("mask", {
    id: "path-914-inside-327_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 164.844H279.734V173.667H246.925V164.844Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 164.844H279.734V173.667H246.925V164.844Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 164.844V164.521H246.602V164.844H246.925ZM246.925 164.844V165.167H279.734V164.844V164.521H246.925V164.844ZM246.925 173.667H247.248V164.844H246.925H246.602V173.667H246.925Z",
    fill: "#EAEEED",
    style: (_ref584 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref584, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref584, "fillOpacity", 1), _ref584),
    mask: "url(#path-914-inside-327_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 169.255H273.41",
    stroke: "#CCD5D3",
    style: (_ref585 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref585, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref585, "strokeOpacity", 1), _ref585),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask328 || (_mask328 = /*#__PURE__*/React.createElement("mask", {
    id: "path-917-inside-328_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 164.844H312.543V173.667H279.734V164.844Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 164.844H312.543V173.667H279.734V164.844Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 164.844V164.521H279.411V164.844H279.734ZM279.734 164.844V165.167H312.543V164.844V164.521H279.734V164.844ZM279.734 173.667H280.057V164.844H279.734H279.411V173.667H279.734Z",
    fill: "#EAEEED",
    style: (_ref586 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref586, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref586, "fillOpacity", 1), _ref586),
    mask: "url(#path-917-inside-328_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 169.255H306.22",
    stroke: "#CCD5D3",
    style: (_ref587 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref587, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref587, "strokeOpacity", 1), _ref587),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 173.667)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask329 || (_mask329 = /*#__PURE__*/React.createElement("mask", {
    id: "path-920-inside-329_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 173.667H181.308V182.489H171.614V173.667Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 173.667H181.308V182.489H171.614V173.667Z",
    fill: "#FAFAFA",
    style: (_ref588 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref588, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref588, "fillOpacity", 1), _ref588)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 173.667V173.99H181.308V173.667V173.344H171.614V173.667Z",
    fill: "url(#paint52_linear_17113_221003)",
    style: {},
    mask: "url(#path-920-inside-329_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.484 179.713C176.297 179.713 176.136 179.68 175.999 179.612C175.864 179.545 175.757 179.453 175.677 179.337C175.6 179.221 175.55 179.09 175.53 178.946H175.848C175.879 179.09 175.95 179.208 176.061 179.298C176.172 179.389 176.314 179.434 176.487 179.434C176.617 179.434 176.727 179.404 176.817 179.345C176.91 179.285 176.981 179.204 177.03 179.101C177.082 178.997 177.108 178.882 177.108 178.756C177.108 178.624 177.082 178.507 177.03 178.407C176.979 178.306 176.908 178.228 176.817 178.174C176.727 178.117 176.621 178.089 176.499 178.089C176.352 178.089 176.226 178.121 176.123 178.186C176.02 178.25 175.942 178.333 175.89 178.434H175.576L175.801 176.953H177.236V177.236H176.053L175.902 178.069C175.967 177.994 176.052 177.934 176.158 177.887C176.266 177.838 176.392 177.813 176.534 177.813C176.668 177.813 176.79 177.837 176.898 177.883C177.007 177.93 177.1 177.996 177.178 178.081C177.255 178.166 177.315 178.266 177.356 178.379C177.4 178.493 177.422 178.617 177.422 178.752C177.422 178.884 177.4 179.008 177.356 179.124C177.315 179.238 177.254 179.34 177.174 179.43C177.094 179.518 176.995 179.588 176.879 179.64C176.763 179.689 176.631 179.713 176.484 179.713Z",
    fill: "#7F7F7D",
    style: (_ref589 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref589, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref589, "fillOpacity", 1), _ref589)
  }), _mask330 || (_mask330 = /*#__PURE__*/React.createElement("mask", {
    id: "path-923-inside-330_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 173.667H214.116V182.489H181.308V173.667Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 173.667H214.116V182.489H181.308V173.667Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 173.667V173.344H180.985V173.667H181.308ZM181.308 173.667V173.99H214.116V173.667V173.344H181.308V173.667ZM181.308 182.489H181.631V173.667H181.308H180.985V182.489H181.308Z",
    fill: "#EAEEED",
    style: (_ref590 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref590, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref590, "fillOpacity", 1), _ref590),
    mask: "url(#path-923-inside-330_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 178.078H207.793",
    stroke: "#CCD5D3",
    style: (_ref591 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref591, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref591, "strokeOpacity", 1), _ref591),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask331 || (_mask331 = /*#__PURE__*/React.createElement("mask", {
    id: "path-926-inside-331_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 173.667H246.925V182.489H214.116V173.667Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 173.667H246.925V182.489H214.116V173.667Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 173.667V173.344H213.793V173.667H214.116ZM214.116 173.667V173.99H246.925V173.667V173.344H214.116V173.667ZM214.116 182.489H214.439V173.667H214.116H213.793V182.489H214.116Z",
    fill: "#EAEEED",
    style: (_ref592 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref592, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref592, "fillOpacity", 1), _ref592),
    mask: "url(#path-926-inside-331_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 178.078H240.602",
    stroke: "#CCD5D3",
    style: (_ref593 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref593, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref593, "strokeOpacity", 1), _ref593),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask332 || (_mask332 = /*#__PURE__*/React.createElement("mask", {
    id: "path-929-inside-332_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 173.667H279.734V182.489H246.925V173.667Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 173.667H279.734V182.489H246.925V173.667Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 173.667V173.344H246.602V173.667H246.925ZM246.925 173.667V173.99H279.734V173.667V173.344H246.925V173.667ZM246.925 182.489H247.248V173.667H246.925H246.602V182.489H246.925Z",
    fill: "#EAEEED",
    style: (_ref594 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref594, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref594, "fillOpacity", 1), _ref594),
    mask: "url(#path-929-inside-332_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 178.078H273.41",
    stroke: "#CCD5D3",
    style: (_ref595 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref595, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref595, "strokeOpacity", 1), _ref595),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask333 || (_mask333 = /*#__PURE__*/React.createElement("mask", {
    id: "path-932-inside-333_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 173.667H312.543V182.489H279.734V173.667Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 173.667H312.543V182.489H279.734V173.667Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 173.667V173.344H279.411V173.667H279.734ZM279.734 173.667V173.99H312.543V173.667V173.344H279.734V173.667ZM279.734 182.489H280.057V173.667H279.734H279.411V182.489H279.734Z",
    fill: "#EAEEED",
    style: (_ref596 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref596, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref596, "fillOpacity", 1), _ref596),
    mask: "url(#path-932-inside-333_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 178.078H306.22",
    stroke: "#CCD5D3",
    style: (_ref597 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref597, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref597, "strokeOpacity", 1), _ref597),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 182.489)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask334 || (_mask334 = /*#__PURE__*/React.createElement("mask", {
    id: "path-935-inside-334_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 182.489H181.308V191.312H171.614V182.489Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 182.489H181.308V191.312H171.614V182.489Z",
    fill: "#FAFAFA",
    style: (_ref598 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref598, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref598, "fillOpacity", 1), _ref598)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 182.489V182.812H181.308V182.489V182.166H171.614V182.489Z",
    fill: "url(#paint53_linear_17113_221003)",
    style: {},
    mask: "url(#path-935-inside-334_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.508 188.536C176.311 188.536 176.146 188.5 176.011 188.427C175.877 188.352 175.77 188.254 175.69 188.132C175.609 188.008 175.55 187.869 175.511 187.714C175.475 187.559 175.457 187.401 175.457 187.241C175.457 186.941 175.498 186.678 175.581 186.454C175.664 186.226 175.783 186.049 175.938 185.922C176.095 185.793 176.284 185.728 176.504 185.728C176.674 185.728 176.82 185.762 176.942 185.829C177.066 185.894 177.164 185.982 177.237 186.093C177.309 186.204 177.353 186.328 177.368 186.465H177.066C177.04 186.32 176.977 186.209 176.876 186.132C176.778 186.052 176.652 186.012 176.5 186.012C176.365 186.012 176.244 186.054 176.135 186.139C176.027 186.222 175.94 186.35 175.876 186.523C175.814 186.694 175.777 186.912 175.767 187.179C175.767 187.181 175.767 187.185 175.767 187.19C175.767 187.195 175.767 187.201 175.767 187.206C175.808 187.126 175.865 187.051 175.938 186.981C176.013 186.911 176.102 186.856 176.205 186.814C176.309 186.773 176.424 186.752 176.55 186.752C176.703 186.752 176.846 186.788 176.981 186.861C177.115 186.933 177.224 187.035 177.306 187.167C177.392 187.296 177.434 187.449 177.434 187.625C177.434 187.777 177.397 187.923 177.322 188.063C177.25 188.202 177.144 188.316 177.004 188.404C176.864 188.492 176.699 188.536 176.508 188.536ZM176.484 188.249C176.603 188.249 176.709 188.223 176.802 188.171C176.898 188.117 176.972 188.045 177.023 187.954C177.078 187.861 177.105 187.756 177.105 187.64C177.105 187.519 177.078 187.413 177.023 187.322C176.972 187.232 176.898 187.162 176.802 187.113C176.709 187.061 176.603 187.035 176.484 187.035C176.365 187.035 176.258 187.062 176.163 187.117C176.067 187.171 175.991 187.245 175.934 187.338C175.88 187.428 175.852 187.53 175.852 187.644C175.852 187.76 175.88 187.865 175.934 187.958C175.991 188.048 176.067 188.12 176.163 188.171C176.258 188.223 176.365 188.249 176.484 188.249Z",
    fill: "#7F7F7D",
    style: (_ref599 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref599, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref599, "fillOpacity", 1), _ref599)
  }), _mask335 || (_mask335 = /*#__PURE__*/React.createElement("mask", {
    id: "path-938-inside-335_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 182.489H214.116V191.312H181.308V182.489Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 182.489H214.116V191.312H181.308V182.489Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 182.489V182.166H180.985V182.489H181.308ZM181.308 182.489V182.812H214.116V182.489V182.166H181.308V182.489ZM181.308 191.312H181.631V182.489H181.308H180.985V191.312H181.308Z",
    fill: "#EAEEED",
    style: (_ref600 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref600, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref600, "fillOpacity", 1), _ref600),
    mask: "url(#path-938-inside-335_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 186.9H207.793",
    stroke: "#CCD5D3",
    style: (_ref601 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref601, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref601, "strokeOpacity", 1), _ref601),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask336 || (_mask336 = /*#__PURE__*/React.createElement("mask", {
    id: "path-941-inside-336_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 182.489H246.925V191.312H214.116V182.489Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 182.489H246.925V191.312H214.116V182.489Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 182.489V182.166H213.793V182.489H214.116ZM214.116 182.489V182.812H246.925V182.489V182.166H214.116V182.489ZM214.116 191.312H214.439V182.489H214.116H213.793V191.312H214.116Z",
    fill: "#EAEEED",
    style: (_ref602 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref602, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref602, "fillOpacity", 1), _ref602),
    mask: "url(#path-941-inside-336_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 186.9H240.602",
    stroke: "#CCD5D3",
    style: (_ref603 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref603, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref603, "strokeOpacity", 1), _ref603),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask337 || (_mask337 = /*#__PURE__*/React.createElement("mask", {
    id: "path-944-inside-337_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 182.489H279.734V191.312H246.925V182.489Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 182.489H279.734V191.312H246.925V182.489Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 182.489V182.166H246.602V182.489H246.925ZM246.925 182.489V182.812H279.734V182.489V182.166H246.925V182.489ZM246.925 191.312H247.248V182.489H246.925H246.602V191.312H246.925Z",
    fill: "#EAEEED",
    style: (_ref604 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref604, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref604, "fillOpacity", 1), _ref604),
    mask: "url(#path-944-inside-337_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 186.9H273.41",
    stroke: "#CCD5D3",
    style: (_ref605 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref605, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref605, "strokeOpacity", 1), _ref605),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask338 || (_mask338 = /*#__PURE__*/React.createElement("mask", {
    id: "path-947-inside-338_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 182.489H312.543V191.312H279.734V182.489Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 182.489H312.543V191.312H279.734V182.489Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 182.489V182.166H279.411V182.489H279.734ZM279.734 182.489V182.812H312.543V182.489V182.166H279.734V182.489ZM279.734 191.312H280.057V182.489H279.734H279.411V191.312H279.734Z",
    fill: "#EAEEED",
    style: (_ref606 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref606, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref606, "fillOpacity", 1), _ref606),
    mask: "url(#path-947-inside-338_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 186.9H306.22",
    stroke: "#CCD5D3",
    style: (_ref607 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref607, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref607, "strokeOpacity", 1), _ref607),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 191.312)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask339 || (_mask339 = /*#__PURE__*/React.createElement("mask", {
    id: "path-950-inside-339_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 191.312H181.308V200.134H171.614V191.312Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 191.312H181.308V200.134H171.614V191.312Z",
    fill: "#FAFAFA",
    style: (_ref608 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref608, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref608, "fillOpacity", 1), _ref608)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 191.312V191.635H181.308V191.312V190.989H171.614V191.312Z",
    fill: "url(#paint54_linear_17113_221003)",
    style: {},
    mask: "url(#path-950-inside-339_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.96 197.312L177.019 194.877H175.53V194.597H177.352V194.842L176.306 197.312H175.96Z",
    fill: "#7F7F7D",
    style: (_ref609 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref609, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref609, "fillOpacity", 1), _ref609)
  }), _mask340 || (_mask340 = /*#__PURE__*/React.createElement("mask", {
    id: "path-953-inside-340_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 191.312H214.116V200.134H181.308V191.312Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 191.312H214.116V200.134H181.308V191.312Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 191.312V190.989H180.985V191.312H181.308ZM181.308 191.312V191.635H214.116V191.312V190.989H181.308V191.312ZM181.308 200.134H181.631V191.312H181.308H180.985V200.134H181.308Z",
    fill: "#EAEEED",
    style: (_ref610 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref610, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref610, "fillOpacity", 1), _ref610),
    mask: "url(#path-953-inside-340_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 195.723H207.793",
    stroke: "#CCD5D3",
    style: (_ref611 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref611, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref611, "strokeOpacity", 1), _ref611),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask341 || (_mask341 = /*#__PURE__*/React.createElement("mask", {
    id: "path-956-inside-341_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 191.312H246.925V200.134H214.116V191.312Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 191.312H246.925V200.134H214.116V191.312Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 191.312V190.989H213.793V191.312H214.116ZM214.116 191.312V191.635H246.925V191.312V190.989H214.116V191.312ZM214.116 200.134H214.439V191.312H214.116H213.793V200.134H214.116Z",
    fill: "#EAEEED",
    style: (_ref612 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref612, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref612, "fillOpacity", 1), _ref612),
    mask: "url(#path-956-inside-341_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 195.723H240.602",
    stroke: "#CCD5D3",
    style: (_ref613 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref613, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref613, "strokeOpacity", 1), _ref613),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask342 || (_mask342 = /*#__PURE__*/React.createElement("mask", {
    id: "path-959-inside-342_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 191.312H279.734V200.134H246.925V191.312Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 191.312H279.734V200.134H246.925V191.312Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 191.312V190.989H246.602V191.312H246.925ZM246.925 191.312V191.635H279.734V191.312V190.989H246.925V191.312ZM246.925 200.134H247.248V191.312H246.925H246.602V200.134H246.925Z",
    fill: "#EAEEED",
    style: (_ref614 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref614, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref614, "fillOpacity", 1), _ref614),
    mask: "url(#path-959-inside-342_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 195.723H273.41",
    stroke: "#CCD5D3",
    style: (_ref615 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref615, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref615, "strokeOpacity", 1), _ref615),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask343 || (_mask343 = /*#__PURE__*/React.createElement("mask", {
    id: "path-962-inside-343_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 191.312H312.543V200.134H279.734V191.312Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 191.312H312.543V200.134H279.734V191.312Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 191.312V190.989H279.411V191.312H279.734ZM279.734 191.312V191.635H312.543V191.312V190.989H279.734V191.312ZM279.734 200.134H280.057V191.312H279.734H279.411V200.134H279.734Z",
    fill: "#EAEEED",
    style: (_ref616 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref616, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref616, "fillOpacity", 1), _ref616),
    mask: "url(#path-962-inside-343_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 195.723H306.22",
    stroke: "#CCD5D3",
    style: (_ref617 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref617, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref617, "strokeOpacity", 1), _ref617),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 200.134)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask344 || (_mask344 = /*#__PURE__*/React.createElement("mask", {
    id: "path-965-inside-344_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 200.134H181.308V208.957H171.614V200.134Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 200.134H181.308V208.957H171.614V200.134Z",
    fill: "#FAFAFA",
    style: (_ref618 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref618, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref618, "fillOpacity", 1), _ref618)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 200.134V200.457H181.308V200.134V199.811H171.614V200.134Z",
    fill: "url(#paint55_linear_17113_221003)",
    style: {},
    mask: "url(#path-965-inside-344_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.46 206.181C176.284 206.181 176.127 206.148 175.987 206.084C175.848 206.017 175.736 205.925 175.654 205.808C175.571 205.69 175.53 205.553 175.53 205.397C175.53 205.286 175.552 205.183 175.596 205.087C175.64 204.992 175.7 204.909 175.778 204.839C175.858 204.767 175.95 204.716 176.053 204.688C175.908 204.636 175.796 204.556 175.716 204.447C175.638 204.339 175.599 204.221 175.599 204.095C175.599 203.96 175.634 203.839 175.704 203.73C175.774 203.622 175.872 203.535 175.999 203.47C176.128 203.406 176.282 203.373 176.46 203.373C176.641 203.373 176.795 203.406 176.922 203.47C177.051 203.535 177.149 203.622 177.216 203.73C177.286 203.839 177.321 203.96 177.321 204.095C177.321 204.221 177.281 204.339 177.201 204.447C177.123 204.556 177.012 204.636 176.867 204.688C176.973 204.716 177.065 204.767 177.143 204.839C177.223 204.909 177.284 204.992 177.325 205.087C177.369 205.183 177.391 205.286 177.391 205.397C177.391 205.553 177.349 205.69 177.267 205.808C177.187 205.925 177.075 206.017 176.933 206.084C176.794 206.148 176.636 206.181 176.46 206.181ZM176.46 205.894C176.664 205.894 176.816 205.847 176.914 205.754C177.015 205.659 177.065 205.533 177.065 205.378C177.065 205.202 177.01 205.069 176.898 204.979C176.79 204.888 176.644 204.843 176.46 204.843C176.277 204.843 176.129 204.888 176.018 204.979C175.91 205.069 175.855 205.202 175.855 205.378C175.855 205.533 175.906 205.659 176.007 205.754C176.107 205.847 176.259 205.894 176.46 205.894ZM176.46 204.572C176.623 204.572 176.752 204.529 176.848 204.444C176.944 204.358 176.991 204.248 176.991 204.114C176.991 203.962 176.944 203.846 176.848 203.769C176.755 203.691 176.626 203.653 176.46 203.653C176.297 203.653 176.168 203.691 176.072 203.769C175.979 203.846 175.933 203.962 175.933 204.114C175.933 204.248 175.979 204.358 176.072 204.444C176.168 204.529 176.297 204.572 176.46 204.572Z",
    fill: "#7F7F7D",
    style: (_ref619 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref619, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref619, "fillOpacity", 1), _ref619)
  }), _mask345 || (_mask345 = /*#__PURE__*/React.createElement("mask", {
    id: "path-968-inside-345_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 200.134H214.116V208.957H181.308V200.134Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 200.134H214.116V208.957H181.308V200.134Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 200.134V199.811H180.985V200.134H181.308ZM181.308 200.134V200.457H214.116V200.134V199.811H181.308V200.134ZM181.308 208.957H181.631V200.134H181.308H180.985V208.957H181.308Z",
    fill: "#EAEEED",
    style: (_ref620 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref620, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref620, "fillOpacity", 1), _ref620),
    mask: "url(#path-968-inside-345_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 204.545H207.793",
    stroke: "#CCD5D3",
    style: (_ref621 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref621, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref621, "strokeOpacity", 1), _ref621),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask346 || (_mask346 = /*#__PURE__*/React.createElement("mask", {
    id: "path-971-inside-346_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 200.134H246.925V208.957H214.116V200.134Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 200.134H246.925V208.957H214.116V200.134Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 200.134V199.811H213.793V200.134H214.116ZM214.116 200.134V200.457H246.925V200.134V199.811H214.116V200.134ZM214.116 208.957H214.439V200.134H214.116H213.793V208.957H214.116Z",
    fill: "#EAEEED",
    style: (_ref622 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref622, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref622, "fillOpacity", 1), _ref622),
    mask: "url(#path-971-inside-346_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 204.545H240.602",
    stroke: "#CCD5D3",
    style: (_ref623 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref623, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref623, "strokeOpacity", 1), _ref623),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask347 || (_mask347 = /*#__PURE__*/React.createElement("mask", {
    id: "path-974-inside-347_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 200.134H279.734V208.957H246.925V200.134Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 200.134H279.734V208.957H246.925V200.134Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 200.134V199.811H246.602V200.134H246.925ZM246.925 200.134V200.457H279.734V200.134V199.811H246.925V200.134ZM246.925 208.957H247.248V200.134H246.925H246.602V208.957H246.925Z",
    fill: "#EAEEED",
    style: (_ref624 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref624, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref624, "fillOpacity", 1), _ref624),
    mask: "url(#path-974-inside-347_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 204.545H273.41",
    stroke: "#CCD5D3",
    style: (_ref625 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref625, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref625, "strokeOpacity", 1), _ref625),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask348 || (_mask348 = /*#__PURE__*/React.createElement("mask", {
    id: "path-977-inside-348_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 200.134H312.543V208.957H279.734V200.134Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 200.134H312.543V208.957H279.734V200.134Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 200.134V199.811H279.411V200.134H279.734ZM279.734 200.134V200.457H312.543V200.134V199.811H279.734V200.134ZM279.734 208.957H280.057V200.134H279.734H279.411V208.957H279.734Z",
    fill: "#EAEEED",
    style: (_ref626 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref626, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref626, "fillOpacity", 1), _ref626),
    mask: "url(#path-977-inside-348_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 204.545H306.22",
    stroke: "#CCD5D3",
    style: (_ref627 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref627, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref627, "strokeOpacity", 1), _ref627),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 208.957)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask349 || (_mask349 = /*#__PURE__*/React.createElement("mask", {
    id: "path-980-inside-349_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 208.957H181.308V217.779H171.614V208.957Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 208.957H181.308V217.779H171.614V208.957Z",
    fill: "#FAFAFA",
    style: (_ref628 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref628, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref628, "fillOpacity", 1), _ref628)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 208.957V209.28H181.308V208.957V208.633H171.614V208.957Z",
    fill: "url(#paint56_linear_17113_221003)",
    style: {},
    mask: "url(#path-980-inside-349_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.418 215.003C176.248 215.003 176.102 214.971 175.98 214.906C175.859 214.839 175.762 214.75 175.69 214.639C175.62 214.525 175.577 214.401 175.562 214.266H175.864C175.89 214.411 175.952 214.524 176.05 214.604C176.148 214.681 176.272 214.72 176.422 214.72C176.559 214.72 176.681 214.679 176.787 214.596C176.893 214.513 176.978 214.388 177.043 214.22C177.11 214.049 177.147 213.833 177.155 213.572C177.155 213.565 177.155 213.557 177.155 213.549C177.155 213.541 177.155 213.534 177.155 213.526C177.116 213.606 177.06 213.681 176.985 213.751C176.91 213.821 176.82 213.876 176.717 213.917C176.616 213.959 176.502 213.98 176.376 213.98C176.223 213.98 176.079 213.943 175.942 213.871C175.807 213.799 175.697 213.698 175.612 213.568C175.529 213.437 175.488 213.283 175.488 213.107C175.488 212.955 175.525 212.809 175.6 212.669C175.675 212.529 175.783 212.416 175.922 212.328C176.062 212.24 176.227 212.196 176.418 212.196C176.612 212.196 176.776 212.233 176.911 212.308C177.045 212.381 177.153 212.479 177.233 212.603C177.315 212.725 177.375 212.863 177.411 213.018C177.447 213.173 177.465 213.331 177.465 213.491C177.465 213.788 177.424 214.051 177.341 214.278C177.261 214.506 177.142 214.684 176.985 214.813C176.829 214.94 176.641 215.003 176.418 215.003ZM176.442 213.696C176.561 213.696 176.668 213.669 176.764 213.615C176.859 213.561 176.934 213.487 176.988 213.394C177.045 213.301 177.074 213.199 177.074 213.088C177.074 212.969 177.045 212.864 176.988 212.774C176.934 212.683 176.859 212.612 176.764 212.56C176.668 212.509 176.561 212.483 176.442 212.483C176.323 212.483 176.216 212.51 176.12 212.564C176.027 212.616 175.953 212.687 175.899 212.778C175.845 212.868 175.817 212.973 175.817 213.092C175.817 213.213 175.845 213.319 175.899 213.41C175.953 213.5 176.027 213.571 176.12 213.623C176.216 213.672 176.323 213.696 176.442 213.696Z",
    fill: "#7F7F7D",
    style: (_ref629 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref629, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref629, "fillOpacity", 1), _ref629)
  }), _mask350 || (_mask350 = /*#__PURE__*/React.createElement("mask", {
    id: "path-983-inside-350_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 208.957H214.116V217.779H181.308V208.957Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 208.957H214.116V217.779H181.308V208.957Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 208.957V208.633H180.985V208.957H181.308ZM181.308 208.957V209.28H214.116V208.957V208.633H181.308V208.957ZM181.308 217.779H181.631V208.957H181.308H180.985V217.779H181.308Z",
    fill: "#EAEEED",
    style: (_ref630 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref630, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref630, "fillOpacity", 1), _ref630),
    mask: "url(#path-983-inside-350_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 213.368H207.793",
    stroke: "#CCD5D3",
    style: (_ref631 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref631, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref631, "strokeOpacity", 1), _ref631),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask351 || (_mask351 = /*#__PURE__*/React.createElement("mask", {
    id: "path-986-inside-351_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 208.957H246.925V217.779H214.116V208.957Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 208.957H246.925V217.779H214.116V208.957Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 208.957V208.633H213.793V208.957H214.116ZM214.116 208.957V209.28H246.925V208.957V208.633H214.116V208.957ZM214.116 217.779H214.439V208.957H214.116H213.793V217.779H214.116Z",
    fill: "#EAEEED",
    style: (_ref632 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref632, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref632, "fillOpacity", 1), _ref632),
    mask: "url(#path-986-inside-351_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 213.368H240.602",
    stroke: "#CCD5D3",
    style: (_ref633 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref633, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref633, "strokeOpacity", 1), _ref633),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask352 || (_mask352 = /*#__PURE__*/React.createElement("mask", {
    id: "path-989-inside-352_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 208.957H279.734V217.779H246.925V208.957Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 208.957H279.734V217.779H246.925V208.957Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 208.957V208.633H246.602V208.957H246.925ZM246.925 208.957V209.28H279.734V208.957V208.633H246.925V208.957ZM246.925 217.779H247.248V208.957H246.925H246.602V217.779H246.925Z",
    fill: "#EAEEED",
    style: (_ref634 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref634, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref634, "fillOpacity", 1), _ref634),
    mask: "url(#path-989-inside-352_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 213.368H273.41",
    stroke: "#CCD5D3",
    style: (_ref635 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref635, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref635, "strokeOpacity", 1), _ref635),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask353 || (_mask353 = /*#__PURE__*/React.createElement("mask", {
    id: "path-992-inside-353_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 208.957H312.543V217.779H279.734V208.957Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 208.957H312.543V217.779H279.734V208.957Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 208.957V208.633H279.411V208.957H279.734ZM279.734 208.957V209.28H312.543V208.957V208.633H279.734V208.957ZM279.734 217.779H280.057V208.957H279.734H279.411V217.779H279.734Z",
    fill: "#EAEEED",
    style: (_ref636 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref636, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref636, "fillOpacity", 1), _ref636),
    mask: "url(#path-992-inside-353_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 213.368H306.22",
    stroke: "#CCD5D3",
    style: (_ref637 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref637, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref637, "strokeOpacity", 1), _ref637),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 217.779)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask354 || (_mask354 = /*#__PURE__*/React.createElement("mask", {
    id: "path-995-inside-354_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 217.779H181.308V226.602H171.614V217.779Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 217.779H181.308V226.602H171.614V217.779Z",
    fill: "#FAFAFA",
    style: (_ref638 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref638, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref638, "fillOpacity", 1), _ref638)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 217.779V218.102H181.308V217.779V217.456H171.614V217.779Z",
    fill: "url(#paint57_linear_17113_221003)",
    style: {},
    mask: "url(#path-995-inside-354_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.121 223.779V221.429L174.656 221.546V221.313L175.23 221.065H175.451V223.779H175.121ZM177.07 223.826C176.832 223.826 176.626 223.767 176.453 223.651C176.283 223.532 176.152 223.368 176.061 223.159C175.971 222.947 175.926 222.701 175.926 222.422C175.926 222.143 175.971 221.899 176.061 221.689C176.152 221.477 176.283 221.313 176.453 221.197C176.626 221.078 176.832 221.018 177.07 221.018C177.307 221.018 177.51 221.078 177.678 221.197C177.849 221.313 177.98 221.477 178.07 221.689C178.16 221.899 178.206 222.143 178.206 222.422C178.206 222.701 178.16 222.947 178.07 223.159C177.98 223.368 177.849 223.532 177.678 223.651C177.51 223.767 177.307 223.826 177.07 223.826ZM177.066 223.539C177.221 223.539 177.359 223.495 177.481 223.407C177.602 223.316 177.698 223.188 177.768 223.023C177.837 222.855 177.872 222.655 177.872 222.422C177.872 222.189 177.837 221.99 177.768 221.825C177.698 221.657 177.602 221.529 177.481 221.441C177.359 221.353 177.221 221.309 177.066 221.309C176.911 221.309 176.771 221.353 176.647 221.441C176.525 221.529 176.43 221.657 176.36 221.825C176.293 221.99 176.259 222.189 176.259 222.422C176.259 222.655 176.293 222.855 176.36 223.023C176.43 223.188 176.525 223.316 176.647 223.407C176.771 223.495 176.911 223.539 177.066 223.539Z",
    fill: "#7F7F7D",
    style: (_ref639 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref639, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref639, "fillOpacity", 1), _ref639)
  }), _mask355 || (_mask355 = /*#__PURE__*/React.createElement("mask", {
    id: "path-998-inside-355_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 217.779H214.116V226.602H181.308V217.779Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 217.779H214.116V226.602H181.308V217.779Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 217.779V217.456H180.985V217.779H181.308ZM181.308 217.779V218.102H214.116V217.779V217.456H181.308V217.779ZM181.308 226.602H181.631V217.779H181.308H180.985V226.602H181.308Z",
    fill: "#EAEEED",
    style: (_ref640 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref640, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref640, "fillOpacity", 1), _ref640),
    mask: "url(#path-998-inside-355_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 222.19H207.793",
    stroke: "#CCD5D3",
    style: (_ref641 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref641, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref641, "strokeOpacity", 1), _ref641),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask356 || (_mask356 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1001-inside-356_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 217.779H246.925V226.602H214.116V217.779Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 217.779H246.925V226.602H214.116V217.779Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 217.779V217.456H213.793V217.779H214.116ZM214.116 217.779V218.102H246.925V217.779V217.456H214.116V217.779ZM214.116 226.602H214.439V217.779H214.116H213.793V226.602H214.116Z",
    fill: "#EAEEED",
    style: (_ref642 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref642, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref642, "fillOpacity", 1), _ref642),
    mask: "url(#path-1001-inside-356_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 222.19H240.602",
    stroke: "#CCD5D3",
    style: (_ref643 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref643, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref643, "strokeOpacity", 1), _ref643),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask357 || (_mask357 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1004-inside-357_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 217.779H279.734V226.602H246.925V217.779Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 217.779H279.734V226.602H246.925V217.779Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 217.779V217.456H246.602V217.779H246.925ZM246.925 217.779V218.102H279.734V217.779V217.456H246.925V217.779ZM246.925 226.602H247.248V217.779H246.925H246.602V226.602H246.925Z",
    fill: "#EAEEED",
    style: (_ref644 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref644, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref644, "fillOpacity", 1), _ref644),
    mask: "url(#path-1004-inside-357_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 222.19H273.41",
    stroke: "#CCD5D3",
    style: (_ref645 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref645, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref645, "strokeOpacity", 1), _ref645),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask358 || (_mask358 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1007-inside-358_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 217.779H312.543V226.602H279.734V217.779Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 217.779H312.543V226.602H279.734V217.779Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 217.779V217.456H279.411V217.779H279.734ZM279.734 217.779V218.102H312.543V217.779V217.456H279.734V217.779ZM279.734 226.602H280.057V217.779H279.734H279.411V226.602H279.734Z",
    fill: "#EAEEED",
    style: (_ref646 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref646, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref646, "fillOpacity", 1), _ref646),
    mask: "url(#path-1007-inside-358_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 222.19H306.22",
    stroke: "#CCD5D3",
    style: (_ref647 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref647, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref647, "strokeOpacity", 1), _ref647),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 226.602)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask359 || (_mask359 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1010-inside-359_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 226.602H181.308V235.424H171.614V226.602Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 226.602H181.308V235.424H171.614V226.602Z",
    fill: "#FAFAFA",
    style: (_ref648 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref648, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref648, "fillOpacity", 1), _ref648)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 226.602V226.925H181.308V226.602V226.278H171.614V226.602Z",
    fill: "url(#paint58_linear_17113_221003)",
    style: {},
    mask: "url(#path-1010-inside-359_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.842 232.602V230.252L175.377 230.368V230.136L175.951 229.887H176.172V232.602H175.842ZM177.05 232.602V230.252L176.585 230.368V230.136L177.159 229.887H177.38V232.602H177.05Z",
    fill: "#7F7F7D",
    style: (_ref649 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref649, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref649, "fillOpacity", 1), _ref649)
  }), _mask360 || (_mask360 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1013-inside-360_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 226.602H214.116V235.424H181.308V226.602Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 226.602H214.116V235.424H181.308V226.602Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 226.602V226.278H180.985V226.602H181.308ZM181.308 226.602V226.925H214.116V226.602V226.278H181.308V226.602ZM181.308 235.424H181.631V226.602H181.308H180.985V235.424H181.308Z",
    fill: "#EAEEED",
    style: (_ref650 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref650, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref650, "fillOpacity", 1), _ref650),
    mask: "url(#path-1013-inside-360_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.632 231.013H207.793",
    stroke: "#CCD5D3",
    style: (_ref651 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref651, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref651, "strokeOpacity", 1), _ref651),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask361 || (_mask361 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1016-inside-361_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 226.602H246.925V235.424H214.116V226.602Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 226.602H246.925V235.424H214.116V226.602Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 226.602V226.278H213.793V226.602H214.116ZM214.116 226.602V226.925H246.925V226.602V226.278H214.116V226.602ZM214.116 235.424H214.439V226.602H214.116H213.793V235.424H214.116Z",
    fill: "#EAEEED",
    style: (_ref652 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref652, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref652, "fillOpacity", 1), _ref652),
    mask: "url(#path-1016-inside-361_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M220.44 231.013H240.602",
    stroke: "#CCD5D3",
    style: (_ref653 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref653, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref653, "strokeOpacity", 1), _ref653),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask362 || (_mask362 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1019-inside-362_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 226.602H279.734V235.424H246.925V226.602Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 226.602H279.734V235.424H246.925V226.602Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 226.602V226.278H246.602V226.602H246.925ZM246.925 226.602V226.925H279.734V226.602V226.278H246.925V226.602ZM246.925 235.424H247.248V226.602H246.925H246.602V235.424H246.925Z",
    fill: "#EAEEED",
    style: (_ref654 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref654, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref654, "fillOpacity", 1), _ref654),
    mask: "url(#path-1019-inside-362_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.249 231.013H273.41",
    stroke: "#CCD5D3",
    style: (_ref655 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref655, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref655, "strokeOpacity", 1), _ref655),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  }), _mask363 || (_mask363 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1022-inside-363_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 226.602H312.543V235.424H279.734V226.602Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 226.602H312.543V235.424H279.734V226.602Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 226.602V226.278H279.411V226.602H279.734ZM279.734 226.602V226.925H312.543V226.602V226.278H279.734V226.602ZM279.734 235.424H280.057V226.602H279.734H279.411V235.424H279.734Z",
    fill: "#EAEEED",
    style: (_ref656 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref656, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref656, "fillOpacity", 1), _ref656),
    mask: "url(#path-1022-inside-363_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.059 231.013H306.22",
    stroke: "#CCD5D3",
    style: (_ref657 = {
      stroke: "#CCD5D3"
    }, _defineProperty(_ref657, "stroke", "color(display-p3 0.8000 0.8353 0.8275)"), _defineProperty(_ref657, "strokeOpacity", 1), _ref657),
    strokeWidth: 1.9387,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 235.424)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask364 || (_mask364 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1025-inside-364_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 235.424H181.308V244.246H171.614V235.424Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 235.424H181.308V244.246H171.614V235.424Z",
    fill: "#FAFAFA",
    style: (_ref658 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref658, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref658, "fillOpacity", 1), _ref658)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 235.424V235.747H181.308V235.424V235.101H171.614V235.424Z",
    fill: "url(#paint59_linear_17113_221003)",
    style: {},
    mask: "url(#path-1025-inside-364_17113_221003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.329 241.424V239.074L174.864 239.191V238.958L175.438 238.71H175.659V241.424H175.329ZM176.196 241.424V241.195C176.38 241.05 176.554 240.904 176.72 240.757C176.888 240.61 177.036 240.464 177.165 240.319C177.295 240.172 177.395 240.028 177.468 239.889C177.543 239.749 177.58 239.615 177.58 239.485C177.58 239.39 177.564 239.302 177.53 239.222C177.496 239.139 177.442 239.072 177.367 239.02C177.295 238.968 177.196 238.942 177.072 238.942C176.951 238.942 176.85 238.97 176.77 239.024C176.69 239.076 176.629 239.145 176.588 239.233C176.549 239.319 176.53 239.413 176.53 239.516H176.215C176.218 239.338 176.256 239.185 176.328 239.059C176.403 238.93 176.505 238.831 176.634 238.764C176.763 238.697 176.911 238.663 177.076 238.663C177.239 238.663 177.383 238.694 177.507 238.756C177.631 238.816 177.728 238.905 177.797 239.024C177.87 239.143 177.906 239.293 177.906 239.474C177.906 239.6 177.879 239.727 177.825 239.854C177.773 239.98 177.703 240.104 177.615 240.226C177.527 240.345 177.429 240.46 177.321 240.571C177.215 240.682 177.105 240.787 176.991 240.885C176.88 240.983 176.775 241.072 176.677 241.153H177.999V241.424H176.196Z",
    fill: "#7F7F7D",
    style: (_ref659 = {
      fill: "#7F7F7D"
    }, _defineProperty(_ref659, "fill", "color(display-p3 0.4980 0.4980 0.4902)"), _defineProperty(_ref659, "fillOpacity", 1), _ref659)
  }), _mask365 || (_mask365 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1028-inside-365_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 235.424H214.116V244.246H181.308V235.424Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 235.424H214.116V244.246H181.308V235.424Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 235.424V235.101H180.985V235.424H181.308ZM181.308 235.424V235.747H214.116V235.424V235.101H181.308V235.424ZM181.308 244.246H181.631V235.424H181.308H180.985V244.246H181.308Z",
    fill: "#EAEEED",
    style: (_ref660 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref660, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref660, "fillOpacity", 1), _ref660),
    mask: "url(#path-1028-inside-365_17113_221003)"
  }), _mask366 || (_mask366 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1030-inside-366_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 235.424H246.925V244.246H214.116V235.424Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 235.424H246.925V244.246H214.116V235.424Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 235.424V235.101H213.793V235.424H214.116ZM214.116 235.424V235.747H246.925V235.424V235.101H214.116V235.424ZM214.116 244.246H214.439V235.424H214.116H213.793V244.246H214.116Z",
    fill: "#EAEEED",
    style: (_ref661 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref661, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref661, "fillOpacity", 1), _ref661),
    mask: "url(#path-1030-inside-366_17113_221003)"
  }), _mask367 || (_mask367 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1032-inside-367_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 235.424H279.734V244.246H246.925V235.424Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 235.424H279.734V244.246H246.925V235.424Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 235.424V235.101H246.602V235.424H246.925ZM246.925 235.424V235.747H279.734V235.424V235.101H246.925V235.424ZM246.925 244.246H247.248V235.424H246.925H246.602V244.246H246.925Z",
    fill: "#EAEEED",
    style: (_ref662 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref662, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref662, "fillOpacity", 1), _ref662),
    mask: "url(#path-1032-inside-367_17113_221003)"
  }), _mask368 || (_mask368 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1034-inside-368_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 235.424H312.543V244.246H279.734V235.424Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 235.424H312.543V244.246H279.734V235.424Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 235.424V235.101H279.411V235.424H279.734ZM279.734 235.424V235.747H312.543V235.424V235.101H279.734V235.424ZM279.734 244.246H280.057V235.424H279.734H279.411V244.246H279.734Z",
    fill: "#EAEEED",
    style: (_ref663 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref663, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref663, "fillOpacity", 1), _ref663),
    mask: "url(#path-1034-inside-368_17113_221003)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_17113_221003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    transform: "translate(171.614 244.247)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), _mask369 || (_mask369 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1036-inside-369_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 244.247H181.308V253.069H171.614V244.247Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 244.247H181.308V253.069H171.614V244.247Z",
    fill: "#FAFAFA",
    style: (_ref664 = {
      fill: "#FAFAFA"
    }, _defineProperty(_ref664, "fill", "color(display-p3 0.9804 0.9804 0.9804)"), _defineProperty(_ref664, "fillOpacity", 1), _ref664)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.614 244.247V244.57H181.308V244.247V243.923H171.614V244.247Z",
    fill: "url(#paint60_linear_17113_221003)",
    style: {},
    mask: "url(#path-1036-inside-369_17113_221003)"
  }), _mask370 || (_mask370 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1038-inside-370_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.308 244.247H214.116V253.069H181.308V244.247Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 244.247H214.116V253.069H181.308V244.247Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.308 244.247V243.923H180.985V244.247H181.308ZM181.308 244.247V244.57H214.116V244.247V243.923H181.308V244.247ZM181.308 253.069H181.631V244.247H181.308H180.985V253.069H181.308Z",
    fill: "#EAEEED",
    style: (_ref665 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref665, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref665, "fillOpacity", 1), _ref665),
    mask: "url(#path-1038-inside-370_17113_221003)"
  }), _mask371 || (_mask371 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1040-inside-371_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.116 244.247H246.925V253.069H214.116V244.247Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 244.247H246.925V253.069H214.116V244.247Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 244.247V243.923H213.793V244.247H214.116ZM214.116 244.247V244.57H246.925V244.247V243.923H214.116V244.247ZM214.116 253.069H214.439V244.247H214.116H213.793V253.069H214.116Z",
    fill: "#EAEEED",
    style: (_ref666 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref666, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref666, "fillOpacity", 1), _ref666),
    mask: "url(#path-1040-inside-371_17113_221003)"
  }), _mask372 || (_mask372 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1042-inside-372_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.925 244.247H279.734V253.069H246.925V244.247Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 244.247H279.734V253.069H246.925V244.247Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.925 244.247V243.923H246.602V244.247H246.925ZM246.925 244.247V244.57H279.734V244.247V243.923H246.925V244.247ZM246.925 253.069H247.248V244.247H246.925H246.602V253.069H246.925Z",
    fill: "#EAEEED",
    style: (_ref667 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref667, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref667, "fillOpacity", 1), _ref667),
    mask: "url(#path-1042-inside-372_17113_221003)"
  }), _mask373 || (_mask373 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1044-inside-373_17113_221003",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.734 244.247H312.543V253.069H279.734V244.247Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 244.247H312.543V253.069H279.734V244.247Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.734 244.247V243.923H279.411V244.247H279.734ZM279.734 244.247V244.57H312.543V244.247V243.923H279.734V244.247ZM279.734 253.069H280.057V244.247H279.734H279.411V253.069H279.734Z",
    fill: "#EAEEED",
    style: (_ref668 = {
      fill: "#EAEEED"
    }, _defineProperty(_ref668, "fill", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref668, "fillOpacity", 1), _ref668),
    mask: "url(#path-1044-inside-373_17113_221003)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 171.533,
    y: 115.678,
    width: 436.368,
    height: 242.499,
    rx: 2.66571,
    stroke: "#EAEEED",
    style: (_ref669 = {
      stroke: "#EAEEED"
    }, _defineProperty(_ref669, "stroke", "color(display-p3 0.9176 0.9333 0.9294)"), _defineProperty(_ref669, "strokeOpacity", 1), _ref669),
    strokeWidth: 0.161558,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 171.823,
    y: 115.968,
    width: 140.954,
    height: 128.179,
    rx: 6.62442,
    stroke: "#C2E6D1",
    style: (_ref670 = {
      stroke: "#C2E6D1"
    }, _defineProperty(_ref670, "stroke", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref670, "strokeOpacity", 1), _ref670),
    strokeWidth: 0.417964
  })), /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 54,
    transform: "translate(0 246)",
    fill: "#F4FAF5",
    style: (_ref671 = {
      fill: "#F4FAF5"
    }, _defineProperty(_ref671, "fill", "color(display-p3 0.9569 0.9804 0.9608)"), _defineProperty(_ref671, "fillOpacity", 1), _ref671)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.54 280.24C25.58 280.24 24.7067 280.047 23.92 279.66C23.1467 279.273 22.5267 278.687 22.06 277.9C21.5933 277.1 21.36 276.08 21.36 274.84V266H23.04V274.86C23.04 275.767 23.1867 276.507 23.48 277.08C23.7867 277.653 24.2067 278.073 24.74 278.34C25.2733 278.607 25.8867 278.74 26.58 278.74C27.2867 278.74 27.9 278.607 28.42 278.34C28.94 278.073 29.3467 277.653 29.64 277.08C29.9333 276.507 30.08 275.767 30.08 274.86V266H31.76V274.84C31.76 276.08 31.5267 277.1 31.06 277.9C30.5933 278.687 29.9667 279.273 29.18 279.66C28.3933 280.047 27.5133 280.24 26.54 280.24ZM34.5055 284.4V269.92H36.0255L36.1655 271.56C36.3788 271.24 36.6521 270.94 36.9855 270.66C37.3188 270.367 37.7188 270.133 38.1855 269.96C38.6521 269.773 39.1855 269.68 39.7855 269.68C40.7721 269.68 41.6255 269.913 42.3455 270.38C43.0788 270.847 43.6455 271.48 44.0455 272.28C44.4588 273.067 44.6655 273.967 44.6655 274.98C44.6655 275.993 44.4588 276.9 44.0455 277.7C43.6455 278.487 43.0788 279.107 42.3455 279.56C41.6121 280.013 40.7521 280.24 39.7655 280.24C38.9521 280.24 38.2321 280.073 37.6055 279.74C36.9921 279.407 36.5188 278.94 36.1855 278.34V284.4H34.5055ZM39.5855 278.78C40.2388 278.78 40.8188 278.62 41.3255 278.3C41.8321 277.98 42.2255 277.54 42.5055 276.98C42.7988 276.407 42.9455 275.733 42.9455 274.96C42.9455 274.2 42.7988 273.533 42.5055 272.96C42.2255 272.387 41.8321 271.94 41.3255 271.62C40.8188 271.3 40.2388 271.14 39.5855 271.14C38.9188 271.14 38.3321 271.3 37.8255 271.62C37.3188 271.94 36.9255 272.387 36.6455 272.96C36.3655 273.533 36.2255 274.2 36.2255 274.96C36.2255 275.733 36.3655 276.407 36.6455 276.98C36.9255 277.54 37.3188 277.98 37.8255 278.3C38.3321 278.62 38.9188 278.78 39.5855 278.78ZM47.025 280V265.6H48.705V280H47.025ZM55.9781 280.24C55.0448 280.24 54.2048 280.027 53.4581 279.6C52.7115 279.16 52.1248 278.547 51.6981 277.76C51.2715 276.96 51.0581 276.033 51.0581 274.98C51.0581 273.9 51.2715 272.967 51.6981 272.18C52.1381 271.38 52.7315 270.767 53.4781 270.34C54.2381 269.9 55.0848 269.68 56.0181 269.68C56.9781 269.68 57.8248 269.9 58.5581 270.34C59.3048 270.767 59.8915 271.38 60.3181 272.18C60.7581 272.967 60.9781 273.893 60.9781 274.96C60.9781 276.027 60.7581 276.96 60.3181 277.76C59.8781 278.547 59.2848 279.16 58.5381 279.6C57.7915 280.027 56.9381 280.24 55.9781 280.24ZM55.9981 278.8C56.5715 278.8 57.1048 278.66 57.5981 278.38C58.0915 278.087 58.4915 277.653 58.7981 277.08C59.1048 276.507 59.2581 275.8 59.2581 274.96C59.2581 274.107 59.1048 273.4 58.7981 272.84C58.5048 272.267 58.1115 271.84 57.6181 271.56C57.1381 271.267 56.6048 271.12 56.0181 271.12C55.4581 271.12 54.9248 271.267 54.4181 271.56C53.9248 271.84 53.5248 272.267 53.2181 272.84C52.9248 273.4 52.7781 274.107 52.7781 274.96C52.7781 275.8 52.9248 276.507 53.2181 277.08C53.5248 277.653 53.9181 278.087 54.3981 278.38C54.8915 278.66 55.4248 278.8 55.9981 278.8ZM66.6136 280.24C65.8003 280.24 65.1203 280.1 64.5736 279.82C64.0269 279.527 63.6203 279.147 63.3536 278.68C63.0869 278.2 62.9536 277.68 62.9536 277.12C62.9536 276.44 63.1269 275.867 63.4736 275.4C63.8336 274.92 64.3336 274.56 64.9736 274.32C65.6269 274.067 66.3936 273.94 67.2736 273.94H69.9336C69.9336 273.313 69.8336 272.793 69.6336 272.38C69.4469 271.953 69.1669 271.633 68.7936 271.42C68.4336 271.207 67.9803 271.1 67.4336 271.1C66.7936 271.1 66.2403 271.26 65.7736 271.58C65.3069 271.9 65.0203 272.373 64.9136 273H63.1936C63.2736 272.28 63.5136 271.68 63.9136 271.2C64.3269 270.707 64.8469 270.333 65.4736 270.08C66.1003 269.813 66.7536 269.68 67.4336 269.68C68.3669 269.68 69.1403 269.853 69.7536 270.2C70.3803 270.533 70.8469 271.007 71.1536 271.62C71.4603 272.22 71.6136 272.933 71.6136 273.76V280H70.1136L70.0136 278.22C69.8803 278.5 69.7069 278.767 69.4936 279.02C69.2936 279.26 69.0536 279.473 68.7736 279.66C68.4936 279.833 68.1736 279.973 67.8136 280.08C67.4669 280.187 67.0669 280.24 66.6136 280.24ZM66.8736 278.82C67.3403 278.82 67.7603 278.727 68.1336 278.54C68.5203 278.34 68.8469 278.073 69.1136 277.74C69.3803 277.393 69.5803 277.013 69.7136 276.6C69.8603 276.187 69.9336 275.753 69.9336 275.3V275.24H67.4136C66.7603 275.24 66.2336 275.32 65.8336 275.48C65.4336 275.627 65.1469 275.84 64.9736 276.12C64.8003 276.387 64.7136 276.693 64.7136 277.04C64.7136 277.4 64.7936 277.713 64.9536 277.98C65.1269 278.247 65.3736 278.453 65.6936 278.6C66.0269 278.747 66.4203 278.82 66.8736 278.82ZM78.6525 280.24C77.6792 280.24 76.8258 280.013 76.0925 279.56C75.3592 279.093 74.7925 278.46 74.3925 277.66C73.9925 276.86 73.7925 275.953 73.7925 274.94C73.7925 273.927 73.9925 273.027 74.3925 272.24C74.7925 271.44 75.3592 270.813 76.0925 270.36C76.8392 269.907 77.6992 269.68 78.6725 269.68C79.4992 269.68 80.2192 269.847 80.8325 270.18C81.4592 270.513 81.9392 270.98 82.2725 271.58V265.6H83.9525V280H82.4325L82.2925 278.34C82.0792 278.673 81.8058 278.987 81.4725 279.28C81.1392 279.56 80.7392 279.793 80.2725 279.98C79.8058 280.153 79.2658 280.24 78.6525 280.24ZM78.8525 278.78C79.5192 278.78 80.1058 278.62 80.6125 278.3C81.1192 277.98 81.5125 277.54 81.7925 276.98C82.0725 276.407 82.2125 275.733 82.2125 274.96C82.2125 274.2 82.0725 273.533 81.7925 272.96C81.5125 272.387 81.1192 271.94 80.6125 271.62C80.1058 271.3 79.5192 271.14 78.8525 271.14C78.1992 271.14 77.6192 271.3 77.1125 271.62C76.6058 271.94 76.2125 272.387 75.9325 272.96C75.6525 273.533 75.5125 274.2 75.5125 274.96C75.5125 275.733 75.6525 276.407 75.9325 276.98C76.2125 277.54 76.6058 277.98 77.1125 278.3C77.6192 278.62 78.1992 278.78 78.8525 278.78ZM95.3441 280.24C94.5307 280.24 93.8507 280.1 93.3041 279.82C92.7574 279.527 92.3507 279.147 92.0841 278.68C91.8174 278.2 91.6841 277.68 91.6841 277.12C91.6841 276.44 91.8574 275.867 92.2041 275.4C92.5641 274.92 93.0641 274.56 93.7041 274.32C94.3574 274.067 95.1241 273.94 96.0041 273.94H98.6641C98.6641 273.313 98.5641 272.793 98.3641 272.38C98.1774 271.953 97.8974 271.633 97.5241 271.42C97.1641 271.207 96.7107 271.1 96.1641 271.1C95.5241 271.1 94.9707 271.26 94.5041 271.58C94.0374 271.9 93.7507 272.373 93.6441 273H91.9241C92.0041 272.28 92.2441 271.68 92.6441 271.2C93.0574 270.707 93.5774 270.333 94.2041 270.08C94.8307 269.813 95.4841 269.68 96.1641 269.68C97.0974 269.68 97.8707 269.853 98.4841 270.2C99.1107 270.533 99.5774 271.007 99.8841 271.62C100.191 272.22 100.344 272.933 100.344 273.76V280H98.8441L98.7441 278.22C98.6107 278.5 98.4374 278.767 98.2241 279.02C98.0241 279.26 97.7841 279.473 97.5041 279.66C97.2241 279.833 96.9041 279.973 96.5441 280.08C96.1974 280.187 95.7974 280.24 95.3441 280.24ZM95.6041 278.82C96.0707 278.82 96.4907 278.727 96.8641 278.54C97.2507 278.34 97.5774 278.073 97.8441 277.74C98.1107 277.393 98.3107 277.013 98.4441 276.6C98.5907 276.187 98.6641 275.753 98.6641 275.3V275.24H96.1441C95.4907 275.24 94.9641 275.32 94.5641 275.48C94.1641 275.627 93.8774 275.84 93.7041 276.12C93.5307 276.387 93.4441 276.693 93.4441 277.04C93.4441 277.4 93.5241 277.713 93.6841 277.98C93.8574 278.247 94.1041 278.453 94.4241 278.6C94.7574 278.747 95.1507 278.82 95.6041 278.82ZM106.743 280.24C105.903 280.24 105.17 280.1 104.543 279.82C103.93 279.54 103.436 279.153 103.063 278.66C102.703 278.153 102.483 277.56 102.403 276.88H104.123C104.19 277.227 104.33 277.547 104.543 277.84C104.756 278.133 105.043 278.373 105.403 278.56C105.776 278.733 106.23 278.82 106.763 278.82C107.23 278.82 107.616 278.753 107.923 278.62C108.23 278.473 108.456 278.28 108.603 278.04C108.763 277.8 108.843 277.54 108.843 277.26C108.843 276.847 108.743 276.533 108.543 276.32C108.356 276.107 108.076 275.94 107.703 275.82C107.33 275.687 106.876 275.573 106.343 275.48C105.903 275.4 105.47 275.293 105.043 275.16C104.616 275.027 104.236 274.853 103.903 274.64C103.57 274.413 103.303 274.14 103.103 273.82C102.916 273.5 102.823 273.107 102.823 272.64C102.823 272.067 102.97 271.56 103.263 271.12C103.556 270.667 103.976 270.313 104.523 270.06C105.083 269.807 105.73 269.68 106.463 269.68C107.543 269.68 108.416 269.94 109.083 270.46C109.75 270.98 110.143 271.733 110.263 272.72H108.603C108.536 272.213 108.316 271.82 107.943 271.54C107.583 271.247 107.083 271.1 106.443 271.1C105.816 271.1 105.336 271.227 105.003 271.48C104.683 271.733 104.523 272.067 104.523 272.48C104.523 272.747 104.61 272.987 104.783 273.2C104.97 273.4 105.236 273.573 105.583 273.72C105.943 273.867 106.383 273.987 106.903 274.08C107.57 274.2 108.176 274.36 108.723 274.56C109.27 274.76 109.71 275.06 110.043 275.46C110.39 275.847 110.563 276.4 110.563 277.12C110.563 277.747 110.403 278.293 110.083 278.76C109.776 279.227 109.336 279.593 108.763 279.86C108.19 280.113 107.516 280.24 106.743 280.24ZM118.395 280V266H127.055V267.38H120.075V272.26H126.455V273.62H120.075V278.62H127.055V280H118.395ZM128.603 280L132.023 274.96L128.603 269.92H130.443L133.163 274.04L135.923 269.92H137.723L134.303 274.96L137.723 280H135.923L133.163 275.86L130.443 280H128.603ZM143.635 280.24C142.689 280.24 141.835 280.02 141.075 279.58C140.329 279.14 139.742 278.527 139.315 277.74C138.889 276.94 138.675 276.02 138.675 274.98C138.675 273.913 138.889 272.987 139.315 272.2C139.742 271.413 140.329 270.8 141.075 270.36C141.835 269.907 142.689 269.68 143.635 269.68C144.835 269.68 145.835 269.993 146.635 270.62C147.435 271.233 147.942 272.06 148.155 273.1H146.435C146.302 272.473 145.975 271.987 145.455 271.64C144.935 271.293 144.322 271.12 143.615 271.12C143.042 271.12 142.509 271.267 142.015 271.56C141.522 271.84 141.129 272.267 140.835 272.84C140.542 273.413 140.395 274.12 140.395 274.96C140.395 275.587 140.482 276.147 140.655 276.64C140.829 277.12 141.062 277.52 141.355 277.84C141.649 278.16 141.989 278.407 142.375 278.58C142.775 278.74 143.189 278.82 143.615 278.82C144.095 278.82 144.529 278.747 144.915 278.6C145.302 278.44 145.629 278.207 145.895 277.9C146.162 277.593 146.342 277.233 146.435 276.82H148.155C147.942 277.833 147.429 278.66 146.615 279.3C145.815 279.927 144.822 280.24 143.635 280.24ZM154.961 280.24C154.014 280.24 153.174 280.02 152.441 279.58C151.721 279.14 151.154 278.527 150.741 277.74C150.327 276.94 150.121 276.013 150.121 274.96C150.121 273.893 150.321 272.967 150.721 272.18C151.134 271.393 151.707 270.78 152.441 270.34C153.187 269.9 154.041 269.68 155.001 269.68C155.987 269.68 156.821 269.9 157.501 270.34C158.194 270.78 158.721 271.36 159.081 272.08C159.454 272.787 159.641 273.567 159.641 274.42C159.641 274.553 159.641 274.693 159.641 274.84C159.641 274.987 159.634 275.153 159.621 275.34H151.381V274.04H158.001C157.961 273.12 157.654 272.4 157.081 271.88C156.521 271.36 155.814 271.1 154.961 271.1C154.387 271.1 153.854 271.233 153.361 271.5C152.881 271.753 152.494 272.133 152.201 272.64C151.907 273.133 151.761 273.753 151.761 274.5V275.06C151.761 275.887 151.907 276.58 152.201 277.14C152.507 277.7 152.901 278.12 153.381 278.4C153.874 278.68 154.401 278.82 154.961 278.82C155.667 278.82 156.247 278.667 156.701 278.36C157.167 278.04 157.501 277.613 157.701 277.08H159.361C159.201 277.68 158.921 278.22 158.521 278.7C158.121 279.18 157.621 279.56 157.021 279.84C156.434 280.107 155.747 280.24 154.961 280.24ZM161.908 280V265.6H163.588V280H161.908Z",
    fill: "#111111",
    style: (_ref672 = {
      fill: "#111111"
    }, _defineProperty(_ref672, "fill", "color(display-p3 0.0667 0.0667 0.0667)"), _defineProperty(_ref672, "fillOpacity", 1), _ref672)
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 309,
    height: 299,
    rx: 19.5,
    stroke: "#C2E6D1",
    style: (_ref673 = {
      stroke: "#C2E6D1"
    }, _defineProperty(_ref673, "stroke", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref673, "strokeOpacity", 1), _ref673)
  }), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17113_221003",
    x: -35.2333,
    y: 57.7121,
    width: 396.875,
    height: 230.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.21873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.54682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17113_221003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17113_221003",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17113_221003",
    x: 195.76,
    y: 41.6303,
    width: 396.875,
    height: 230.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.21873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.54682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17113_221003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17113_221003",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_17113_221003",
    x: 20.1486,
    y: 82.9041,
    width: 187.729,
    height: 128.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.851638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.68401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17113_221003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17113_221003",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_17113_221003",
    x: 18.2843,
    y: 84.1102,
    width: 396.875,
    height: 230.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.21873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.54682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17113_221003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17113_221003",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_17113_221003",
    x: 162.246,
    y: 105.539,
    width: 160.108,
    height: 147.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.851638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.68401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17113_221003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17113_221003",
    result: "shape"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_17113_221003",
    x: 158.528,
    y: 105.257,
    width: 462.379,
    height: 268.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.58493
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46232
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17113_221003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17113_221003",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17113_221003",
    x1: -1.60027,
    y1: 86.1396,
    x2: -1.60027,
    y2: 76.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref674 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref674, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref674, "stopOpacity", 1), _ref674)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17113_221003",
    x1: 26.5609,
    y1: 86.1396,
    x2: 26.5609,
    y2: 76.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref675 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref675, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref675, "stopOpacity", 1), _ref675)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17113_221003",
    x1: 54.721,
    y1: 86.1396,
    x2: 54.721,
    y2: 76.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref676 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref676, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref676, "stopOpacity", 1), _ref676)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17113_221003",
    x1: 82.8822,
    y1: 86.1396,
    x2: 82.8822,
    y2: 76.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref677 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref677, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref677, "stopOpacity", 1), _ref677)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17113_221003",
    x1: 111.043,
    y1: 86.1396,
    x2: 111.043,
    y2: 76.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref678 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref678, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref678, "stopOpacity", 1), _ref678)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17113_221003",
    x1: 139.203,
    y1: 86.1396,
    x2: 139.203,
    y2: 76.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref679 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref679, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref679, "stopOpacity", 1), _ref679)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17113_221003",
    x1: 229.393,
    y1: 70.0578,
    x2: 229.393,
    y2: 60.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref680 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref680, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref680, "stopOpacity", 1), _ref680)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17113_221003",
    x1: 257.554,
    y1: 70.0578,
    x2: 257.554,
    y2: 60.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref681 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref681, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref681, "stopOpacity", 1), _ref681)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17113_221003",
    x1: 285.714,
    y1: 70.0578,
    x2: 285.714,
    y2: 60.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref682 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref682, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref682, "stopOpacity", 1), _ref682)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17113_221003",
    x1: 313.875,
    y1: 70.0578,
    x2: 313.875,
    y2: 60.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref683 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref683, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref683, "stopOpacity", 1), _ref683)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17113_221003",
    x1: 215.312,
    y1: 73.8441,
    x2: 206.992,
    y2: 73.8441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref684 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref684, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref684, "stopOpacity", 1), _ref684)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref685 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref685, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref685, "stopOpacity", 0.72), _ref685)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17113_221003",
    x1: 215.312,
    y1: 81.4167,
    x2: 206.992,
    y2: 81.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref686 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref686, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref686, "stopOpacity", 1), _ref686)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref687 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref687, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref687, "stopOpacity", 0.72), _ref687)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17113_221003",
    x1: 215.312,
    y1: 88.9893,
    x2: 206.992,
    y2: 88.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref688 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref688, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref688, "stopOpacity", 1), _ref688)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref689 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref689, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref689, "stopOpacity", 0.72), _ref689)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_17113_221003",
    x1: 215.312,
    y1: 96.5619,
    x2: 206.992,
    y2: 96.5619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref690 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref690, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref690, "stopOpacity", 1), _ref690)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref691 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref691, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref691, "stopOpacity", 0.72), _ref691)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_17113_221003",
    x1: 215.312,
    y1: 104.135,
    x2: 206.992,
    y2: 104.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref692 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref692, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref692, "stopOpacity", 1), _ref692)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref693 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref693, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref693, "stopOpacity", 0.72), _ref693)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17113_221003",
    x1: 215.312,
    y1: 111.707,
    x2: 206.992,
    y2: 111.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref694 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref694, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref694, "stopOpacity", 1), _ref694)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref695 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref695, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref695, "stopOpacity", 0.72), _ref695)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17113_221003",
    x1: 215.312,
    y1: 119.28,
    x2: 206.992,
    y2: 119.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref696 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref696, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref696, "stopOpacity", 1), _ref696)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref697 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref697, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref697, "stopOpacity", 0.72), _ref697)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_17113_221003",
    x1: 215.312,
    y1: 126.852,
    x2: 206.992,
    y2: 126.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref698 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref698, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref698, "stopOpacity", 1), _ref698)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref699 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref699, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref699, "stopOpacity", 0.72), _ref699)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17113_221003",
    x1: 215.312,
    y1: 134.425,
    x2: 206.992,
    y2: 134.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref700 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref700, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref700, "stopOpacity", 1), _ref700)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref701 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref701, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref701, "stopOpacity", 0.72), _ref701)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17113_221003",
    x1: 215.312,
    y1: 141.998,
    x2: 206.992,
    y2: 141.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref702 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref702, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref702, "stopOpacity", 1), _ref702)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref703 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref703, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref703, "stopOpacity", 0.72), _ref703)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_17113_221003",
    x1: 215.312,
    y1: 149.57,
    x2: 206.992,
    y2: 149.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref704 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref704, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref704, "stopOpacity", 1), _ref704)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref705 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref705, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref705, "stopOpacity", 0.72), _ref705)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_17113_221003",
    x1: 215.312,
    y1: 157.143,
    x2: 206.992,
    y2: 157.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref706 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref706, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref706, "stopOpacity", 1), _ref706)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref707 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref707, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref707, "stopOpacity", 0.72), _ref707)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_17113_221003",
    x1: 215.312,
    y1: 164.716,
    x2: 206.992,
    y2: 164.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref708 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref708, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref708, "stopOpacity", 1), _ref708)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref709 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref709, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref709, "stopOpacity", 0.72), _ref709)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_17113_221003",
    x1: 215.312,
    y1: 172.288,
    x2: 206.992,
    y2: 172.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref710 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref710, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref710, "stopOpacity", 1), _ref710)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref711 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref711, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref711, "stopOpacity", 0.72), _ref711)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_17113_221003",
    x1: 215.312,
    y1: 179.861,
    x2: 206.992,
    y2: 179.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref712 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref712, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref712, "stopOpacity", 1), _ref712)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref713 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref713, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref713, "stopOpacity", 0.72), _ref713)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_17113_221003",
    x1: 215.312,
    y1: 187.433,
    x2: 206.992,
    y2: 187.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref714 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref714, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref714, "stopOpacity", 1), _ref714)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref715 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref715, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref715, "stopOpacity", 0.72), _ref715)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_17113_221003",
    x1: 51.9173,
    y1: 112.538,
    x2: 51.9173,
    y2: 103.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref716 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref716, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref716, "stopOpacity", 1), _ref716)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_17113_221003",
    x1: 80.0784,
    y1: 112.538,
    x2: 80.0784,
    y2: 103.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref717 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref717, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref717, "stopOpacity", 1), _ref717)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_17113_221003",
    x1: 108.239,
    y1: 112.538,
    x2: 108.239,
    y2: 103.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref718 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref718, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref718, "stopOpacity", 1), _ref718)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_17113_221003",
    x1: 136.4,
    y1: 112.538,
    x2: 136.4,
    y2: 103.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref719 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref719, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref719, "stopOpacity", 1), _ref719)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_17113_221003",
    x1: 164.561,
    y1: 112.538,
    x2: 164.561,
    y2: 103.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref720 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref720, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref720, "stopOpacity", 1), _ref720)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_17113_221003",
    x1: 192.721,
    y1: 112.538,
    x2: 192.721,
    y2: 103.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref721 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref721, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref721, "stopOpacity", 1), _ref721)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_17113_221003",
    x1: 37.8368,
    y1: 116.324,
    x2: 29.5166,
    y2: 116.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref722 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref722, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref722, "stopOpacity", 1), _ref722)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref723 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref723, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref723, "stopOpacity", 0.72), _ref723)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_17113_221003",
    x1: 37.8368,
    y1: 123.897,
    x2: 29.5166,
    y2: 123.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref724 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref724, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref724, "stopOpacity", 1), _ref724)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref725 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref725, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref725, "stopOpacity", 0.72), _ref725)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_17113_221003",
    x1: 37.8368,
    y1: 131.469,
    x2: 29.5166,
    y2: 131.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref726 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref726, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref726, "stopOpacity", 1), _ref726)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref727 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref727, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref727, "stopOpacity", 0.72), _ref727)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_17113_221003",
    x1: 37.8368,
    y1: 139.042,
    x2: 29.5166,
    y2: 139.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref728 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref728, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref728, "stopOpacity", 1), _ref728)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref729 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref729, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref729, "stopOpacity", 0.72), _ref729)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_17113_221003",
    x1: 37.8368,
    y1: 146.614,
    x2: 29.5166,
    y2: 146.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref730 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref730, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref730, "stopOpacity", 1), _ref730)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref731 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref731, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref731, "stopOpacity", 0.72), _ref731)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_17113_221003",
    x1: 37.8368,
    y1: 154.187,
    x2: 29.5166,
    y2: 154.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref732 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref732, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref732, "stopOpacity", 1), _ref732)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref733 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref733, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref733, "stopOpacity", 0.72), _ref733)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_17113_221003",
    x1: 37.8368,
    y1: 161.76,
    x2: 29.5166,
    y2: 161.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref734 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref734, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref734, "stopOpacity", 1), _ref734)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref735 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref735, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref735, "stopOpacity", 0.72), _ref735)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_17113_221003",
    x1: 37.8368,
    y1: 169.332,
    x2: 29.5166,
    y2: 169.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref736 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref736, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref736, "stopOpacity", 1), _ref736)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref737 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref737, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref737, "stopOpacity", 0.72), _ref737)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_17113_221003",
    x1: 37.8368,
    y1: 176.905,
    x2: 29.5166,
    y2: 176.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref738 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref738, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref738, "stopOpacity", 1), _ref738)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref739 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref739, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref739, "stopOpacity", 0.72), _ref739)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_17113_221003",
    x1: 37.8368,
    y1: 184.478,
    x2: 29.5166,
    y2: 184.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref740 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref740, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref740, "stopOpacity", 1), _ref740)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref741 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref741, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref741, "stopOpacity", 0.72), _ref741)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_17113_221003",
    x1: 37.8368,
    y1: 192.05,
    x2: 29.5166,
    y2: 192.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref742 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref742, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref742, "stopOpacity", 1), _ref742)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref743 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref743, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref743, "stopOpacity", 0.72), _ref743)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_17113_221003",
    x1: 37.8368,
    y1: 199.623,
    x2: 29.5166,
    y2: 199.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref744 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref744, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref744, "stopOpacity", 1), _ref744)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref745 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref745, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref745, "stopOpacity", 0.72), _ref745)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_17113_221003",
    x1: 197.712,
    y1: 138.377,
    x2: 197.712,
    y2: 127.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref746 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref746, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref746, "stopOpacity", 1), _ref746)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_17113_221003",
    x1: 230.521,
    y1: 138.377,
    x2: 230.521,
    y2: 127.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref747 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref747, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref747, "stopOpacity", 1), _ref747)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_17113_221003",
    x1: 263.329,
    y1: 138.377,
    x2: 263.329,
    y2: 127.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref748 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref748, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref748, "stopOpacity", 1), _ref748)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_17113_221003",
    x1: 296.139,
    y1: 138.377,
    x2: 296.139,
    y2: 127.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref749 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref749, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref749, "stopOpacity", 1), _ref749)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_17113_221003",
    x1: 181.308,
    y1: 142.788,
    x2: 171.614,
    y2: 142.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref750 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref750, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref750, "stopOpacity", 1), _ref750)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref751 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref751, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref751, "stopOpacity", 0.72), _ref751)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_17113_221003",
    x1: 181.308,
    y1: 151.611,
    x2: 171.614,
    y2: 151.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref752 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref752, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref752, "stopOpacity", 1), _ref752)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref753 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref753, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref753, "stopOpacity", 0.72), _ref753)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_17113_221003",
    x1: 181.308,
    y1: 160.433,
    x2: 171.614,
    y2: 160.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref754 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref754, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref754, "stopOpacity", 1), _ref754)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref755 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref755, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref755, "stopOpacity", 0.72), _ref755)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_17113_221003",
    x1: 181.308,
    y1: 169.255,
    x2: 171.614,
    y2: 169.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref756 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref756, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref756, "stopOpacity", 1), _ref756)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref757 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref757, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref757, "stopOpacity", 0.72), _ref757)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_17113_221003",
    x1: 181.308,
    y1: 178.078,
    x2: 171.614,
    y2: 178.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref758 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref758, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref758, "stopOpacity", 1), _ref758)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref759 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref759, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref759, "stopOpacity", 0.72), _ref759)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_17113_221003",
    x1: 181.308,
    y1: 186.9,
    x2: 171.614,
    y2: 186.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref760 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref760, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref760, "stopOpacity", 1), _ref760)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref761 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref761, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref761, "stopOpacity", 0.72), _ref761)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_17113_221003",
    x1: 181.308,
    y1: 195.723,
    x2: 171.614,
    y2: 195.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref762 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref762, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref762, "stopOpacity", 1), _ref762)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref763 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref763, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref763, "stopOpacity", 0.72), _ref763)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_17113_221003",
    x1: 181.308,
    y1: 204.545,
    x2: 171.614,
    y2: 204.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref764 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref764, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref764, "stopOpacity", 1), _ref764)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref765 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref765, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref765, "stopOpacity", 0.72), _ref765)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_17113_221003",
    x1: 181.308,
    y1: 213.368,
    x2: 171.614,
    y2: 213.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref766 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref766, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref766, "stopOpacity", 1), _ref766)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref767 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref767, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref767, "stopOpacity", 0.72), _ref767)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_17113_221003",
    x1: 181.308,
    y1: 222.19,
    x2: 171.614,
    y2: 222.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref768 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref768, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref768, "stopOpacity", 1), _ref768)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref769 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref769, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref769, "stopOpacity", 0.72), _ref769)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_17113_221003",
    x1: 181.308,
    y1: 231.013,
    x2: 171.614,
    y2: 231.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref770 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref770, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref770, "stopOpacity", 1), _ref770)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref771 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref771, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref771, "stopOpacity", 0.72), _ref771)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_17113_221003",
    x1: 181.308,
    y1: 239.835,
    x2: 171.614,
    y2: 239.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref772 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref772, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref772, "stopOpacity", 1), _ref772)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref773 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref773, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref773, "stopOpacity", 0.72), _ref773)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_17113_221003",
    x1: 181.308,
    y1: 248.658,
    x2: 171.614,
    y2: 248.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0",
    style: (_ref774 = {
      stopColor: "#D0D0D0"
    }, _defineProperty(_ref774, "stopColor", "color(display-p3 0.8157 0.8157 0.8157)"), _defineProperty(_ref774, "stopOpacity", 1), _ref774)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#DDDDDD",
    stopOpacity: 0.72,
    style: (_ref775 = {
      stopColor: "#DDDDDD"
    }, _defineProperty(_ref775, "stopColor", "color(display-p3 0.8673 0.8673 0.8673)"), _defineProperty(_ref775, "stopOpacity", 0.72), _ref775)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 300,
    rx: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: 66.7257,
    width: 168.858,
    height: 170.32,
    rx: 5.86533,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24.001,
    y: 66.7257,
    width: 374.411,
    height: 208.006,
    rx: 2.21873,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_17113_221003"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.001 76.71H350.41V86.1396H-24.001V76.71Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 86.1395)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 93.7122)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 101.285)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 108.857)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 116.43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 124.003)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 131.575)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 139.148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 146.72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 154.293)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 161.866)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 169.438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 177.011)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 184.584)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 192.156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 199.729)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 207.301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 214.874)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 222.447)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-24.001 230.019)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.992,
    y: 50.6439,
    width: 169.589,
    height: 138.157,
    rx: 5.86533,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.992,
    y: 50.6439,
    width: 374.411,
    height: 208.006,
    rx: 2.21873,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_17113_221003"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.992 60.6282H581.403V70.0578H206.992V60.6282Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 70.0577)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 77.6304)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 85.203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 92.7756)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 100.348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 107.921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 115.494)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 123.066)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 130.639)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 138.211)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 145.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 153.357)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 160.929)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 168.502)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 176.074)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(206.992 183.647)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_17113_221003"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 99.9572C29.5166 96.1832 32.576 93.1238 36.35 93.1238H191.676C195.45 93.1238 198.51 96.1832 198.51 99.9572V196.345C198.51 200.119 195.45 203.178 191.676 203.178H36.35C32.576 203.178 29.5166 200.119 29.5166 196.345V99.9572Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.5166,
    y: 93.1238,
    width: 374.411,
    height: 208.006,
    rx: 2.21873,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_17113_221003"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5166 103.108H403.927V112.538H29.5166V103.108Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 112.538)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 120.11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 127.683)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 135.255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 142.828)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 150.401)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 157.973)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 165.546)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 173.119)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 180.691)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 188.264)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.411,
    height: 7.57262,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(29.5166 195.836)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.614,
    y: 115.759,
    width: 141.372,
    height: 128.597,
    rx: 6.8334,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.614,
    y: 115.759,
    width: 436.207,
    height: 242.337,
    rx: 2.58493,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_17113_221003"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.614 127.391H607.821V138.377H171.614V127.391Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 138.377)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 147.199)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 156.022)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 164.844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 173.667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 182.489)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 191.312)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 200.134)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 208.957)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 217.779)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 226.602)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 235.424)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_17113_221003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.207,
    height: 8.82248,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(171.614 244.247)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbExcelUpload);
export default __webpack_public_path__ + "static/media/tbExcelUpload.f6c149ac.svg";
export { ForwardRef as ReactComponent };